[
  {
    "zipcode": "1000",
    "localities": ["BRUXELLES"]
  },
  {
    "zipcode": "1005",
    "localities": ["Assemblée Réunie de la Commission Communautaire"]
  },
  {
    "zipcode": "1006",
    "localities": ["Raad van de Vlaamse Gemeenschapscommissie"]
  },
  {
    "zipcode": "1007",
    "localities": ["Assemblée de la Commission Communautaire Française"]
  },
  {
    "zipcode": "1008",
    "localities": ["Chambre des Représentants"]
  },
  {
    "zipcode": "1009",
    "localities": ["Senat de Belgique"]
  },
  {
    "zipcode": "1011",
    "localities": ["Vlaams parlement"]
  },
  {
    "zipcode": "1012",
    "localities": ["Parlement de la Communauté française"]
  },
  {
    "zipcode": "1020",
    "localities": ["Laeken"]
  },
  {
    "zipcode": "1030",
    "localities": ["SCHAERBEEK"]
  },
  {
    "zipcode": "1031",
    "localities": ["Organisations Sociales Chrétiennes"]
  },
  {
    "zipcode": "1033",
    "localities": ["RTL-TVI"]
  },
  {
    "zipcode": "1035",
    "localities": ["Ministère de la Région de Bruxelles Capitale"]
  },
  {
    "zipcode": "1040",
    "localities": ["ETTERBEEK"]
  },
  {
    "zipcode": "1041",
    "localities": ["International Press Center"]
  },
  {
    "zipcode": "1043",
    "localities": ["VRT"]
  },
  {
    "zipcode": "1044",
    "localities": ["RTBF"]
  },
  {
    "zipcode": "1046",
    "localities": ["European External Action Service"]
  },
  {
    "zipcode": "1047",
    "localities": ["Parlement Européen"]
  },
  {
    "zipcode": "1048",
    "localities": ["Union Européenne - Conseil"]
  },
  {
    "zipcode": "1049",
    "localities": ["Union Européenne - Commission"]
  },
  {
    "zipcode": "1050",
    "localities": ["IXELLES"]
  },
  {
    "zipcode": "1060",
    "localities": ["SAINT-GILLES"]
  },
  {
    "zipcode": "1070",
    "localities": ["ANDERLECHT"]
  },
  {
    "zipcode": "1080",
    "localities": ["MOLENBEEK-SAINT-JEAN"]
  },
  {
    "zipcode": "1081",
    "localities": ["KOEKELBERG"]
  },
  {
    "zipcode": "1082",
    "localities": ["BERCHEM-SAINTE-AGATHE"]
  },
  {
    "zipcode": "1083",
    "localities": ["GANSHOREN"]
  },
  {
    "zipcode": "1090",
    "localities": ["JETTE"]
  },
  {
    "zipcode": "1099",
    "localities": ["Bruxelles X"]
  },
  {
    "zipcode": "1100",
    "localities": ["Postcheque"]
  },
  {
    "zipcode": "1101",
    "localities": ["Scanning"]
  },
  {
    "zipcode": "1105",
    "localities": ["ACTISOC"]
  },
  {
    "zipcode": "1110",
    "localities": ["OTAN"]
  },
  {
    "zipcode": "1120",
    "localities": ["Neder-Over-Heembeek"]
  },
  {
    "zipcode": "1130",
    "localities": ["Haren"]
  },
  {
    "zipcode": "1140",
    "localities": ["EVERE"]
  },
  {
    "zipcode": "1150",
    "localities": ["WOLUWE-SAINT-PIERRE"]
  },
  {
    "zipcode": "1160",
    "localities": ["AUDERGHEM"]
  },
  {
    "zipcode": "1170",
    "localities": ["WATERMAEL-BOITSFORT"]
  },
  {
    "zipcode": "1180",
    "localities": ["UCCLE"]
  },
  {
    "zipcode": "1190",
    "localities": ["FOREST"]
  },
  {
    "zipcode": "1200",
    "localities": ["WOLUWE-SAINT-LAMBERT"]
  },
  {
    "zipcode": "1210",
    "localities": ["SAINT-JOSSE-TEN-NOODE"]
  },
  {
    "zipcode": "1212",
    "localities": ["SPF Mobilité"]
  },
  {
    "zipcode": "1300",
    "localities": ["Limal"]
  },
  {
    "zipcode": "1300",
    "localities": ["WAVRE"]
  },
  {
    "zipcode": "1301",
    "localities": ["Bierges"]
  },
  {
    "zipcode": "1310",
    "localities": ["LA HULPE"]
  },
  {
    "zipcode": "1315",
    "localities": ["Roux-Miroir"]
  },
  {
    "zipcode": "1315",
    "localities": ["INCOURT"]
  },
  {
    "zipcode": "1315",
    "localities": ["Piétrebais"]
  },
  {
    "zipcode": "1315",
    "localities": ["Opprebais"]
  },
  {
    "zipcode": "1315",
    "localities": ["Glimes"]
  },
  {
    "zipcode": "1320",
    "localities": ["Hamme-Mille"]
  },
  {
    "zipcode": "1320",
    "localities": ["Nodebais"]
  },
  {
    "zipcode": "1320",
    "localities": ["BEAUVECHAIN"]
  },
  {
    "zipcode": "1320",
    "localities": ["L'Ecluse"]
  },
  {
    "zipcode": "1320",
    "localities": ["Tourinnes-La-Grosse"]
  },
  {
    "zipcode": "1325",
    "localities": ["CHAUMONT-GISTOUX"]
  },
  {
    "zipcode": "1325",
    "localities": ["Corroy-Le-Grand"]
  },
  {
    "zipcode": "1325",
    "localities": ["Dion-Valmont"]
  },
  {
    "zipcode": "1325",
    "localities": ["Bonlez"]
  },
  {
    "zipcode": "1325",
    "localities": ["Longueville"]
  },
  {
    "zipcode": "1330",
    "localities": ["RIXENSART"]
  },
  {
    "zipcode": "1331",
    "localities": ["Rosières"]
  },
  {
    "zipcode": "1332",
    "localities": ["Genval"]
  },
  {
    "zipcode": "1340",
    "localities": ["Ottignies"]
  },
  {
    "zipcode": "1340",
    "localities": ["OTTIGNIES-LOUVAIN-LA-NEUVE"]
  },
  {
    "zipcode": "1341",
    "localities": ["Céroux-Mousty"]
  },
  {
    "zipcode": "1342",
    "localities": ["Limelette"]
  },
  {
    "zipcode": "1348",
    "localities": ["Louvain-La-Neuve"]
  },
  {
    "zipcode": "1350",
    "localities": ["Enines"]
  },
  {
    "zipcode": "1350",
    "localities": ["Jandrain-Jandrenouille"]
  },
  {
    "zipcode": "1350",
    "localities": ["Jauche"]
  },
  {
    "zipcode": "1350",
    "localities": ["ORP-JAUCHE"]
  },
  {
    "zipcode": "1350",
    "localities": ["Marilles"]
  },
  {
    "zipcode": "1350",
    "localities": ["Folx-Les-Caves"]
  },
  {
    "zipcode": "1350",
    "localities": ["Noduwez"]
  },
  {
    "zipcode": "1350",
    "localities": ["Orp-Le-Grand"]
  },
  {
    "zipcode": "1357",
    "localities": ["Opheylissem"]
  },
  {
    "zipcode": "1357",
    "localities": ["Linsmeau"]
  },
  {
    "zipcode": "1357",
    "localities": ["Neerheylissem"]
  },
  {
    "zipcode": "1357",
    "localities": ["HÉLÉCINE"]
  },
  {
    "zipcode": "1360",
    "localities": ["Orbais"]
  },
  {
    "zipcode": "1360",
    "localities": ["PERWEZ"]
  },
  {
    "zipcode": "1360",
    "localities": ["Thorembais-Les-Béguines"]
  },
  {
    "zipcode": "1360",
    "localities": ["Thorembais-Saint-Trond"]
  },
  {
    "zipcode": "1360",
    "localities": ["Malèves-Sainte-Marie-Wastinnes"]
  },
  {
    "zipcode": "1367",
    "localities": ["Mont-Saint-André"]
  },
  {
    "zipcode": "1367",
    "localities": ["Gérompont"]
  },
  {
    "zipcode": "1367",
    "localities": ["Autre-Eglise"]
  },
  {
    "zipcode": "1367",
    "localities": ["Huppaye"]
  },
  {
    "zipcode": "1367",
    "localities": ["RAMILLIES"]
  },
  {
    "zipcode": "1367",
    "localities": ["Geest-Gérompont-Petit-Rosière"]
  },
  {
    "zipcode": "1367",
    "localities": ["Bomal"]
  },
  {
    "zipcode": "1367",
    "localities": ["Grand-Rosière-Hottomont"]
  },
  {
    "zipcode": "1370",
    "localities": ["Jodoigne-Souveraine"]
  },
  {
    "zipcode": "1370",
    "localities": ["Jauchelette"]
  },
  {
    "zipcode": "1370",
    "localities": ["Dongelberg"]
  },
  {
    "zipcode": "1370",
    "localities": ["Saint-Jean-Geest"]
  },
  {
    "zipcode": "1370",
    "localities": ["Saint-Remy-Geest"]
  },
  {
    "zipcode": "1370",
    "localities": ["Zétrud-Lumay"]
  },
  {
    "zipcode": "1370",
    "localities": ["Lathuy"]
  },
  {
    "zipcode": "1370",
    "localities": ["Mélin"]
  },
  {
    "zipcode": "1370",
    "localities": ["Piétrain"]
  },
  {
    "zipcode": "1370",
    "localities": ["JODOIGNE"]
  },
  {
    "zipcode": "1380",
    "localities": ["Lasne-Chapelle-Saint-Lambert"]
  },
  {
    "zipcode": "1380",
    "localities": ["LASNE"]
  },
  {
    "zipcode": "1380",
    "localities": ["Plancenoit"]
  },
  {
    "zipcode": "1380",
    "localities": ["Maransart"]
  },
  {
    "zipcode": "1380",
    "localities": ["Couture-Saint-Germain"]
  },
  {
    "zipcode": "1380",
    "localities": ["Ohain"]
  },
  {
    "zipcode": "1390",
    "localities": ["Bossut-Gottechain"]
  },
  {
    "zipcode": "1390",
    "localities": ["Archennes"]
  },
  {
    "zipcode": "1390",
    "localities": ["GREZ-DOICEAU"]
  },
  {
    "zipcode": "1390",
    "localities": ["Nethen"]
  },
  {
    "zipcode": "1390",
    "localities": ["Biez"]
  },
  {
    "zipcode": "1400",
    "localities": ["Monstreux"]
  },
  {
    "zipcode": "1400",
    "localities": ["NIVELLES"]
  },
  {
    "zipcode": "1401",
    "localities": ["Baulers"]
  },
  {
    "zipcode": "1402",
    "localities": ["Thines"]
  },
  {
    "zipcode": "1404",
    "localities": ["Bornival"]
  },
  {
    "zipcode": "1410",
    "localities": ["WATERLOO"]
  },
  {
    "zipcode": "1420",
    "localities": ["BRAINE-L'ALLEUD"]
  },
  {
    "zipcode": "1421",
    "localities": ["Ophain-Bois-Seigneur-Isaac"]
  },
  {
    "zipcode": "1428",
    "localities": ["Lillois-Witterzée"]
  },
  {
    "zipcode": "1430",
    "localities": ["Bierghes"]
  },
  {
    "zipcode": "1430",
    "localities": ["Rebecq-Rognon"]
  },
  {
    "zipcode": "1430",
    "localities": ["Quenast"]
  },
  {
    "zipcode": "1430",
    "localities": ["REBECQ"]
  },
  {
    "zipcode": "1435",
    "localities": ["Corbais"]
  },
  {
    "zipcode": "1435",
    "localities": ["Hévillers"]
  },
  {
    "zipcode": "1435",
    "localities": ["MONT-SAINT-GUIBERT"]
  },
  {
    "zipcode": "1440",
    "localities": ["BRAINE-LE-CHÂTEAU"]
  },
  {
    "zipcode": "1440",
    "localities": ["Wauthier-Braine"]
  },
  {
    "zipcode": "1450",
    "localities": ["CHASTRE"]
  },
  {
    "zipcode": "1450",
    "localities": ["Chastre-Villeroux-Blanmont"]
  },
  {
    "zipcode": "1450",
    "localities": ["Saint-Géry"]
  },
  {
    "zipcode": "1450",
    "localities": ["Cortil-Noirmont"]
  },
  {
    "zipcode": "1450",
    "localities": ["Gentinnes"]
  },
  {
    "zipcode": "1457",
    "localities": ["Tourinnes-Saint-Lambert"]
  },
  {
    "zipcode": "1457",
    "localities": ["Walhain-Saint-Paul"]
  },
  {
    "zipcode": "1457",
    "localities": ["Nil-Saint-Vincent-Saint-Martin"]
  },
  {
    "zipcode": "1457",
    "localities": ["WALHAIN"]
  },
  {
    "zipcode": "1460",
    "localities": ["ITTRE"]
  },
  {
    "zipcode": "1460",
    "localities": ["Virginal-Samme"]
  },
  {
    "zipcode": "1461",
    "localities": ["Haut-Ittre"]
  },
  {
    "zipcode": "1470",
    "localities": ["GENAPPE"]
  },
  {
    "zipcode": "1470",
    "localities": ["Bousval"]
  },
  {
    "zipcode": "1470",
    "localities": ["Baisy-Thy"]
  },
  {
    "zipcode": "1471",
    "localities": ["Loupoigne"]
  },
  {
    "zipcode": "1472",
    "localities": ["Vieux-Genappe"]
  },
  {
    "zipcode": "1473",
    "localities": ["Glabais"]
  },
  {
    "zipcode": "1474",
    "localities": ["Ways"]
  },
  {
    "zipcode": "1476",
    "localities": ["Houtain-Le-Val"]
  },
  {
    "zipcode": "1480",
    "localities": ["Oisquercq"]
  },
  {
    "zipcode": "1480",
    "localities": ["TUBIZE"]
  },
  {
    "zipcode": "1480",
    "localities": ["Saintes"]
  },
  {
    "zipcode": "1480",
    "localities": ["Clabecq"]
  },
  {
    "zipcode": "1490",
    "localities": ["COURT-SAINT-ETIENNE"]
  },
  {
    "zipcode": "1495",
    "localities": ["Tilly"]
  },
  {
    "zipcode": "1495",
    "localities": ["Marbais"]
  },
  {
    "zipcode": "1495",
    "localities": ["Mellery"]
  },
  {
    "zipcode": "1495",
    "localities": ["VILLERS-LA-VILLE"]
  },
  {
    "zipcode": "1495",
    "localities": ["Sart-Dames-Avelines"]
  },
  {
    "zipcode": "1500",
    "localities": ["HALLE"]
  },
  {
    "zipcode": "1501",
    "localities": ["Buizingen"]
  },
  {
    "zipcode": "1502",
    "localities": ["Lembeek"]
  },
  {
    "zipcode": "1540",
    "localities": ["Herfelingen"]
  },
  {
    "zipcode": "1540",
    "localities": ["HERNE"]
  },
  {
    "zipcode": "1541",
    "localities": ["Sint-Pieters-Kapelle"]
  },
  {
    "zipcode": "1547",
    "localities": ["BIÉVÈNE"]
  },
  {
    "zipcode": "1560",
    "localities": ["HOEILAART"]
  },
  {
    "zipcode": "1570",
    "localities": ["Tollembeek"]
  },
  {
    "zipcode": "1570",
    "localities": ["GALMAARDEN"]
  },
  {
    "zipcode": "1570",
    "localities": ["Vollezele"]
  },
  {
    "zipcode": "1600",
    "localities": ["Sint-Laureins-Berchem"]
  },
  {
    "zipcode": "1600",
    "localities": ["SINT-PIETERS-LEEUW"]
  },
  {
    "zipcode": "1600",
    "localities": ["Oudenaken"]
  },
  {
    "zipcode": "1601",
    "localities": ["Ruisbroek"]
  },
  {
    "zipcode": "1602",
    "localities": ["Vlezenbeek"]
  },
  {
    "zipcode": "1620",
    "localities": ["DROGENBOS"]
  },
  {
    "zipcode": "1630",
    "localities": ["LINKEBEEK"]
  },
  {
    "zipcode": "1640",
    "localities": ["RHODE-SAINT-GENÈSE"]
  },
  {
    "zipcode": "1650",
    "localities": ["BEERSEL"]
  },
  {
    "zipcode": "1651",
    "localities": ["Lot"]
  },
  {
    "zipcode": "1652",
    "localities": ["Alsemberg"]
  },
  {
    "zipcode": "1653",
    "localities": ["Dworp"]
  },
  {
    "zipcode": "1654",
    "localities": ["Huizingen"]
  },
  {
    "zipcode": "1670",
    "localities": ["Bogaarden"]
  },
  {
    "zipcode": "1670",
    "localities": ["PEPINGEN"]
  },
  {
    "zipcode": "1670",
    "localities": ["Heikruis"]
  },
  {
    "zipcode": "1671",
    "localities": ["Elingen"]
  },
  {
    "zipcode": "1673",
    "localities": ["Beert"]
  },
  {
    "zipcode": "1674",
    "localities": ["Bellingen"]
  },
  {
    "zipcode": "1700",
    "localities": ["Sint-Martens-Bodegem"]
  },
  {
    "zipcode": "1700",
    "localities": ["Sint-Ulriks-Kapelle"]
  },
  {
    "zipcode": "1700",
    "localities": ["DILBEEK"]
  },
  {
    "zipcode": "1701",
    "localities": ["Itterbeek"]
  },
  {
    "zipcode": "1702",
    "localities": ["Groot-Bijgaarden"]
  },
  {
    "zipcode": "1703",
    "localities": ["Schepdaal"]
  },
  {
    "zipcode": "1730",
    "localities": ["Kobbegem"]
  },
  {
    "zipcode": "1730",
    "localities": ["ASSE"]
  },
  {
    "zipcode": "1730",
    "localities": ["Bekkerzeel"]
  },
  {
    "zipcode": "1730",
    "localities": ["Mollem"]
  },
  {
    "zipcode": "1731",
    "localities": ["Relegem"]
  },
  {
    "zipcode": "1731",
    "localities": ["Zellik"]
  },
  {
    "zipcode": "1733",
    "localities": ["HighCo DATA"]
  },
  {
    "zipcode": "1740",
    "localities": ["TERNAT"]
  },
  {
    "zipcode": "1741",
    "localities": ["Wambeek"]
  },
  {
    "zipcode": "1742",
    "localities": ["Sint-Katherina-Lombeek"]
  },
  {
    "zipcode": "1745",
    "localities": ["Mazenzele"]
  },
  {
    "zipcode": "1745",
    "localities": ["OPWIJK"]
  },
  {
    "zipcode": "1750",
    "localities": ["Sint-Martens-Lennik"]
  },
  {
    "zipcode": "1750",
    "localities": ["Sint-Kwintens-Lennik"]
  },
  {
    "zipcode": "1750",
    "localities": ["Gaasbeek"]
  },
  {
    "zipcode": "1750",
    "localities": ["LENNIK"]
  },
  {
    "zipcode": "1755",
    "localities": ["Leerbeek"]
  },
  {
    "zipcode": "1755",
    "localities": ["GOOIK"]
  },
  {
    "zipcode": "1755",
    "localities": ["Oetingen"]
  },
  {
    "zipcode": "1755",
    "localities": ["Kester"]
  },
  {
    "zipcode": "1760",
    "localities": ["ROOSDAAL"]
  },
  {
    "zipcode": "1760",
    "localities": ["Strijtem"]
  },
  {
    "zipcode": "1760",
    "localities": ["Onze-Lieve-Vrouw-Lombeek"]
  },
  {
    "zipcode": "1760",
    "localities": ["Pamel"]
  },
  {
    "zipcode": "1761",
    "localities": ["Borchtlombeek"]
  },
  {
    "zipcode": "1770",
    "localities": ["LIEDEKERKE"]
  },
  {
    "zipcode": "1780",
    "localities": ["WEMMEL"]
  },
  {
    "zipcode": "1785",
    "localities": ["MERCHTEM"]
  },
  {
    "zipcode": "1785",
    "localities": ["Brussegem"]
  },
  {
    "zipcode": "1785",
    "localities": ["Hamme"]
  },
  {
    "zipcode": "1790",
    "localities": ["Hekelgem"]
  },
  {
    "zipcode": "1790",
    "localities": ["Teralfene"]
  },
  {
    "zipcode": "1790",
    "localities": ["Essene"]
  },
  {
    "zipcode": "1790",
    "localities": ["AFFLIGEM"]
  },
  {
    "zipcode": "1800",
    "localities": ["VILVOORDE"]
  },
  {
    "zipcode": "1800",
    "localities": ["Peutie"]
  },
  {
    "zipcode": "1804",
    "localities": ["Cargovil"]
  },
  {
    "zipcode": "1818",
    "localities": ["VTM"]
  },
  {
    "zipcode": "1820",
    "localities": ["Perk"]
  },
  {
    "zipcode": "1820",
    "localities": ["Melsbroek"]
  },
  {
    "zipcode": "1820",
    "localities": ["STEENOKKERZEEL"]
  },
  {
    "zipcode": "1830",
    "localities": ["MACHELEN"]
  },
  {
    "zipcode": "1831",
    "localities": ["Diegem"]
  },
  {
    "zipcode": "1840",
    "localities": ["Malderen"]
  },
  {
    "zipcode": "1840",
    "localities": ["LONDERZEEL"]
  },
  {
    "zipcode": "1840",
    "localities": ["Steenhuffel"]
  },
  {
    "zipcode": "1850",
    "localities": ["GRIMBERGEN"]
  },
  {
    "zipcode": "1851",
    "localities": ["Humbeek"]
  },
  {
    "zipcode": "1852",
    "localities": ["Beigem"]
  },
  {
    "zipcode": "1853",
    "localities": ["Strombeek-Bever"]
  },
  {
    "zipcode": "1860",
    "localities": ["MEISE"]
  },
  {
    "zipcode": "1861",
    "localities": ["Wolvertem"]
  },
  {
    "zipcode": "1880",
    "localities": ["KAPELLE-OP-DEN-BOS"]
  },
  {
    "zipcode": "1880",
    "localities": ["Nieuwenrode"]
  },
  {
    "zipcode": "1880",
    "localities": ["Ramsdonk"]
  },
  {
    "zipcode": "1910",
    "localities": ["KAMPENHOUT"]
  },
  {
    "zipcode": "1910",
    "localities": ["Berg"]
  },
  {
    "zipcode": "1910",
    "localities": ["Nederokkerzeel"]
  },
  {
    "zipcode": "1910",
    "localities": ["Buken"]
  },
  {
    "zipcode": "1930",
    "localities": ["Nossegem"]
  },
  {
    "zipcode": "1930",
    "localities": ["ZAVENTEM"]
  },
  {
    "zipcode": "1931",
    "localities": ["Brucargo"]
  },
  {
    "zipcode": "1932",
    "localities": ["Sint-Stevens-Woluwe"]
  },
  {
    "zipcode": "1933",
    "localities": ["Sterrebeek"]
  },
  {
    "zipcode": "1934",
    "localities": ["Office Exchange Brussels Airport Remailing"]
  },
  {
    "zipcode": "1935",
    "localities": ["Corporate Village"]
  },
  {
    "zipcode": "1950",
    "localities": ["KRAAINEM"]
  },
  {
    "zipcode": "1970",
    "localities": ["WEZEMBEEK-OPPEM"]
  },
  {
    "zipcode": "1980",
    "localities": ["Eppegem"]
  },
  {
    "zipcode": "1980",
    "localities": ["ZEMST"]
  },
  {
    "zipcode": "1981",
    "localities": ["Hofstade"]
  },
  {
    "zipcode": "1982",
    "localities": ["Weerde"]
  },
  {
    "zipcode": "1982",
    "localities": ["Elewijt"]
  },
  {
    "zipcode": "2000",
    "localities": ["ANTWERPEN"]
  },
  {
    "zipcode": "2018",
    "localities": ["ANTWERPEN"]
  },
  {
    "zipcode": "2020",
    "localities": ["ANTWERPEN"]
  },
  {
    "zipcode": "2030",
    "localities": ["ANTWERPEN"]
  },
  {
    "zipcode": "2040",
    "localities": ["Lillo"]
  },
  {
    "zipcode": "2040",
    "localities": ["Zandvliet"]
  },
  {
    "zipcode": "2040",
    "localities": ["Berendrecht"]
  },
  {
    "zipcode": "2040",
    "localities": ["ANTWERPEN"]
  },
  {
    "zipcode": "2050",
    "localities": ["ANTWERPEN"]
  },
  {
    "zipcode": "2060",
    "localities": ["ANTWERPEN"]
  },
  {
    "zipcode": "2070",
    "localities": ["ZWIJNDRECHT"]
  },
  {
    "zipcode": "2070",
    "localities": ["Burcht"]
  },
  {
    "zipcode": "2099",
    "localities": ["Antwerpen x"]
  },
  {
    "zipcode": "2100",
    "localities": ["Deurne"]
  },
  {
    "zipcode": "2110",
    "localities": ["WIJNEGEM"]
  },
  {
    "zipcode": "2140",
    "localities": ["Borgerhout"]
  },
  {
    "zipcode": "2150",
    "localities": ["BORSBEEK"]
  },
  {
    "zipcode": "2160",
    "localities": ["WOMMELGEM"]
  },
  {
    "zipcode": "2170",
    "localities": ["Merksem"]
  },
  {
    "zipcode": "2180",
    "localities": ["Ekeren"]
  },
  {
    "zipcode": "2200",
    "localities": ["Morkhoven"]
  },
  {
    "zipcode": "2200",
    "localities": ["HERENTALS"]
  },
  {
    "zipcode": "2200",
    "localities": ["Noorderwijk"]
  },
  {
    "zipcode": "2220",
    "localities": ["HEIST-OP-DEN-BERG"]
  },
  {
    "zipcode": "2220",
    "localities": ["Hallaar"]
  },
  {
    "zipcode": "2221",
    "localities": ["Booischot"]
  },
  {
    "zipcode": "2222",
    "localities": ["Itegem"]
  },
  {
    "zipcode": "2222",
    "localities": ["Wiekevorst"]
  },
  {
    "zipcode": "2223",
    "localities": ["Schriek"]
  },
  {
    "zipcode": "2230",
    "localities": ["Ramsel"]
  },
  {
    "zipcode": "2230",
    "localities": ["HERSELT"]
  },
  {
    "zipcode": "2235",
    "localities": ["Houtvenne"]
  },
  {
    "zipcode": "2235",
    "localities": ["HULSHOUT"]
  },
  {
    "zipcode": "2235",
    "localities": ["Westmeerbeek"]
  },
  {
    "zipcode": "2240",
    "localities": ["Viersel"]
  },
  {
    "zipcode": "2240",
    "localities": ["Massenhoven"]
  },
  {
    "zipcode": "2240",
    "localities": ["ZANDHOVEN"]
  },
  {
    "zipcode": "2242",
    "localities": ["Pulderbos"]
  },
  {
    "zipcode": "2243",
    "localities": ["Pulle"]
  },
  {
    "zipcode": "2250",
    "localities": ["OLEN"]
  },
  {
    "zipcode": "2260",
    "localities": ["Zoerle-Parwijs"]
  },
  {
    "zipcode": "2260",
    "localities": ["WESTERLO"]
  },
  {
    "zipcode": "2260",
    "localities": ["Oevel"]
  },
  {
    "zipcode": "2260",
    "localities": ["Tongerlo"]
  },
  {
    "zipcode": "2270",
    "localities": ["HERENTHOUT"]
  },
  {
    "zipcode": "2275",
    "localities": ["Wechelderzande"]
  },
  {
    "zipcode": "2275",
    "localities": ["Gierle"]
  },
  {
    "zipcode": "2275",
    "localities": ["Poederlee"]
  },
  {
    "zipcode": "2275",
    "localities": ["LILLE"]
  },
  {
    "zipcode": "2280",
    "localities": ["GROBBENDONK"]
  },
  {
    "zipcode": "2288",
    "localities": ["Bouwel"]
  },
  {
    "zipcode": "2290",
    "localities": ["VORSELAAR"]
  },
  {
    "zipcode": "2300",
    "localities": ["TURNHOUT"]
  },
  {
    "zipcode": "2310",
    "localities": ["RIJKEVORSEL"]
  },
  {
    "zipcode": "2320",
    "localities": ["HOOGSTRATEN"]
  },
  {
    "zipcode": "2321",
    "localities": ["Meer"]
  },
  {
    "zipcode": "2322",
    "localities": ["Minderhout"]
  },
  {
    "zipcode": "2323",
    "localities": ["Wortel"]
  },
  {
    "zipcode": "2328",
    "localities": ["Meerle"]
  },
  {
    "zipcode": "2330",
    "localities": ["MERKSPLAS"]
  },
  {
    "zipcode": "2340",
    "localities": ["BEERSE"]
  },
  {
    "zipcode": "2340",
    "localities": ["Vlimmeren"]
  },
  {
    "zipcode": "2350",
    "localities": ["VOSSELAAR"]
  },
  {
    "zipcode": "2360",
    "localities": ["OUD-TURNHOUT"]
  },
  {
    "zipcode": "2370",
    "localities": ["ARENDONK"]
  },
  {
    "zipcode": "2380",
    "localities": ["RAVELS"]
  },
  {
    "zipcode": "2381",
    "localities": ["Weelde"]
  },
  {
    "zipcode": "2382",
    "localities": ["Poppel"]
  },
  {
    "zipcode": "2387",
    "localities": ["BAARLE-HERTOG"]
  },
  {
    "zipcode": "2390",
    "localities": ["MALLE"]
  },
  {
    "zipcode": "2390",
    "localities": ["Westmalle"]
  },
  {
    "zipcode": "2390",
    "localities": ["Oostmalle"]
  },
  {
    "zipcode": "2400",
    "localities": ["MOL"]
  },
  {
    "zipcode": "2430",
    "localities": ["LAAKDAL"]
  },
  {
    "zipcode": "2430",
    "localities": ["Eindhout"]
  },
  {
    "zipcode": "2430",
    "localities": ["Vorst"]
  },
  {
    "zipcode": "2431",
    "localities": ["Veerle"]
  },
  {
    "zipcode": "2431",
    "localities": ["Varendonk"]
  },
  {
    "zipcode": "2440",
    "localities": ["GEEL"]
  },
  {
    "zipcode": "2450",
    "localities": ["MEERHOUT"]
  },
  {
    "zipcode": "2460",
    "localities": ["Lichtaart"]
  },
  {
    "zipcode": "2460",
    "localities": ["KASTERLEE"]
  },
  {
    "zipcode": "2460",
    "localities": ["Tielen"]
  },
  {
    "zipcode": "2470",
    "localities": ["RETIE"]
  },
  {
    "zipcode": "2480",
    "localities": ["DESSEL"]
  },
  {
    "zipcode": "2490",
    "localities": ["BALEN"]
  },
  {
    "zipcode": "2491",
    "localities": ["Olmen"]
  },
  {
    "zipcode": "2500",
    "localities": ["LIER"]
  },
  {
    "zipcode": "2500",
    "localities": ["Koningshooikt"]
  },
  {
    "zipcode": "2520",
    "localities": ["Broechem"]
  },
  {
    "zipcode": "2520",
    "localities": ["Oelegem"]
  },
  {
    "zipcode": "2520",
    "localities": ["Emblem"]
  },
  {
    "zipcode": "2520",
    "localities": ["RANST"]
  },
  {
    "zipcode": "2530",
    "localities": ["BOECHOUT"]
  },
  {
    "zipcode": "2531",
    "localities": ["Vremde"]
  },
  {
    "zipcode": "2540",
    "localities": ["HOVE"]
  },
  {
    "zipcode": "2547",
    "localities": ["LINT"]
  },
  {
    "zipcode": "2550",
    "localities": ["Waarloos"]
  },
  {
    "zipcode": "2550",
    "localities": ["KONTICH"]
  },
  {
    "zipcode": "2560",
    "localities": ["NIJLEN"]
  },
  {
    "zipcode": "2560",
    "localities": ["Kessel"]
  },
  {
    "zipcode": "2560",
    "localities": ["Bevel"]
  },
  {
    "zipcode": "2570",
    "localities": ["DUFFEL"]
  },
  {
    "zipcode": "2580",
    "localities": ["PUTTE"]
  },
  {
    "zipcode": "2580",
    "localities": ["Beerzel"]
  },
  {
    "zipcode": "2590",
    "localities": ["Gestel"]
  },
  {
    "zipcode": "2590",
    "localities": ["BERLAAR"]
  },
  {
    "zipcode": "2600",
    "localities": ["Berchem"]
  },
  {
    "zipcode": "2610",
    "localities": ["Wilrijk"]
  },
  {
    "zipcode": "2620",
    "localities": ["HEMIKSEM"]
  },
  {
    "zipcode": "2627",
    "localities": ["SCHELLE"]
  },
  {
    "zipcode": "2630",
    "localities": ["AARTSELAAR"]
  },
  {
    "zipcode": "2640",
    "localities": ["MORTSEL"]
  },
  {
    "zipcode": "2650",
    "localities": ["EDEGEM"]
  },
  {
    "zipcode": "2660",
    "localities": ["Hoboken"]
  },
  {
    "zipcode": "2800",
    "localities": ["MECHELEN"]
  },
  {
    "zipcode": "2800",
    "localities": ["Walem"]
  },
  {
    "zipcode": "2801",
    "localities": ["Heffen"]
  },
  {
    "zipcode": "2811",
    "localities": ["Leest"]
  },
  {
    "zipcode": "2811",
    "localities": ["Hombeek"]
  },
  {
    "zipcode": "2812",
    "localities": ["Muizen"]
  },
  {
    "zipcode": "2820",
    "localities": ["BONHEIDEN"]
  },
  {
    "zipcode": "2820",
    "localities": ["Rijmenam"]
  },
  {
    "zipcode": "2830",
    "localities": ["Blaasveld"]
  },
  {
    "zipcode": "2830",
    "localities": ["Tisselt"]
  },
  {
    "zipcode": "2830",
    "localities": ["WILLEBROEK"]
  },
  {
    "zipcode": "2830",
    "localities": ["Heindonk"]
  },
  {
    "zipcode": "2840",
    "localities": ["Reet"]
  },
  {
    "zipcode": "2840",
    "localities": ["RUMST"]
  },
  {
    "zipcode": "2840",
    "localities": ["Terhagen"]
  },
  {
    "zipcode": "2845",
    "localities": ["NIEL"]
  },
  {
    "zipcode": "2850",
    "localities": ["BOOM"]
  },
  {
    "zipcode": "2860",
    "localities": ["SINT-KATELIJNE-WAVER"]
  },
  {
    "zipcode": "2861",
    "localities": ["Onze-Lieve-Vrouw-Waver"]
  },
  {
    "zipcode": "2870",
    "localities": ["Ruisbroek"]
  },
  {
    "zipcode": "2870",
    "localities": ["Puurs"]
  },
  {
    "zipcode": "2870",
    "localities": ["Breendonk"]
  },
  {
    "zipcode": "2870",
    "localities": ["Liezele"]
  },
  {
    "zipcode": "2870",
    "localities": ["PUURS-SINT-AMANDS"]
  },
  {
    "zipcode": "2880",
    "localities": ["Mariekerke"]
  },
  {
    "zipcode": "2880",
    "localities": ["Weert"]
  },
  {
    "zipcode": "2880",
    "localities": ["BORNEM"]
  },
  {
    "zipcode": "2880",
    "localities": ["Hingene"]
  },
  {
    "zipcode": "2890",
    "localities": ["Oppuurs"]
  },
  {
    "zipcode": "2890",
    "localities": ["Sint-Amands"]
  },
  {
    "zipcode": "2890",
    "localities": ["Lippelo"]
  },
  {
    "zipcode": "2900",
    "localities": ["SCHOTEN"]
  },
  {
    "zipcode": "2910",
    "localities": ["ESSEN"]
  },
  {
    "zipcode": "2920",
    "localities": ["KALMTHOUT"]
  },
  {
    "zipcode": "2930",
    "localities": ["BRASSCHAAT"]
  },
  {
    "zipcode": "2940",
    "localities": ["STABROEK"]
  },
  {
    "zipcode": "2940",
    "localities": ["Hoevenen"]
  },
  {
    "zipcode": "2950",
    "localities": ["KAPELLEN"]
  },
  {
    "zipcode": "2960",
    "localities": ["Sint-Lenaarts"]
  },
  {
    "zipcode": "2960",
    "localities": ["Sint-Job-In-'T-Goor"]
  },
  {
    "zipcode": "2960",
    "localities": ["BRECHT"]
  },
  {
    "zipcode": "2970",
    "localities": ["SCHILDE"]
  },
  {
    "zipcode": "2970",
    "localities": ["'S Gravenwezel"]
  },
  {
    "zipcode": "2980",
    "localities": ["Halle"]
  },
  {
    "zipcode": "2980",
    "localities": ["ZOERSEL"]
  },
  {
    "zipcode": "2990",
    "localities": ["WUUSTWEZEL"]
  },
  {
    "zipcode": "2990",
    "localities": ["Loenhout"]
  },
  {
    "zipcode": "3000",
    "localities": ["LEUVEN"]
  },
  {
    "zipcode": "3001",
    "localities": ["Heverlee"]
  },
  {
    "zipcode": "3010",
    "localities": ["Kessel Lo"]
  },
  {
    "zipcode": "3012",
    "localities": ["Wilsele"]
  },
  {
    "zipcode": "3018",
    "localities": ["Wijgmaal"]
  },
  {
    "zipcode": "3020",
    "localities": ["Winksele"]
  },
  {
    "zipcode": "3020",
    "localities": ["HERENT"]
  },
  {
    "zipcode": "3020",
    "localities": ["Veltem-Beisem"]
  },
  {
    "zipcode": "3040",
    "localities": ["Neerijse"]
  },
  {
    "zipcode": "3040",
    "localities": ["Ottenburg"]
  },
  {
    "zipcode": "3040",
    "localities": ["HULDENBERG"]
  },
  {
    "zipcode": "3040",
    "localities": ["Loonbeek"]
  },
  {
    "zipcode": "3040",
    "localities": ["Sint-Agatha-Rode"]
  },
  {
    "zipcode": "3050",
    "localities": ["OUD-HEVERLEE"]
  },
  {
    "zipcode": "3051",
    "localities": ["Sint-Joris-Weert"]
  },
  {
    "zipcode": "3052",
    "localities": ["Blanden"]
  },
  {
    "zipcode": "3053",
    "localities": ["Haasrode"]
  },
  {
    "zipcode": "3054",
    "localities": ["Vaalbeek"]
  },
  {
    "zipcode": "3060",
    "localities": ["Korbeek-Dijle"]
  },
  {
    "zipcode": "3060",
    "localities": ["BERTEM"]
  },
  {
    "zipcode": "3061",
    "localities": ["Leefdaal"]
  },
  {
    "zipcode": "3070",
    "localities": ["KORTENBERG"]
  },
  {
    "zipcode": "3071",
    "localities": ["Erps-Kwerps"]
  },
  {
    "zipcode": "3078",
    "localities": ["Meerbeek"]
  },
  {
    "zipcode": "3078",
    "localities": ["Everberg"]
  },
  {
    "zipcode": "3080",
    "localities": ["Duisburg"]
  },
  {
    "zipcode": "3080",
    "localities": ["TERVUREN"]
  },
  {
    "zipcode": "3080",
    "localities": ["Vossem"]
  },
  {
    "zipcode": "3090",
    "localities": ["OVERIJSE"]
  },
  {
    "zipcode": "3110",
    "localities": ["ROTSELAAR"]
  },
  {
    "zipcode": "3111",
    "localities": ["Wezemaal"]
  },
  {
    "zipcode": "3118",
    "localities": ["Werchter"]
  },
  {
    "zipcode": "3120",
    "localities": ["TREMELO"]
  },
  {
    "zipcode": "3128",
    "localities": ["Baal"]
  },
  {
    "zipcode": "3130",
    "localities": ["BEGIJNENDIJK"]
  },
  {
    "zipcode": "3130",
    "localities": ["Betekom"]
  },
  {
    "zipcode": "3140",
    "localities": ["KEERBERGEN"]
  },
  {
    "zipcode": "3150",
    "localities": ["Tildonk"]
  },
  {
    "zipcode": "3150",
    "localities": ["HAACHT"]
  },
  {
    "zipcode": "3150",
    "localities": ["Wespelaar"]
  },
  {
    "zipcode": "3190",
    "localities": ["BOORTMEERBEEK"]
  },
  {
    "zipcode": "3191",
    "localities": ["Hever"]
  },
  {
    "zipcode": "3200",
    "localities": ["AARSCHOT"]
  },
  {
    "zipcode": "3200",
    "localities": ["Gelrode"]
  },
  {
    "zipcode": "3201",
    "localities": ["Langdorp"]
  },
  {
    "zipcode": "3202",
    "localities": ["Rillaar"]
  },
  {
    "zipcode": "3210",
    "localities": ["LUBBEEK"]
  },
  {
    "zipcode": "3210",
    "localities": ["Linden"]
  },
  {
    "zipcode": "3211",
    "localities": ["Binkom"]
  },
  {
    "zipcode": "3212",
    "localities": ["Pellenberg"]
  },
  {
    "zipcode": "3220",
    "localities": ["Sint-Pieters-Rode"]
  },
  {
    "zipcode": "3220",
    "localities": ["HOLSBEEK"]
  },
  {
    "zipcode": "3220",
    "localities": ["Kortrijk-Dutsel"]
  },
  {
    "zipcode": "3221",
    "localities": ["Nieuwrode"]
  },
  {
    "zipcode": "3270",
    "localities": ["SCHERPENHEUVEL-ZICHEM"]
  },
  {
    "zipcode": "3270",
    "localities": ["Scherpenheuvel"]
  },
  {
    "zipcode": "3271",
    "localities": ["Averbode"]
  },
  {
    "zipcode": "3271",
    "localities": ["Zichem"]
  },
  {
    "zipcode": "3272",
    "localities": ["Testelt"]
  },
  {
    "zipcode": "3272",
    "localities": ["Messelbroek"]
  },
  {
    "zipcode": "3290",
    "localities": ["Webbekom"]
  },
  {
    "zipcode": "3290",
    "localities": ["DIEST"]
  },
  {
    "zipcode": "3290",
    "localities": ["Schaffen"]
  },
  {
    "zipcode": "3290",
    "localities": ["Deurne"]
  },
  {
    "zipcode": "3293",
    "localities": ["Kaggevinne"]
  },
  {
    "zipcode": "3294",
    "localities": ["Molenstede"]
  },
  {
    "zipcode": "3300",
    "localities": ["Oorbeek"]
  },
  {
    "zipcode": "3300",
    "localities": ["Goetsenhoven"]
  },
  {
    "zipcode": "3300",
    "localities": ["Vissenaken"]
  },
  {
    "zipcode": "3300",
    "localities": ["Oplinter"]
  },
  {
    "zipcode": "3300",
    "localities": ["Kumtich"]
  },
  {
    "zipcode": "3300",
    "localities": ["Sint-Margriete-Houtem"]
  },
  {
    "zipcode": "3300",
    "localities": ["TIENEN"]
  },
  {
    "zipcode": "3300",
    "localities": ["Bost"]
  },
  {
    "zipcode": "3300",
    "localities": ["Hakendover"]
  },
  {
    "zipcode": "3320",
    "localities": ["Meldert"]
  },
  {
    "zipcode": "3320",
    "localities": ["HOEGAARDEN"]
  },
  {
    "zipcode": "3321",
    "localities": ["Outgaarden"]
  },
  {
    "zipcode": "3350",
    "localities": ["Neerhespen"]
  },
  {
    "zipcode": "3350",
    "localities": ["Neerlinter"]
  },
  {
    "zipcode": "3350",
    "localities": ["Wommersom"]
  },
  {
    "zipcode": "3350",
    "localities": ["LINTER"]
  },
  {
    "zipcode": "3350",
    "localities": ["Drieslinter"]
  },
  {
    "zipcode": "3350",
    "localities": ["Orsmaal-Gussenhoven"]
  },
  {
    "zipcode": "3350",
    "localities": ["Melkwezer"]
  },
  {
    "zipcode": "3350",
    "localities": ["Overhespen"]
  },
  {
    "zipcode": "3360",
    "localities": ["BIERBEEK"]
  },
  {
    "zipcode": "3360",
    "localities": ["Opvelp"]
  },
  {
    "zipcode": "3360",
    "localities": ["Korbeek-Lo"]
  },
  {
    "zipcode": "3360",
    "localities": ["Lovenjoel"]
  },
  {
    "zipcode": "3370",
    "localities": ["Neervelp"]
  },
  {
    "zipcode": "3370",
    "localities": ["BOUTERSEM"]
  },
  {
    "zipcode": "3370",
    "localities": ["Vertrijk"]
  },
  {
    "zipcode": "3370",
    "localities": ["Roosbeek"]
  },
  {
    "zipcode": "3370",
    "localities": ["Kerkom"]
  },
  {
    "zipcode": "3370",
    "localities": ["Willebringen"]
  },
  {
    "zipcode": "3380",
    "localities": ["GLABBEEK"]
  },
  {
    "zipcode": "3380",
    "localities": ["Bunsbeek"]
  },
  {
    "zipcode": "3381",
    "localities": ["Kapellen"]
  },
  {
    "zipcode": "3384",
    "localities": ["Attenrode"]
  },
  {
    "zipcode": "3390",
    "localities": ["Sint-Joris-Winge"]
  },
  {
    "zipcode": "3390",
    "localities": ["TIELT-WINGE"]
  },
  {
    "zipcode": "3390",
    "localities": ["Tielt"]
  },
  {
    "zipcode": "3390",
    "localities": ["Houwaart"]
  },
  {
    "zipcode": "3391",
    "localities": ["Meensel-Kiezegem"]
  },
  {
    "zipcode": "3400",
    "localities": ["Ezemaal"]
  },
  {
    "zipcode": "3400",
    "localities": ["LANDEN"]
  },
  {
    "zipcode": "3400",
    "localities": ["Overwinden"]
  },
  {
    "zipcode": "3400",
    "localities": ["Wange"]
  },
  {
    "zipcode": "3400",
    "localities": ["Neerwinden"]
  },
  {
    "zipcode": "3400",
    "localities": ["Rumsdorp"]
  },
  {
    "zipcode": "3400",
    "localities": ["Laar"]
  },
  {
    "zipcode": "3400",
    "localities": ["Eliksem"]
  },
  {
    "zipcode": "3401",
    "localities": ["Waasmont"]
  },
  {
    "zipcode": "3401",
    "localities": ["Wezeren"]
  },
  {
    "zipcode": "3401",
    "localities": ["Walshoutem"]
  },
  {
    "zipcode": "3401",
    "localities": ["Walsbets"]
  },
  {
    "zipcode": "3404",
    "localities": ["Attenhoven"]
  },
  {
    "zipcode": "3404",
    "localities": ["Neerlanden"]
  },
  {
    "zipcode": "3440",
    "localities": ["Dormaal"]
  },
  {
    "zipcode": "3440",
    "localities": ["Halle-Booienhoven"]
  },
  {
    "zipcode": "3440",
    "localities": ["Budingen"]
  },
  {
    "zipcode": "3440",
    "localities": ["ZOUTLEEUW"]
  },
  {
    "zipcode": "3440",
    "localities": ["Helen-Bos"]
  },
  {
    "zipcode": "3450",
    "localities": ["Grazen"]
  },
  {
    "zipcode": "3450",
    "localities": ["GEETBETS"]
  },
  {
    "zipcode": "3454",
    "localities": ["Rummen"]
  },
  {
    "zipcode": "3460",
    "localities": ["Assent"]
  },
  {
    "zipcode": "3460",
    "localities": ["BEKKEVOORT"]
  },
  {
    "zipcode": "3461",
    "localities": ["Molenbeek-Wersbeek"]
  },
  {
    "zipcode": "3470",
    "localities": ["Ransberg"]
  },
  {
    "zipcode": "3470",
    "localities": ["KORTENAKEN"]
  },
  {
    "zipcode": "3470",
    "localities": ["Sint-Margriete-Houtem"]
  },
  {
    "zipcode": "3471",
    "localities": ["Hoeleden"]
  },
  {
    "zipcode": "3472",
    "localities": ["Kersbeek-Miskom"]
  },
  {
    "zipcode": "3473",
    "localities": ["Waanrode"]
  },
  {
    "zipcode": "3500",
    "localities": ["HASSELT"]
  },
  {
    "zipcode": "3500",
    "localities": ["Sint-Lambrechts-Herk"]
  },
  {
    "zipcode": "3501",
    "localities": ["Wimmertingen"]
  },
  {
    "zipcode": "3510",
    "localities": ["Kermt"]
  },
  {
    "zipcode": "3510",
    "localities": ["Spalbeek"]
  },
  {
    "zipcode": "3511",
    "localities": ["Kuringen"]
  },
  {
    "zipcode": "3511",
    "localities": ["Stokrooie"]
  },
  {
    "zipcode": "3512",
    "localities": ["Stevoort"]
  },
  {
    "zipcode": "3520",
    "localities": ["ZONHOVEN"]
  },
  {
    "zipcode": "3530",
    "localities": ["Houthalen"]
  },
  {
    "zipcode": "3530",
    "localities": ["Helchteren"]
  },
  {
    "zipcode": "3530",
    "localities": ["HOUTHALEN-HELCHTEREN"]
  },
  {
    "zipcode": "3540",
    "localities": ["Donk"]
  },
  {
    "zipcode": "3540",
    "localities": ["Berbroek"]
  },
  {
    "zipcode": "3540",
    "localities": ["HERK-DE-STAD"]
  },
  {
    "zipcode": "3540",
    "localities": ["Schulen"]
  },
  {
    "zipcode": "3545",
    "localities": ["HALEN"]
  },
  {
    "zipcode": "3545",
    "localities": ["Zelem"]
  },
  {
    "zipcode": "3545",
    "localities": ["Loksbergen"]
  },
  {
    "zipcode": "3550",
    "localities": ["Heusden"]
  },
  {
    "zipcode": "3550",
    "localities": ["HEUSDEN-ZOLDER"]
  },
  {
    "zipcode": "3550",
    "localities": ["Zolder"]
  },
  {
    "zipcode": "3560",
    "localities": ["Linkhout"]
  },
  {
    "zipcode": "3560",
    "localities": ["LUMMEN"]
  },
  {
    "zipcode": "3560",
    "localities": ["Meldert"]
  },
  {
    "zipcode": "3570",
    "localities": ["ALKEN"]
  },
  {
    "zipcode": "3580",
    "localities": ["BERINGEN"]
  },
  {
    "zipcode": "3581",
    "localities": ["Beverlo"]
  },
  {
    "zipcode": "3582",
    "localities": ["Koersel"]
  },
  {
    "zipcode": "3583",
    "localities": ["Paal"]
  },
  {
    "zipcode": "3590",
    "localities": ["DIEPENBEEK"]
  },
  {
    "zipcode": "3600",
    "localities": ["GENK"]
  },
  {
    "zipcode": "3620",
    "localities": ["Neerharen"]
  },
  {
    "zipcode": "3620",
    "localities": ["Veldwezelt"]
  },
  {
    "zipcode": "3620",
    "localities": ["LANAKEN"]
  },
  {
    "zipcode": "3620",
    "localities": ["Gellik"]
  },
  {
    "zipcode": "3621",
    "localities": ["Rekem"]
  },
  {
    "zipcode": "3630",
    "localities": ["Mechelen-Aan-De-Maas"]
  },
  {
    "zipcode": "3630",
    "localities": ["Opgrimbie"]
  },
  {
    "zipcode": "3630",
    "localities": ["Vucht"]
  },
  {
    "zipcode": "3630",
    "localities": ["MAASMECHELEN"]
  },
  {
    "zipcode": "3630",
    "localities": ["Meeswijk"]
  },
  {
    "zipcode": "3630",
    "localities": ["Eisden"]
  },
  {
    "zipcode": "3630",
    "localities": ["Leut"]
  },
  {
    "zipcode": "3631",
    "localities": ["Uikhoven"]
  },
  {
    "zipcode": "3631",
    "localities": ["Boorsem"]
  },
  {
    "zipcode": "3640",
    "localities": ["Molenbeersel"]
  },
  {
    "zipcode": "3640",
    "localities": ["Ophoven"]
  },
  {
    "zipcode": "3640",
    "localities": ["KINROOI"]
  },
  {
    "zipcode": "3640",
    "localities": ["Kessenich"]
  },
  {
    "zipcode": "3650",
    "localities": ["Dilsen"]
  },
  {
    "zipcode": "3650",
    "localities": ["Rotem"]
  },
  {
    "zipcode": "3650",
    "localities": ["Lanklaar"]
  },
  {
    "zipcode": "3650",
    "localities": ["DILSEN-STOKKEM"]
  },
  {
    "zipcode": "3650",
    "localities": ["Elen"]
  },
  {
    "zipcode": "3650",
    "localities": ["Stokkem"]
  },
  {
    "zipcode": "3660",
    "localities": ["Opglabbeek"]
  },
  {
    "zipcode": "3665",
    "localities": ["AS"]
  },
  {
    "zipcode": "3668",
    "localities": ["Niel-Bij-As"]
  },
  {
    "zipcode": "3670",
    "localities": ["Gruitrode"]
  },
  {
    "zipcode": "3670",
    "localities": ["Neerglabbeek"]
  },
  {
    "zipcode": "3670",
    "localities": ["Wijshagen"]
  },
  {
    "zipcode": "3670",
    "localities": ["OUDSBERGEN"]
  },
  {
    "zipcode": "3670",
    "localities": ["Meeuwen"]
  },
  {
    "zipcode": "3670",
    "localities": ["Ellikom"]
  },
  {
    "zipcode": "3680",
    "localities": ["MAASEIK"]
  },
  {
    "zipcode": "3680",
    "localities": ["Neeroeteren"]
  },
  {
    "zipcode": "3680",
    "localities": ["Opoeteren"]
  },
  {
    "zipcode": "3690",
    "localities": ["ZUTENDAAL"]
  },
  {
    "zipcode": "3700",
    "localities": ["'S Herenelderen"]
  },
  {
    "zipcode": "3700",
    "localities": ["Haren"]
  },
  {
    "zipcode": "3700",
    "localities": ["Neerrepen"]
  },
  {
    "zipcode": "3700",
    "localities": ["Sluizen"]
  },
  {
    "zipcode": "3700",
    "localities": ["Koninksem"]
  },
  {
    "zipcode": "3700",
    "localities": ["Nerem"]
  },
  {
    "zipcode": "3700",
    "localities": ["TONGEREN"]
  },
  {
    "zipcode": "3700",
    "localities": ["Kolmont"]
  },
  {
    "zipcode": "3700",
    "localities": ["Widooie"]
  },
  {
    "zipcode": "3700",
    "localities": ["Mal"]
  },
  {
    "zipcode": "3700",
    "localities": ["Riksingen"]
  },
  {
    "zipcode": "3700",
    "localities": ["Berg"]
  },
  {
    "zipcode": "3700",
    "localities": ["Henis"]
  },
  {
    "zipcode": "3700",
    "localities": ["Overrepen"]
  },
  {
    "zipcode": "3700",
    "localities": ["Diets-Heur"]
  },
  {
    "zipcode": "3700",
    "localities": ["Lauw"]
  },
  {
    "zipcode": "3700",
    "localities": ["Vreren"]
  },
  {
    "zipcode": "3700",
    "localities": ["Piringen"]
  },
  {
    "zipcode": "3700",
    "localities": ["Rutten"]
  },
  {
    "zipcode": "3717",
    "localities": ["HERSTAPPE"]
  },
  {
    "zipcode": "3720",
    "localities": ["KORTESSEM"]
  },
  {
    "zipcode": "3721",
    "localities": ["Vliermaalroot"]
  },
  {
    "zipcode": "3722",
    "localities": ["Wintershoven"]
  },
  {
    "zipcode": "3723",
    "localities": ["Guigoven"]
  },
  {
    "zipcode": "3724",
    "localities": ["Vliermaal"]
  },
  {
    "zipcode": "3730",
    "localities": ["Sint-Huibrechts-Hern"]
  },
  {
    "zipcode": "3730",
    "localities": ["Werm"]
  },
  {
    "zipcode": "3730",
    "localities": ["HOESELT"]
  },
  {
    "zipcode": "3730",
    "localities": ["Romershoven"]
  },
  {
    "zipcode": "3732",
    "localities": ["Schalkhoven"]
  },
  {
    "zipcode": "3740",
    "localities": ["Eigenbilzen"]
  },
  {
    "zipcode": "3740",
    "localities": ["Mopertingen"]
  },
  {
    "zipcode": "3740",
    "localities": ["Kleine-Spouwen"]
  },
  {
    "zipcode": "3740",
    "localities": ["Hees"]
  },
  {
    "zipcode": "3740",
    "localities": ["Waltwilder"]
  },
  {
    "zipcode": "3740",
    "localities": ["Munsterbilzen"]
  },
  {
    "zipcode": "3740",
    "localities": ["Beverst"]
  },
  {
    "zipcode": "3740",
    "localities": ["BILZEN"]
  },
  {
    "zipcode": "3740",
    "localities": ["Grote-Spouwen"]
  },
  {
    "zipcode": "3740",
    "localities": ["Rijkhoven"]
  },
  {
    "zipcode": "3740",
    "localities": ["Rosmeer"]
  },
  {
    "zipcode": "3742",
    "localities": ["Martenslinde"]
  },
  {
    "zipcode": "3746",
    "localities": ["Hoelbeek"]
  },
  {
    "zipcode": "3770",
    "localities": ["RIEMST"]
  },
  {
    "zipcode": "3770",
    "localities": ["Vroenhoven"]
  },
  {
    "zipcode": "3770",
    "localities": ["Zichen-Zussen-Bolder"]
  },
  {
    "zipcode": "3770",
    "localities": ["Kanne"]
  },
  {
    "zipcode": "3770",
    "localities": ["Herderen"]
  },
  {
    "zipcode": "3770",
    "localities": ["Val-Meer"]
  },
  {
    "zipcode": "3770",
    "localities": ["Millen"]
  },
  {
    "zipcode": "3770",
    "localities": ["Membruggen"]
  },
  {
    "zipcode": "3770",
    "localities": ["Genoelselderen"]
  },
  {
    "zipcode": "3770",
    "localities": ["Vlijtingen"]
  },
  {
    "zipcode": "3790",
    "localities": ["Mouland"]
  },
  {
    "zipcode": "3790",
    "localities": ["Fouron-Saint-Martin"]
  },
  {
    "zipcode": "3790",
    "localities": ["FOURONS"]
  },
  {
    "zipcode": "3791",
    "localities": ["Remersdaal"]
  },
  {
    "zipcode": "3792",
    "localities": ["Fouron-Saint-Pierre"]
  },
  {
    "zipcode": "3793",
    "localities": ["Teuven"]
  },
  {
    "zipcode": "3798",
    "localities": ["Fouron-Le-Comte"]
  },
  {
    "zipcode": "3800",
    "localities": ["Gelinden"]
  },
  {
    "zipcode": "3800",
    "localities": ["Zepperen"]
  },
  {
    "zipcode": "3800",
    "localities": ["Brustem"]
  },
  {
    "zipcode": "3800",
    "localities": ["SINT-TRUIDEN"]
  },
  {
    "zipcode": "3800",
    "localities": ["Ordingen"]
  },
  {
    "zipcode": "3800",
    "localities": ["Groot-Gelmen"]
  },
  {
    "zipcode": "3800",
    "localities": ["Kerkom-Bij-Sint-Truiden"]
  },
  {
    "zipcode": "3800",
    "localities": ["Engelmanshoven"]
  },
  {
    "zipcode": "3800",
    "localities": ["Aalst"]
  },
  {
    "zipcode": "3800",
    "localities": ["Halmaal"]
  },
  {
    "zipcode": "3803",
    "localities": ["Runkelen"]
  },
  {
    "zipcode": "3803",
    "localities": ["Gorsem"]
  },
  {
    "zipcode": "3803",
    "localities": ["Duras"]
  },
  {
    "zipcode": "3803",
    "localities": ["Wilderen"]
  },
  {
    "zipcode": "3806",
    "localities": ["Velm"]
  },
  {
    "zipcode": "3830",
    "localities": ["WELLEN"]
  },
  {
    "zipcode": "3830",
    "localities": ["Berlingen"]
  },
  {
    "zipcode": "3831",
    "localities": ["Herten"]
  },
  {
    "zipcode": "3832",
    "localities": ["Ulbeek"]
  },
  {
    "zipcode": "3840",
    "localities": ["Rijkel"]
  },
  {
    "zipcode": "3840",
    "localities": ["Bommershoven"]
  },
  {
    "zipcode": "3840",
    "localities": ["Hendrieken"]
  },
  {
    "zipcode": "3840",
    "localities": ["Kerniel"]
  },
  {
    "zipcode": "3840",
    "localities": ["Voort"]
  },
  {
    "zipcode": "3840",
    "localities": ["Kolmont"]
  },
  {
    "zipcode": "3840",
    "localities": ["Gotem"]
  },
  {
    "zipcode": "3840",
    "localities": ["Gors-Opleeuw"]
  },
  {
    "zipcode": "3840",
    "localities": ["BORGLOON"]
  },
  {
    "zipcode": "3840",
    "localities": ["Hoepertingen"]
  },
  {
    "zipcode": "3840",
    "localities": ["Kuttekoven"]
  },
  {
    "zipcode": "3840",
    "localities": ["Broekom"]
  },
  {
    "zipcode": "3840",
    "localities": ["Haren"]
  },
  {
    "zipcode": "3840",
    "localities": ["Groot-Loon"]
  },
  {
    "zipcode": "3840",
    "localities": ["Jesseren"]
  },
  {
    "zipcode": "3850",
    "localities": ["Wijer"]
  },
  {
    "zipcode": "3850",
    "localities": ["NIEUWERKERKEN"]
  },
  {
    "zipcode": "3850",
    "localities": ["Kozen"]
  },
  {
    "zipcode": "3850",
    "localities": ["Binderveld"]
  },
  {
    "zipcode": "3870",
    "localities": ["Bovelingen"]
  },
  {
    "zipcode": "3870",
    "localities": ["Klein-Gelmen"]
  },
  {
    "zipcode": "3870",
    "localities": ["Horpmaal"]
  },
  {
    "zipcode": "3870",
    "localities": ["Mechelen-Bovelingen"]
  },
  {
    "zipcode": "3870",
    "localities": ["Opheers"]
  },
  {
    "zipcode": "3870",
    "localities": ["Batsheers"]
  },
  {
    "zipcode": "3870",
    "localities": ["HEERS"]
  },
  {
    "zipcode": "3870",
    "localities": ["Vechmaal"]
  },
  {
    "zipcode": "3870",
    "localities": ["Gutshoven"]
  },
  {
    "zipcode": "3870",
    "localities": ["Heks"]
  },
  {
    "zipcode": "3870",
    "localities": ["Mettekoven"]
  },
  {
    "zipcode": "3870",
    "localities": ["Rukkelingen-Loon"]
  },
  {
    "zipcode": "3870",
    "localities": ["Veulen"]
  },
  {
    "zipcode": "3890",
    "localities": ["GINGELOM"]
  },
  {
    "zipcode": "3890",
    "localities": ["Kortijs"]
  },
  {
    "zipcode": "3890",
    "localities": ["Niel-Bij-Sint-Truiden"]
  },
  {
    "zipcode": "3890",
    "localities": ["Jeuk"]
  },
  {
    "zipcode": "3890",
    "localities": ["Montenaken"]
  },
  {
    "zipcode": "3890",
    "localities": ["Vorsen"]
  },
  {
    "zipcode": "3890",
    "localities": ["Boekhout"]
  },
  {
    "zipcode": "3891",
    "localities": ["Borlo"]
  },
  {
    "zipcode": "3891",
    "localities": ["Muizen"]
  },
  {
    "zipcode": "3891",
    "localities": ["Buvingen"]
  },
  {
    "zipcode": "3891",
    "localities": ["Mielen-Boven-Aalst"]
  },
  {
    "zipcode": "3900",
    "localities": ["Overpelt"]
  },
  {
    "zipcode": "3900",
    "localities": ["PELT"]
  },
  {
    "zipcode": "3910",
    "localities": ["Neerpelt"]
  },
  {
    "zipcode": "3910",
    "localities": ["Sint-Huibrechts-Lille"]
  },
  {
    "zipcode": "3920",
    "localities": ["LOMMEL"]
  },
  {
    "zipcode": "3930",
    "localities": ["HAMONT-ACHEL"]
  },
  {
    "zipcode": "3930",
    "localities": ["Hamont"]
  },
  {
    "zipcode": "3930",
    "localities": ["Achel"]
  },
  {
    "zipcode": "3940",
    "localities": ["Hechtel"]
  },
  {
    "zipcode": "3940",
    "localities": ["HECHTEL-EKSEL"]
  },
  {
    "zipcode": "3941",
    "localities": ["Eksel"]
  },
  {
    "zipcode": "3945",
    "localities": ["HAM"]
  },
  {
    "zipcode": "3945",
    "localities": ["Kwaadmechelen"]
  },
  {
    "zipcode": "3945",
    "localities": ["Oostham"]
  },
  {
    "zipcode": "3950",
    "localities": ["BOCHOLT"]
  },
  {
    "zipcode": "3950",
    "localities": ["Kaulille"]
  },
  {
    "zipcode": "3950",
    "localities": ["Reppel"]
  },
  {
    "zipcode": "3960",
    "localities": ["Opitter"]
  },
  {
    "zipcode": "3960",
    "localities": ["Tongerlo"]
  },
  {
    "zipcode": "3960",
    "localities": ["BREE"]
  },
  {
    "zipcode": "3960",
    "localities": ["Gerdingen"]
  },
  {
    "zipcode": "3960",
    "localities": ["Beek"]
  },
  {
    "zipcode": "3970",
    "localities": ["LEOPOLDSBURG"]
  },
  {
    "zipcode": "3971",
    "localities": ["Heppen"]
  },
  {
    "zipcode": "3980",
    "localities": ["TESSENDERLO"]
  },
  {
    "zipcode": "3990",
    "localities": ["Grote-Brogel"]
  },
  {
    "zipcode": "3990",
    "localities": ["PEER"]
  },
  {
    "zipcode": "3990",
    "localities": ["Kleine-Brogel"]
  },
  {
    "zipcode": "3990",
    "localities": ["Wijchmaal"]
  },
  {
    "zipcode": "4000",
    "localities": ["Rocourt"]
  },
  {
    "zipcode": "4000",
    "localities": ["LIÈGE"]
  },
  {
    "zipcode": "4000",
    "localities": ["Glain"]
  },
  {
    "zipcode": "4020",
    "localities": ["Bressoux"]
  },
  {
    "zipcode": "4020",
    "localities": ["LIÈGE"]
  },
  {
    "zipcode": "4020",
    "localities": ["Wandre"]
  },
  {
    "zipcode": "4020",
    "localities": ["Jupille-Sur-Meuse"]
  },
  {
    "zipcode": "4030",
    "localities": ["Grivegnée"]
  },
  {
    "zipcode": "4031",
    "localities": ["Angleur"]
  },
  {
    "zipcode": "4032",
    "localities": ["Chênée"]
  },
  {
    "zipcode": "4040",
    "localities": ["HERSTAL"]
  },
  {
    "zipcode": "4041",
    "localities": ["Vottem"]
  },
  {
    "zipcode": "4041",
    "localities": ["Milmort"]
  },
  {
    "zipcode": "4042",
    "localities": ["Liers"]
  },
  {
    "zipcode": "4050",
    "localities": ["CHAUDFONTAINE"]
  },
  {
    "zipcode": "4051",
    "localities": ["Vaux-Sous-Chèvremont"]
  },
  {
    "zipcode": "4052",
    "localities": ["Beaufays"]
  },
  {
    "zipcode": "4053",
    "localities": ["Embourg"]
  },
  {
    "zipcode": "4099",
    "localities": ["Liège X"]
  },
  {
    "zipcode": "4100",
    "localities": ["SERAING"]
  },
  {
    "zipcode": "4100",
    "localities": ["Boncelles"]
  },
  {
    "zipcode": "4101",
    "localities": ["Jemeppe-Sur-Meuse"]
  },
  {
    "zipcode": "4102",
    "localities": ["Ougrée"]
  },
  {
    "zipcode": "4120",
    "localities": ["Ehein"]
  },
  {
    "zipcode": "4120",
    "localities": ["Rotheux-Rimière"]
  },
  {
    "zipcode": "4120",
    "localities": ["NEUPRÉ"]
  },
  {
    "zipcode": "4121",
    "localities": ["Neuville-En-Condroz"]
  },
  {
    "zipcode": "4122",
    "localities": ["Plainevaux"]
  },
  {
    "zipcode": "4130",
    "localities": ["Tilff"]
  },
  {
    "zipcode": "4130",
    "localities": ["ESNEUX"]
  },
  {
    "zipcode": "4140",
    "localities": ["Rouvreux"]
  },
  {
    "zipcode": "4140",
    "localities": ["Dolembreux"]
  },
  {
    "zipcode": "4140",
    "localities": ["Gomzé-Andoumont"]
  },
  {
    "zipcode": "4140",
    "localities": ["SPRIMONT"]
  },
  {
    "zipcode": "4141",
    "localities": ["Louveigné"]
  },
  {
    "zipcode": "4160",
    "localities": ["ANTHISNES"]
  },
  {
    "zipcode": "4161",
    "localities": ["Villers-Aux-Tours"]
  },
  {
    "zipcode": "4162",
    "localities": ["Hody"]
  },
  {
    "zipcode": "4163",
    "localities": ["Tavier"]
  },
  {
    "zipcode": "4170",
    "localities": ["COMBLAIN-AU-PONT"]
  },
  {
    "zipcode": "4171",
    "localities": ["Poulseur"]
  },
  {
    "zipcode": "4180",
    "localities": ["HAMOIR"]
  },
  {
    "zipcode": "4180",
    "localities": ["Comblain-Fairon"]
  },
  {
    "zipcode": "4180",
    "localities": ["Comblain-La-Tour"]
  },
  {
    "zipcode": "4181",
    "localities": ["Filot"]
  },
  {
    "zipcode": "4190",
    "localities": ["Xhoris"]
  },
  {
    "zipcode": "4190",
    "localities": ["My"]
  },
  {
    "zipcode": "4190",
    "localities": ["Werbomont"]
  },
  {
    "zipcode": "4190",
    "localities": ["Vieuxville"]
  },
  {
    "zipcode": "4190",
    "localities": ["FERRIÈRES"]
  },
  {
    "zipcode": "4210",
    "localities": ["Lamontzée"]
  },
  {
    "zipcode": "4210",
    "localities": ["BURDINNE"]
  },
  {
    "zipcode": "4210",
    "localities": ["Oteppe"]
  },
  {
    "zipcode": "4210",
    "localities": ["Hannêche"]
  },
  {
    "zipcode": "4210",
    "localities": ["Marneffe"]
  },
  {
    "zipcode": "4217",
    "localities": ["Lavoir"]
  },
  {
    "zipcode": "4217",
    "localities": ["HÉRON"]
  },
  {
    "zipcode": "4217",
    "localities": ["Waret-L'Evêque"]
  },
  {
    "zipcode": "4218",
    "localities": ["Couthuin"]
  },
  {
    "zipcode": "4219",
    "localities": ["Ambresin"]
  },
  {
    "zipcode": "4219",
    "localities": ["WASSEIGES"]
  },
  {
    "zipcode": "4219",
    "localities": ["Meeffe"]
  },
  {
    "zipcode": "4219",
    "localities": ["Acosse"]
  },
  {
    "zipcode": "4250",
    "localities": ["Lens-Saint-Servais"]
  },
  {
    "zipcode": "4250",
    "localities": ["Hollogne-Sur-Geer"]
  },
  {
    "zipcode": "4250",
    "localities": ["Boëlhe"]
  },
  {
    "zipcode": "4250",
    "localities": ["GEER"]
  },
  {
    "zipcode": "4252",
    "localities": ["Omal"]
  },
  {
    "zipcode": "4253",
    "localities": ["Darion"]
  },
  {
    "zipcode": "4254",
    "localities": ["Ligney"]
  },
  {
    "zipcode": "4257",
    "localities": ["Rosoux-Crenwick"]
  },
  {
    "zipcode": "4257",
    "localities": ["Corswarem"]
  },
  {
    "zipcode": "4257",
    "localities": ["BERLOZ"]
  },
  {
    "zipcode": "4260",
    "localities": ["Fumal"]
  },
  {
    "zipcode": "4260",
    "localities": ["Avennes"]
  },
  {
    "zipcode": "4260",
    "localities": ["BRAIVES"]
  },
  {
    "zipcode": "4260",
    "localities": ["Ville-En-Hesbaye"]
  },
  {
    "zipcode": "4260",
    "localities": ["Fallais"]
  },
  {
    "zipcode": "4260",
    "localities": ["Ciplet"]
  },
  {
    "zipcode": "4261",
    "localities": ["Latinne"]
  },
  {
    "zipcode": "4263",
    "localities": ["Tourinne"]
  },
  {
    "zipcode": "4280",
    "localities": ["Trognée"]
  },
  {
    "zipcode": "4280",
    "localities": ["Thisnes"]
  },
  {
    "zipcode": "4280",
    "localities": ["Merdorp"]
  },
  {
    "zipcode": "4280",
    "localities": ["Cras-Avernas"]
  },
  {
    "zipcode": "4280",
    "localities": ["Avernas-Le-Bauduin"]
  },
  {
    "zipcode": "4280",
    "localities": ["Avin"]
  },
  {
    "zipcode": "4280",
    "localities": ["Poucet"]
  },
  {
    "zipcode": "4280",
    "localities": ["Grand-Hallet"]
  },
  {
    "zipcode": "4280",
    "localities": ["Blehen"]
  },
  {
    "zipcode": "4280",
    "localities": ["Moxhe"]
  },
  {
    "zipcode": "4280",
    "localities": ["Lens-Saint-Remy"]
  },
  {
    "zipcode": "4280",
    "localities": ["Bertrée"]
  },
  {
    "zipcode": "4280",
    "localities": ["Wansin"]
  },
  {
    "zipcode": "4280",
    "localities": ["Crehen"]
  },
  {
    "zipcode": "4280",
    "localities": ["Petit-Hallet"]
  },
  {
    "zipcode": "4280",
    "localities": ["Abolens"]
  },
  {
    "zipcode": "4280",
    "localities": ["HANNUT"]
  },
  {
    "zipcode": "4280",
    "localities": ["Villers-Le-Peuplier"]
  },
  {
    "zipcode": "4287",
    "localities": ["Racour"]
  },
  {
    "zipcode": "4287",
    "localities": ["Pellaines"]
  },
  {
    "zipcode": "4287",
    "localities": ["LINCENT"]
  },
  {
    "zipcode": "4300",
    "localities": ["Grand-Axhe"]
  },
  {
    "zipcode": "4300",
    "localities": ["WAREMME"]
  },
  {
    "zipcode": "4300",
    "localities": ["Oleye"]
  },
  {
    "zipcode": "4300",
    "localities": ["Lantremange"]
  },
  {
    "zipcode": "4300",
    "localities": ["Bettincourt"]
  },
  {
    "zipcode": "4300",
    "localities": ["Bovenistier"]
  },
  {
    "zipcode": "4300",
    "localities": ["Bleret"]
  },
  {
    "zipcode": "4317",
    "localities": ["Viemme"]
  },
  {
    "zipcode": "4317",
    "localities": ["Borlez"]
  },
  {
    "zipcode": "4317",
    "localities": ["Les Waleffes"]
  },
  {
    "zipcode": "4317",
    "localities": ["FAIMES"]
  },
  {
    "zipcode": "4317",
    "localities": ["Aineffe"]
  },
  {
    "zipcode": "4317",
    "localities": ["Celles"]
  },
  {
    "zipcode": "4340",
    "localities": ["Villers-L'Evêque"]
  },
  {
    "zipcode": "4340",
    "localities": ["Othée"]
  },
  {
    "zipcode": "4340",
    "localities": ["Fooz"]
  },
  {
    "zipcode": "4340",
    "localities": ["AWANS"]
  },
  {
    "zipcode": "4342",
    "localities": ["Hognoul"]
  },
  {
    "zipcode": "4347",
    "localities": ["Voroux-Goreux"]
  },
  {
    "zipcode": "4347",
    "localities": ["FEXHE-LE-HAUT-CLOCHER"]
  },
  {
    "zipcode": "4347",
    "localities": ["Freloux"]
  },
  {
    "zipcode": "4347",
    "localities": ["Noville"]
  },
  {
    "zipcode": "4347",
    "localities": ["Roloux"]
  },
  {
    "zipcode": "4350",
    "localities": ["Lamine"]
  },
  {
    "zipcode": "4350",
    "localities": ["Pousset"]
  },
  {
    "zipcode": "4350",
    "localities": ["Momalle"]
  },
  {
    "zipcode": "4350",
    "localities": ["REMICOURT"]
  },
  {
    "zipcode": "4351",
    "localities": ["Hodeige"]
  },
  {
    "zipcode": "4357",
    "localities": ["Jeneffe"]
  },
  {
    "zipcode": "4357",
    "localities": ["Limont"]
  },
  {
    "zipcode": "4357",
    "localities": ["Haneffe"]
  },
  {
    "zipcode": "4357",
    "localities": ["DONCEEL"]
  },
  {
    "zipcode": "4360",
    "localities": ["Grandville"]
  },
  {
    "zipcode": "4360",
    "localities": ["Bergilers"]
  },
  {
    "zipcode": "4360",
    "localities": ["Lens-Sur-Geer"]
  },
  {
    "zipcode": "4360",
    "localities": ["Otrange"]
  },
  {
    "zipcode": "4360",
    "localities": ["OREYE"]
  },
  {
    "zipcode": "4367",
    "localities": ["Kemexhe"]
  },
  {
    "zipcode": "4367",
    "localities": ["Fize-Le-Marsal"]
  },
  {
    "zipcode": "4367",
    "localities": ["CRISNÉE"]
  },
  {
    "zipcode": "4367",
    "localities": ["Odeur"]
  },
  {
    "zipcode": "4367",
    "localities": ["Thys"]
  },
  {
    "zipcode": "4400",
    "localities": ["Chokier"]
  },
  {
    "zipcode": "4400",
    "localities": ["FLÉMALLE"]
  },
  {
    "zipcode": "4400",
    "localities": ["Gleixhe"]
  },
  {
    "zipcode": "4400",
    "localities": ["Flémalle-Grande"]
  },
  {
    "zipcode": "4400",
    "localities": ["Awirs"]
  },
  {
    "zipcode": "4400",
    "localities": ["Flémalle-Haute"]
  },
  {
    "zipcode": "4400",
    "localities": ["Ivoz-Ramet"]
  },
  {
    "zipcode": "4400",
    "localities": ["Mons-Lez-Liège"]
  },
  {
    "zipcode": "4420",
    "localities": ["Montegnée"]
  },
  {
    "zipcode": "4420",
    "localities": ["Tilleur"]
  },
  {
    "zipcode": "4420",
    "localities": ["SAINT-NICOLAS"]
  },
  {
    "zipcode": "4430",
    "localities": ["ANS"]
  },
  {
    "zipcode": "4431",
    "localities": ["Loncin"]
  },
  {
    "zipcode": "4432",
    "localities": ["Alleur"]
  },
  {
    "zipcode": "4432",
    "localities": ["Xhendremael"]
  },
  {
    "zipcode": "4450",
    "localities": ["Lantin"]
  },
  {
    "zipcode": "4450",
    "localities": ["Slins"]
  },
  {
    "zipcode": "4450",
    "localities": ["JUPRELLE"]
  },
  {
    "zipcode": "4451",
    "localities": ["Voroux-Lez-Liers"]
  },
  {
    "zipcode": "4452",
    "localities": ["Paifve"]
  },
  {
    "zipcode": "4452",
    "localities": ["Wihogne"]
  },
  {
    "zipcode": "4453",
    "localities": ["Villers-Saint-Siméon"]
  },
  {
    "zipcode": "4458",
    "localities": ["Fexhe-Slins"]
  },
  {
    "zipcode": "4460",
    "localities": ["Velroux"]
  },
  {
    "zipcode": "4460",
    "localities": ["Bierset"]
  },
  {
    "zipcode": "4460",
    "localities": ["GRÂCE-HOLLOGNE"]
  },
  {
    "zipcode": "4460",
    "localities": ["Grâce-Berleur"]
  },
  {
    "zipcode": "4460",
    "localities": ["Horion-Hozémont"]
  },
  {
    "zipcode": "4460",
    "localities": ["Hollogne-Aux-Pierres"]
  },
  {
    "zipcode": "4470",
    "localities": ["SAINT-GEORGES-SUR-MEUSE"]
  },
  {
    "zipcode": "4480",
    "localities": ["ENGIS"]
  },
  {
    "zipcode": "4480",
    "localities": ["Ehein"]
  },
  {
    "zipcode": "4480",
    "localities": ["Hermalle-Sous-Huy"]
  },
  {
    "zipcode": "4480",
    "localities": ["Clermont-Sous-Huy"]
  },
  {
    "zipcode": "4500",
    "localities": ["Ben-Ahin"]
  },
  {
    "zipcode": "4500",
    "localities": ["Tihange"]
  },
  {
    "zipcode": "4500",
    "localities": ["HUY"]
  },
  {
    "zipcode": "4520",
    "localities": ["Huccorgne"]
  },
  {
    "zipcode": "4520",
    "localities": ["Antheit"]
  },
  {
    "zipcode": "4520",
    "localities": ["WANZE"]
  },
  {
    "zipcode": "4520",
    "localities": ["Vinalmont"]
  },
  {
    "zipcode": "4520",
    "localities": ["Moha"]
  },
  {
    "zipcode": "4520",
    "localities": ["Bas-Oha"]
  },
  {
    "zipcode": "4530",
    "localities": ["Vaux-Et-Borset"]
  },
  {
    "zipcode": "4530",
    "localities": ["VILLERS-LE-BOUILLET"]
  },
  {
    "zipcode": "4530",
    "localities": ["Fize-Fontaine"]
  },
  {
    "zipcode": "4530",
    "localities": ["Warnant-Dreye"]
  },
  {
    "zipcode": "4530",
    "localities": ["Vieux-Waleffe"]
  },
  {
    "zipcode": "4537",
    "localities": ["Seraing-Le-Château"]
  },
  {
    "zipcode": "4537",
    "localities": ["Chapon-Seraing"]
  },
  {
    "zipcode": "4537",
    "localities": ["Bodegnée"]
  },
  {
    "zipcode": "4537",
    "localities": ["VERLAINE"]
  },
  {
    "zipcode": "4540",
    "localities": ["AMAY"]
  },
  {
    "zipcode": "4540",
    "localities": ["Flône"]
  },
  {
    "zipcode": "4540",
    "localities": ["Ampsin"]
  },
  {
    "zipcode": "4540",
    "localities": ["Jehay"]
  },
  {
    "zipcode": "4540",
    "localities": ["Ombret"]
  },
  {
    "zipcode": "4550",
    "localities": ["NANDRIN"]
  },
  {
    "zipcode": "4550",
    "localities": ["Saint-Séverin"]
  },
  {
    "zipcode": "4550",
    "localities": ["Yernée-Fraineux"]
  },
  {
    "zipcode": "4550",
    "localities": ["Villers-Le-Temple"]
  },
  {
    "zipcode": "4557",
    "localities": ["Fraiture"]
  },
  {
    "zipcode": "4557",
    "localities": ["Seny"]
  },
  {
    "zipcode": "4557",
    "localities": ["Soheit-Tinlot"]
  },
  {
    "zipcode": "4557",
    "localities": ["TINLOT"]
  },
  {
    "zipcode": "4557",
    "localities": ["Ramelot"]
  },
  {
    "zipcode": "4557",
    "localities": ["Abée"]
  },
  {
    "zipcode": "4560",
    "localities": ["Pailhe"]
  },
  {
    "zipcode": "4560",
    "localities": ["Bois-Et-Borsu"]
  },
  {
    "zipcode": "4560",
    "localities": ["CLAVIER"]
  },
  {
    "zipcode": "4560",
    "localities": ["Les Avins"]
  },
  {
    "zipcode": "4560",
    "localities": ["Ocquier"]
  },
  {
    "zipcode": "4560",
    "localities": ["Terwagne"]
  },
  {
    "zipcode": "4570",
    "localities": ["MARCHIN"]
  },
  {
    "zipcode": "4570",
    "localities": ["Vyle-Et-Tharoul"]
  },
  {
    "zipcode": "4577",
    "localities": ["Vierset-Barse"]
  },
  {
    "zipcode": "4577",
    "localities": ["MODAVE"]
  },
  {
    "zipcode": "4577",
    "localities": ["Outrelouxhe"]
  },
  {
    "zipcode": "4577",
    "localities": ["Strée-Lez-Huy"]
  },
  {
    "zipcode": "4590",
    "localities": ["Warzée"]
  },
  {
    "zipcode": "4590",
    "localities": ["OUFFET"]
  },
  {
    "zipcode": "4590",
    "localities": ["Ellemelle"]
  },
  {
    "zipcode": "4600",
    "localities": ["Lanaye"]
  },
  {
    "zipcode": "4600",
    "localities": ["Richelle"]
  },
  {
    "zipcode": "4600",
    "localities": ["VISÉ"]
  },
  {
    "zipcode": "4600",
    "localities": ["Lixhe"]
  },
  {
    "zipcode": "4601",
    "localities": ["Argenteau"]
  },
  {
    "zipcode": "4602",
    "localities": ["Cheratte"]
  },
  {
    "zipcode": "4606",
    "localities": ["Saint-André"]
  },
  {
    "zipcode": "4607",
    "localities": ["Bombaye"]
  },
  {
    "zipcode": "4607",
    "localities": ["Feneur"]
  },
  {
    "zipcode": "4607",
    "localities": ["Berneau"]
  },
  {
    "zipcode": "4607",
    "localities": ["DALHEM"]
  },
  {
    "zipcode": "4607",
    "localities": ["Mortroux"]
  },
  {
    "zipcode": "4608",
    "localities": ["Warsage"]
  },
  {
    "zipcode": "4608",
    "localities": ["Neufchâteau"]
  },
  {
    "zipcode": "4610",
    "localities": ["BEYNE-HEUSAY"]
  },
  {
    "zipcode": "4610",
    "localities": ["Queue-Du-Bois"]
  },
  {
    "zipcode": "4610",
    "localities": ["Bellaire"]
  },
  {
    "zipcode": "4620",
    "localities": ["FLÉRON"]
  },
  {
    "zipcode": "4621",
    "localities": ["Retinne"]
  },
  {
    "zipcode": "4623",
    "localities": ["Magnée"]
  },
  {
    "zipcode": "4624",
    "localities": ["Romsée"]
  },
  {
    "zipcode": "4630",
    "localities": ["Ayeneux"]
  },
  {
    "zipcode": "4630",
    "localities": ["Micheroux"]
  },
  {
    "zipcode": "4630",
    "localities": ["Tignée"]
  },
  {
    "zipcode": "4630",
    "localities": ["SOUMAGNE"]
  },
  {
    "zipcode": "4631",
    "localities": ["Evegnée"]
  },
  {
    "zipcode": "4632",
    "localities": ["Cérexhe-Heuseux"]
  },
  {
    "zipcode": "4633",
    "localities": ["Melen"]
  },
  {
    "zipcode": "4650",
    "localities": ["Grand-Rechain"]
  },
  {
    "zipcode": "4650",
    "localities": ["HERVE"]
  },
  {
    "zipcode": "4650",
    "localities": ["Julémont"]
  },
  {
    "zipcode": "4650",
    "localities": ["Chaineux"]
  },
  {
    "zipcode": "4651",
    "localities": ["Battice"]
  },
  {
    "zipcode": "4652",
    "localities": ["Xhendelesse"]
  },
  {
    "zipcode": "4653",
    "localities": ["Bolland"]
  },
  {
    "zipcode": "4654",
    "localities": ["Charneux"]
  },
  {
    "zipcode": "4670",
    "localities": ["Mortier"]
  },
  {
    "zipcode": "4670",
    "localities": ["Trembleur"]
  },
  {
    "zipcode": "4670",
    "localities": ["BLÉGNY"]
  },
  {
    "zipcode": "4671",
    "localities": ["Barchon"]
  },
  {
    "zipcode": "4671",
    "localities": ["Housse"]
  },
  {
    "zipcode": "4671",
    "localities": ["Saive"]
  },
  {
    "zipcode": "4672",
    "localities": ["Saint-Remy"]
  },
  {
    "zipcode": "4680",
    "localities": ["Hermée"]
  },
  {
    "zipcode": "4680",
    "localities": ["OUPEYE"]
  },
  {
    "zipcode": "4681",
    "localities": ["Hermalle-Sous-Argenteau"]
  },
  {
    "zipcode": "4682",
    "localities": ["Houtain-Saint-Siméon"]
  },
  {
    "zipcode": "4682",
    "localities": ["Heure-Le-Romain"]
  },
  {
    "zipcode": "4683",
    "localities": ["Vivegnis"]
  },
  {
    "zipcode": "4684",
    "localities": ["Haccourt"]
  },
  {
    "zipcode": "4690",
    "localities": ["Boirs"]
  },
  {
    "zipcode": "4690",
    "localities": ["Eben-Emael"]
  },
  {
    "zipcode": "4690",
    "localities": ["BASSENGE"]
  },
  {
    "zipcode": "4690",
    "localities": ["Wonck"]
  },
  {
    "zipcode": "4690",
    "localities": ["Roclenge-Sur-Geer"]
  },
  {
    "zipcode": "4690",
    "localities": ["Glons"]
  },
  {
    "zipcode": "4700",
    "localities": ["EUPEN"]
  },
  {
    "zipcode": "4701",
    "localities": ["Kettenis"]
  },
  {
    "zipcode": "4710",
    "localities": ["LONTZEN"]
  },
  {
    "zipcode": "4711",
    "localities": ["Walhorn"]
  },
  {
    "zipcode": "4720",
    "localities": ["LA CALAMINE"]
  },
  {
    "zipcode": "4721",
    "localities": ["Neu-Moresnet"]
  },
  {
    "zipcode": "4728",
    "localities": ["Hergenrath"]
  },
  {
    "zipcode": "4730",
    "localities": ["RAEREN"]
  },
  {
    "zipcode": "4730",
    "localities": ["Hauset"]
  },
  {
    "zipcode": "4731",
    "localities": ["Eynatten"]
  },
  {
    "zipcode": "4750",
    "localities": ["Elsenborn"]
  },
  {
    "zipcode": "4750",
    "localities": ["BUTGENBACH"]
  },
  {
    "zipcode": "4760",
    "localities": ["Manderfeld"]
  },
  {
    "zipcode": "4760",
    "localities": ["BULLANGE"]
  },
  {
    "zipcode": "4761",
    "localities": ["Rocherath"]
  },
  {
    "zipcode": "4770",
    "localities": ["Meyerode"]
  },
  {
    "zipcode": "4770",
    "localities": ["AMBLÈVE"]
  },
  {
    "zipcode": "4771",
    "localities": ["Heppenbach"]
  },
  {
    "zipcode": "4780",
    "localities": ["SAINT-VITH"]
  },
  {
    "zipcode": "4780",
    "localities": ["Recht"]
  },
  {
    "zipcode": "4782",
    "localities": ["Schoenberg"]
  },
  {
    "zipcode": "4783",
    "localities": ["Lommersweiler"]
  },
  {
    "zipcode": "4784",
    "localities": ["Crombach"]
  },
  {
    "zipcode": "4790",
    "localities": ["BURG-REULAND"]
  },
  {
    "zipcode": "4790",
    "localities": ["Reuland"]
  },
  {
    "zipcode": "4791",
    "localities": ["Thommen"]
  },
  {
    "zipcode": "4800",
    "localities": ["Ensival"]
  },
  {
    "zipcode": "4800",
    "localities": ["VERVIERS"]
  },
  {
    "zipcode": "4800",
    "localities": ["Polleur"]
  },
  {
    "zipcode": "4800",
    "localities": ["Lambermont"]
  },
  {
    "zipcode": "4800",
    "localities": ["Petit-Rechain"]
  },
  {
    "zipcode": "4801",
    "localities": ["Stembert"]
  },
  {
    "zipcode": "4802",
    "localities": ["Heusy"]
  },
  {
    "zipcode": "4820",
    "localities": ["DISON"]
  },
  {
    "zipcode": "4821",
    "localities": ["Andrimont"]
  },
  {
    "zipcode": "4830",
    "localities": ["LIMBOURG"]
  },
  {
    "zipcode": "4831",
    "localities": ["Bilstain"]
  },
  {
    "zipcode": "4834",
    "localities": ["Goé"]
  },
  {
    "zipcode": "4837",
    "localities": ["BAELEN"]
  },
  {
    "zipcode": "4837",
    "localities": ["Membach"]
  },
  {
    "zipcode": "4840",
    "localities": ["WELKENRAEDT"]
  },
  {
    "zipcode": "4841",
    "localities": ["Henri-Chapelle"]
  },
  {
    "zipcode": "4845",
    "localities": ["Sart-Lez-Spa"]
  },
  {
    "zipcode": "4845",
    "localities": ["JALHAY"]
  },
  {
    "zipcode": "4850",
    "localities": ["Montzen"]
  },
  {
    "zipcode": "4850",
    "localities": ["Moresnet"]
  },
  {
    "zipcode": "4850",
    "localities": ["PLOMBIÈRES"]
  },
  {
    "zipcode": "4851",
    "localities": ["Gemmenich"]
  },
  {
    "zipcode": "4851",
    "localities": ["Sippenaeken"]
  },
  {
    "zipcode": "4852",
    "localities": ["Hombourg"]
  },
  {
    "zipcode": "4860",
    "localities": ["Wegnez"]
  },
  {
    "zipcode": "4860",
    "localities": ["PEPINSTER"]
  },
  {
    "zipcode": "4860",
    "localities": ["Cornesse"]
  },
  {
    "zipcode": "4861",
    "localities": ["Soiron"]
  },
  {
    "zipcode": "4870",
    "localities": ["TROOZ"]
  },
  {
    "zipcode": "4870",
    "localities": ["Forêt"]
  },
  {
    "zipcode": "4870",
    "localities": ["Nessonvaux"]
  },
  {
    "zipcode": "4870",
    "localities": ["Fraipont"]
  },
  {
    "zipcode": "4877",
    "localities": ["OLNE"]
  },
  {
    "zipcode": "4880",
    "localities": ["AUBEL"]
  },
  {
    "zipcode": "4890",
    "localities": ["THIMISTER-CLERMONT"]
  },
  {
    "zipcode": "4890",
    "localities": ["Thimister"]
  },
  {
    "zipcode": "4890",
    "localities": ["Clermont"]
  },
  {
    "zipcode": "4900",
    "localities": ["SPA"]
  },
  {
    "zipcode": "4910",
    "localities": ["La Reid"]
  },
  {
    "zipcode": "4910",
    "localities": ["Polleur"]
  },
  {
    "zipcode": "4910",
    "localities": ["THEUX"]
  },
  {
    "zipcode": "4920",
    "localities": ["AYWAILLE"]
  },
  {
    "zipcode": "4920",
    "localities": ["Harzé"]
  },
  {
    "zipcode": "4920",
    "localities": ["Ernonheid"]
  },
  {
    "zipcode": "4920",
    "localities": ["Louveigné"]
  },
  {
    "zipcode": "4920",
    "localities": ["Sougné-Remouchamps"]
  },
  {
    "zipcode": "4950",
    "localities": ["Sourbrodt"]
  },
  {
    "zipcode": "4950",
    "localities": ["Robertville"]
  },
  {
    "zipcode": "4950",
    "localities": ["WAIMES"]
  },
  {
    "zipcode": "4950",
    "localities": ["Faymonville"]
  },
  {
    "zipcode": "4960",
    "localities": ["MALMEDY"]
  },
  {
    "zipcode": "4960",
    "localities": ["Bellevaux-Ligneuville"]
  },
  {
    "zipcode": "4960",
    "localities": ["Bevercé"]
  },
  {
    "zipcode": "4970",
    "localities": ["STAVELOT"]
  },
  {
    "zipcode": "4970",
    "localities": ["Francorchamps"]
  },
  {
    "zipcode": "4980",
    "localities": ["Wanne"]
  },
  {
    "zipcode": "4980",
    "localities": ["TROIS-PONTS"]
  },
  {
    "zipcode": "4980",
    "localities": ["Fosse"]
  },
  {
    "zipcode": "4983",
    "localities": ["Basse-Bodeux"]
  },
  {
    "zipcode": "4987",
    "localities": ["Chevron"]
  },
  {
    "zipcode": "4987",
    "localities": ["Rahier"]
  },
  {
    "zipcode": "4987",
    "localities": ["STOUMONT"]
  },
  {
    "zipcode": "4987",
    "localities": ["La Gleize"]
  },
  {
    "zipcode": "4987",
    "localities": ["Lorcé"]
  },
  {
    "zipcode": "4990",
    "localities": ["Arbrefontaine"]
  },
  {
    "zipcode": "4990",
    "localities": ["Bra"]
  },
  {
    "zipcode": "4990",
    "localities": ["LIERNEUX"]
  },
  {
    "zipcode": "5000",
    "localities": ["Beez"]
  },
  {
    "zipcode": "5000",
    "localities": ["NAMUR"]
  },
  {
    "zipcode": "5001",
    "localities": ["Belgrade"]
  },
  {
    "zipcode": "5002",
    "localities": ["Saint-Servais"]
  },
  {
    "zipcode": "5003",
    "localities": ["Saint-Marc"]
  },
  {
    "zipcode": "5004",
    "localities": ["Bouge"]
  },
  {
    "zipcode": "5010",
    "localities": ["SA SudPresse"]
  },
  {
    "zipcode": "5012",
    "localities": ["Parlement Wallon"]
  },
  {
    "zipcode": "5020",
    "localities": ["Malonne"]
  },
  {
    "zipcode": "5020",
    "localities": ["Vedrin"]
  },
  {
    "zipcode": "5020",
    "localities": ["Champion"]
  },
  {
    "zipcode": "5020",
    "localities": ["Suarlée"]
  },
  {
    "zipcode": "5020",
    "localities": ["Flawinne"]
  },
  {
    "zipcode": "5020",
    "localities": ["Temploux"]
  },
  {
    "zipcode": "5020",
    "localities": ["Daussoulx"]
  },
  {
    "zipcode": "5021",
    "localities": ["Boninne"]
  },
  {
    "zipcode": "5022",
    "localities": ["Cognelée"]
  },
  {
    "zipcode": "5024",
    "localities": ["Gelbressée"]
  },
  {
    "zipcode": "5024",
    "localities": ["Marche-Les-Dames"]
  },
  {
    "zipcode": "5030",
    "localities": ["Ernage"]
  },
  {
    "zipcode": "5030",
    "localities": ["Grand-Manil"]
  },
  {
    "zipcode": "5030",
    "localities": ["GEMBLOUX"]
  },
  {
    "zipcode": "5030",
    "localities": ["Lonzée"]
  },
  {
    "zipcode": "5030",
    "localities": ["Beuzet"]
  },
  {
    "zipcode": "5030",
    "localities": ["Sauvenière"]
  },
  {
    "zipcode": "5031",
    "localities": ["Grand-Leez"]
  },
  {
    "zipcode": "5032",
    "localities": ["Isnes"]
  },
  {
    "zipcode": "5032",
    "localities": ["Mazy"]
  },
  {
    "zipcode": "5032",
    "localities": ["Bothey"]
  },
  {
    "zipcode": "5032",
    "localities": ["Corroy-Le-Château"]
  },
  {
    "zipcode": "5032",
    "localities": ["Bossière"]
  },
  {
    "zipcode": "5060",
    "localities": ["Velaine-Sur-Sambre"]
  },
  {
    "zipcode": "5060",
    "localities": ["Tamines"]
  },
  {
    "zipcode": "5060",
    "localities": ["Moignelée"]
  },
  {
    "zipcode": "5060",
    "localities": ["Falisolle"]
  },
  {
    "zipcode": "5060",
    "localities": ["Keumiée"]
  },
  {
    "zipcode": "5060",
    "localities": ["Arsimont"]
  },
  {
    "zipcode": "5060",
    "localities": ["SAMBREVILLE"]
  },
  {
    "zipcode": "5060",
    "localities": ["Auvelais"]
  },
  {
    "zipcode": "5070",
    "localities": ["Sart-Saint-Laurent"]
  },
  {
    "zipcode": "5070",
    "localities": ["FOSSES-LA-VILLE"]
  },
  {
    "zipcode": "5070",
    "localities": ["Sart-Eustache"]
  },
  {
    "zipcode": "5070",
    "localities": ["Aisemont"]
  },
  {
    "zipcode": "5070",
    "localities": ["Le Roux"]
  },
  {
    "zipcode": "5070",
    "localities": ["Vitrival"]
  },
  {
    "zipcode": "5080",
    "localities": ["Emines"]
  },
  {
    "zipcode": "5080",
    "localities": ["LA BRUYÈRE"]
  },
  {
    "zipcode": "5080",
    "localities": ["Warisoulx"]
  },
  {
    "zipcode": "5080",
    "localities": ["Villers-Lez-Heest"]
  },
  {
    "zipcode": "5080",
    "localities": ["Rhisnes"]
  },
  {
    "zipcode": "5081",
    "localities": ["Meux"]
  },
  {
    "zipcode": "5081",
    "localities": ["Saint-Denis-Bovesse"]
  },
  {
    "zipcode": "5081",
    "localities": ["Bovesse"]
  },
  {
    "zipcode": "5100",
    "localities": ["Dave"]
  },
  {
    "zipcode": "5100",
    "localities": ["Wierde"]
  },
  {
    "zipcode": "5100",
    "localities": ["Jambes"]
  },
  {
    "zipcode": "5100",
    "localities": ["Wépion"]
  },
  {
    "zipcode": "5100",
    "localities": ["Naninne"]
  },
  {
    "zipcode": "5101",
    "localities": ["Erpent"]
  },
  {
    "zipcode": "5101",
    "localities": ["Loyers"]
  },
  {
    "zipcode": "5101",
    "localities": ["Lives-Sur-Meuse"]
  },
  {
    "zipcode": "5140",
    "localities": ["Tongrinne"]
  },
  {
    "zipcode": "5140",
    "localities": ["Ligny"]
  },
  {
    "zipcode": "5140",
    "localities": ["SOMBREFFE"]
  },
  {
    "zipcode": "5140",
    "localities": ["Boignée"]
  },
  {
    "zipcode": "5150",
    "localities": ["Franière"]
  },
  {
    "zipcode": "5150",
    "localities": ["Floriffoux"]
  },
  {
    "zipcode": "5150",
    "localities": ["FLOREFFE"]
  },
  {
    "zipcode": "5150",
    "localities": ["Soye"]
  },
  {
    "zipcode": "5170",
    "localities": ["Lustin"]
  },
  {
    "zipcode": "5170",
    "localities": ["Arbre"]
  },
  {
    "zipcode": "5170",
    "localities": ["Bois-De-Villers"]
  },
  {
    "zipcode": "5170",
    "localities": ["Lesve"]
  },
  {
    "zipcode": "5170",
    "localities": ["PROFONDEVILLE"]
  },
  {
    "zipcode": "5170",
    "localities": ["Rivière"]
  },
  {
    "zipcode": "5190",
    "localities": ["Balâtre"]
  },
  {
    "zipcode": "5190",
    "localities": ["Onoz"]
  },
  {
    "zipcode": "5190",
    "localities": ["JEMEPPE-SUR-SAMBRE"]
  },
  {
    "zipcode": "5190",
    "localities": ["Moustier-Sur-Sambre"]
  },
  {
    "zipcode": "5190",
    "localities": ["Saint-Martin"]
  },
  {
    "zipcode": "5190",
    "localities": ["Spy"]
  },
  {
    "zipcode": "5190",
    "localities": ["Mornimont"]
  },
  {
    "zipcode": "5190",
    "localities": ["Ham-Sur-Sambre"]
  },
  {
    "zipcode": "5300",
    "localities": ["Landenne"]
  },
  {
    "zipcode": "5300",
    "localities": ["Thon"]
  },
  {
    "zipcode": "5300",
    "localities": ["Sclayn"]
  },
  {
    "zipcode": "5300",
    "localities": ["Seilles"]
  },
  {
    "zipcode": "5300",
    "localities": ["Coutisse"]
  },
  {
    "zipcode": "5300",
    "localities": ["Bonneville"]
  },
  {
    "zipcode": "5300",
    "localities": ["Vezin"]
  },
  {
    "zipcode": "5300",
    "localities": ["Namêche"]
  },
  {
    "zipcode": "5300",
    "localities": ["Maizeret"]
  },
  {
    "zipcode": "5300",
    "localities": ["ANDENNE"]
  },
  {
    "zipcode": "5310",
    "localities": ["Saint-Germain"]
  },
  {
    "zipcode": "5310",
    "localities": ["Leuze"]
  },
  {
    "zipcode": "5310",
    "localities": ["Liernu"]
  },
  {
    "zipcode": "5310",
    "localities": ["Hanret"]
  },
  {
    "zipcode": "5310",
    "localities": ["Waret-La-Chaussée"]
  },
  {
    "zipcode": "5310",
    "localities": ["EGHEZÉE"]
  },
  {
    "zipcode": "5310",
    "localities": ["Noville-Sur-Mehaigne"]
  },
  {
    "zipcode": "5310",
    "localities": ["Bolinne"]
  },
  {
    "zipcode": "5310",
    "localities": ["Dhuy"]
  },
  {
    "zipcode": "5310",
    "localities": ["Taviers"]
  },
  {
    "zipcode": "5310",
    "localities": ["Aische-En-Refail"]
  },
  {
    "zipcode": "5310",
    "localities": ["Branchon"]
  },
  {
    "zipcode": "5310",
    "localities": ["Longchamps"]
  },
  {
    "zipcode": "5310",
    "localities": ["Upigny"]
  },
  {
    "zipcode": "5310",
    "localities": ["Boneffe"]
  },
  {
    "zipcode": "5310",
    "localities": ["Mehaigne"]
  },
  {
    "zipcode": "5330",
    "localities": ["Maillen"]
  },
  {
    "zipcode": "5330",
    "localities": ["ASSESSE"]
  },
  {
    "zipcode": "5330",
    "localities": ["Sart-Bernard"]
  },
  {
    "zipcode": "5332",
    "localities": ["Crupet"]
  },
  {
    "zipcode": "5333",
    "localities": ["Sorinne-La-Longue"]
  },
  {
    "zipcode": "5334",
    "localities": ["Florée"]
  },
  {
    "zipcode": "5336",
    "localities": ["Courrière"]
  },
  {
    "zipcode": "5340",
    "localities": ["GESVES"]
  },
  {
    "zipcode": "5340",
    "localities": ["Sorée"]
  },
  {
    "zipcode": "5340",
    "localities": ["Faulx-Les-Tombes"]
  },
  {
    "zipcode": "5340",
    "localities": ["Haltinne"]
  },
  {
    "zipcode": "5340",
    "localities": ["Mozet"]
  },
  {
    "zipcode": "5350",
    "localities": ["Evelette"]
  },
  {
    "zipcode": "5350",
    "localities": ["OHEY"]
  },
  {
    "zipcode": "5351",
    "localities": ["Haillot"]
  },
  {
    "zipcode": "5352",
    "localities": ["Perwez-Haillot"]
  },
  {
    "zipcode": "5353",
    "localities": ["Goesnes"]
  },
  {
    "zipcode": "5354",
    "localities": ["Jallet"]
  },
  {
    "zipcode": "5360",
    "localities": ["HAMOIS"]
  },
  {
    "zipcode": "5360",
    "localities": ["Natoye"]
  },
  {
    "zipcode": "5361",
    "localities": ["Mohiville"]
  },
  {
    "zipcode": "5361",
    "localities": ["Scy"]
  },
  {
    "zipcode": "5362",
    "localities": ["Achet"]
  },
  {
    "zipcode": "5363",
    "localities": ["Emptinne"]
  },
  {
    "zipcode": "5364",
    "localities": ["Schaltin"]
  },
  {
    "zipcode": "5370",
    "localities": ["Flostoy"]
  },
  {
    "zipcode": "5370",
    "localities": ["Barvaux-Condroz"]
  },
  {
    "zipcode": "5370",
    "localities": ["HAVELANGE"]
  },
  {
    "zipcode": "5370",
    "localities": ["Porcheresse"]
  },
  {
    "zipcode": "5370",
    "localities": ["Verlée"]
  },
  {
    "zipcode": "5370",
    "localities": ["Jeneffe"]
  },
  {
    "zipcode": "5372",
    "localities": ["Méan"]
  },
  {
    "zipcode": "5374",
    "localities": ["Maffe"]
  },
  {
    "zipcode": "5376",
    "localities": ["Miécret"]
  },
  {
    "zipcode": "5377",
    "localities": ["Nettinne"]
  },
  {
    "zipcode": "5377",
    "localities": ["Baillonville"]
  },
  {
    "zipcode": "5377",
    "localities": ["Heure"]
  },
  {
    "zipcode": "5377",
    "localities": ["Bonsin"]
  },
  {
    "zipcode": "5377",
    "localities": ["Hogne"]
  },
  {
    "zipcode": "5377",
    "localities": ["Sinsin"]
  },
  {
    "zipcode": "5377",
    "localities": ["Noiseux"]
  },
  {
    "zipcode": "5377",
    "localities": ["SOMME-LEUZE"]
  },
  {
    "zipcode": "5377",
    "localities": ["Waillet"]
  },
  {
    "zipcode": "5380",
    "localities": ["Noville-Les-Bois"]
  },
  {
    "zipcode": "5380",
    "localities": ["FERNELMONT"]
  },
  {
    "zipcode": "5380",
    "localities": ["Pontillas"]
  },
  {
    "zipcode": "5380",
    "localities": ["Hemptinne"]
  },
  {
    "zipcode": "5380",
    "localities": ["Marchovelette"]
  },
  {
    "zipcode": "5380",
    "localities": ["Cortil-Wodon"]
  },
  {
    "zipcode": "5380",
    "localities": ["Forville"]
  },
  {
    "zipcode": "5380",
    "localities": ["Tillier"]
  },
  {
    "zipcode": "5380",
    "localities": ["Franc-Waret"]
  },
  {
    "zipcode": "5380",
    "localities": ["Bierwart"]
  },
  {
    "zipcode": "5380",
    "localities": ["Hingeon"]
  },
  {
    "zipcode": "5500",
    "localities": ["Falmignoul"]
  },
  {
    "zipcode": "5500",
    "localities": ["Bouvignes-Sur-Meuse"]
  },
  {
    "zipcode": "5500",
    "localities": ["Furfooz"]
  },
  {
    "zipcode": "5500",
    "localities": ["Dréhance"]
  },
  {
    "zipcode": "5500",
    "localities": ["DINANT"]
  },
  {
    "zipcode": "5500",
    "localities": ["Falmagne"]
  },
  {
    "zipcode": "5500",
    "localities": ["Anseremme"]
  },
  {
    "zipcode": "5501",
    "localities": ["Lisogne"]
  },
  {
    "zipcode": "5502",
    "localities": ["Thynes"]
  },
  {
    "zipcode": "5503",
    "localities": ["Sorinnes"]
  },
  {
    "zipcode": "5504",
    "localities": ["Foy-Notre-Dame"]
  },
  {
    "zipcode": "5520",
    "localities": ["ONHAYE"]
  },
  {
    "zipcode": "5520",
    "localities": ["Anthée"]
  },
  {
    "zipcode": "5521",
    "localities": ["Serville"]
  },
  {
    "zipcode": "5522",
    "localities": ["Falaën"]
  },
  {
    "zipcode": "5523",
    "localities": ["Sommière"]
  },
  {
    "zipcode": "5523",
    "localities": ["Weillen"]
  },
  {
    "zipcode": "5524",
    "localities": ["Gérin"]
  },
  {
    "zipcode": "5530",
    "localities": ["Evrehailles"]
  },
  {
    "zipcode": "5530",
    "localities": ["Mont"]
  },
  {
    "zipcode": "5530",
    "localities": ["Spontin"]
  },
  {
    "zipcode": "5530",
    "localities": ["Godinne"]
  },
  {
    "zipcode": "5530",
    "localities": ["Dorinne"]
  },
  {
    "zipcode": "5530",
    "localities": ["YVOIR"]
  },
  {
    "zipcode": "5530",
    "localities": ["Durnal"]
  },
  {
    "zipcode": "5530",
    "localities": ["Purnode"]
  },
  {
    "zipcode": "5530",
    "localities": ["Houx"]
  },
  {
    "zipcode": "5537",
    "localities": ["Haut-Le-Wastia"]
  },
  {
    "zipcode": "5537",
    "localities": ["Annevoie-Rouillon"]
  },
  {
    "zipcode": "5537",
    "localities": ["Warnant"]
  },
  {
    "zipcode": "5537",
    "localities": ["Denée"]
  },
  {
    "zipcode": "5537",
    "localities": ["Sosoye"]
  },
  {
    "zipcode": "5537",
    "localities": ["ANHÉE"]
  },
  {
    "zipcode": "5537",
    "localities": ["Bioul"]
  },
  {
    "zipcode": "5540",
    "localities": ["Hastière-Lavaux"]
  },
  {
    "zipcode": "5540",
    "localities": ["Hermeton-Sur-Meuse"]
  },
  {
    "zipcode": "5540",
    "localities": ["HASTIÈRE"]
  },
  {
    "zipcode": "5540",
    "localities": ["Waulsort"]
  },
  {
    "zipcode": "5541",
    "localities": ["Hastière-Par-Delà"]
  },
  {
    "zipcode": "5542",
    "localities": ["Blaimont"]
  },
  {
    "zipcode": "5543",
    "localities": ["Heer"]
  },
  {
    "zipcode": "5544",
    "localities": ["Agimont"]
  },
  {
    "zipcode": "5550",
    "localities": ["Laforêt"]
  },
  {
    "zipcode": "5550",
    "localities": ["VRESSE-SUR-SEMOIS"]
  },
  {
    "zipcode": "5550",
    "localities": ["Chairière"]
  },
  {
    "zipcode": "5550",
    "localities": ["Mouzaive"]
  },
  {
    "zipcode": "5550",
    "localities": ["Orchimont"]
  },
  {
    "zipcode": "5550",
    "localities": ["Membre"]
  },
  {
    "zipcode": "5550",
    "localities": ["Pussemange"]
  },
  {
    "zipcode": "5550",
    "localities": ["Nafraiture"]
  },
  {
    "zipcode": "5550",
    "localities": ["Sugny"]
  },
  {
    "zipcode": "5550",
    "localities": ["Alle"]
  },
  {
    "zipcode": "5550",
    "localities": ["Bagimont"]
  },
  {
    "zipcode": "5550",
    "localities": ["Bohan"]
  },
  {
    "zipcode": "5555",
    "localities": ["BIÈVRE"]
  },
  {
    "zipcode": "5555",
    "localities": ["Graide"]
  },
  {
    "zipcode": "5555",
    "localities": ["Bellefontaine"]
  },
  {
    "zipcode": "5555",
    "localities": ["Cornimont"]
  },
  {
    "zipcode": "5555",
    "localities": ["Gros-Fays"]
  },
  {
    "zipcode": "5555",
    "localities": ["Monceau-En-Ardenne"]
  },
  {
    "zipcode": "5555",
    "localities": ["Naomé"]
  },
  {
    "zipcode": "5555",
    "localities": ["Baillamont"]
  },
  {
    "zipcode": "5555",
    "localities": ["Oizy"]
  },
  {
    "zipcode": "5555",
    "localities": ["Petit-Fays"]
  },
  {
    "zipcode": "5560",
    "localities": ["HOUYET"]
  },
  {
    "zipcode": "5560",
    "localities": ["Hulsonniaux"]
  },
  {
    "zipcode": "5560",
    "localities": ["Ciergnon"]
  },
  {
    "zipcode": "5560",
    "localities": ["Mesnil-Saint-Blaise"]
  },
  {
    "zipcode": "5560",
    "localities": ["Mesnil-Eglise"]
  },
  {
    "zipcode": "5560",
    "localities": ["Finnevaux"]
  },
  {
    "zipcode": "5561",
    "localities": ["Celles"]
  },
  {
    "zipcode": "5562",
    "localities": ["Custinne"]
  },
  {
    "zipcode": "5563",
    "localities": ["Hour"]
  },
  {
    "zipcode": "5564",
    "localities": ["Wanlin"]
  },
  {
    "zipcode": "5570",
    "localities": ["Winenne"]
  },
  {
    "zipcode": "5570",
    "localities": ["Felenne"]
  },
  {
    "zipcode": "5570",
    "localities": ["Honnay"]
  },
  {
    "zipcode": "5570",
    "localities": ["Javingue"]
  },
  {
    "zipcode": "5570",
    "localities": ["BEAURAING"]
  },
  {
    "zipcode": "5570",
    "localities": ["Dion"]
  },
  {
    "zipcode": "5570",
    "localities": ["Vonêche"]
  },
  {
    "zipcode": "5570",
    "localities": ["Feschaux"]
  },
  {
    "zipcode": "5570",
    "localities": ["Wancennes"]
  },
  {
    "zipcode": "5570",
    "localities": ["Baronville"]
  },
  {
    "zipcode": "5571",
    "localities": ["Wiesme"]
  },
  {
    "zipcode": "5572",
    "localities": ["Focant"]
  },
  {
    "zipcode": "5573",
    "localities": ["Martouzin-Neuville"]
  },
  {
    "zipcode": "5574",
    "localities": ["Pondrôme"]
  },
  {
    "zipcode": "5575",
    "localities": ["Malvoisin"]
  },
  {
    "zipcode": "5575",
    "localities": ["Vencimont"]
  },
  {
    "zipcode": "5575",
    "localities": ["Rienne"]
  },
  {
    "zipcode": "5575",
    "localities": ["Bourseigne-Vieille"]
  },
  {
    "zipcode": "5575",
    "localities": ["Louette-Saint-Pierre"]
  },
  {
    "zipcode": "5575",
    "localities": ["Bourseigne-Neuve"]
  },
  {
    "zipcode": "5575",
    "localities": ["GEDINNE"]
  },
  {
    "zipcode": "5575",
    "localities": ["Houdremont"]
  },
  {
    "zipcode": "5575",
    "localities": ["Willerzie"]
  },
  {
    "zipcode": "5575",
    "localities": ["Patignies"]
  },
  {
    "zipcode": "5575",
    "localities": ["Sart-Custinne"]
  },
  {
    "zipcode": "5575",
    "localities": ["Louette-Saint-Denis"]
  },
  {
    "zipcode": "5576",
    "localities": ["Froidfontaine"]
  },
  {
    "zipcode": "5580",
    "localities": ["Wavreille"]
  },
  {
    "zipcode": "5580",
    "localities": ["Mont-Gauthier"]
  },
  {
    "zipcode": "5580",
    "localities": ["Eprave"]
  },
  {
    "zipcode": "5580",
    "localities": ["Ave-Et-Auffe"]
  },
  {
    "zipcode": "5580",
    "localities": ["Han-Sur-Lesse"]
  },
  {
    "zipcode": "5580",
    "localities": ["Villers-Sur-Lesse"]
  },
  {
    "zipcode": "5580",
    "localities": ["Lessive"]
  },
  {
    "zipcode": "5580",
    "localities": ["Lavaux-Sainte-Anne"]
  },
  {
    "zipcode": "5580",
    "localities": ["ROCHEFORT"]
  },
  {
    "zipcode": "5580",
    "localities": ["Buissonville"]
  },
  {
    "zipcode": "5580",
    "localities": ["Jemelle"]
  },
  {
    "zipcode": "5589",
    "localities": ["Jemelle"]
  },
  {
    "zipcode": "5590",
    "localities": ["Achêne"]
  },
  {
    "zipcode": "5590",
    "localities": ["Chevetogne"]
  },
  {
    "zipcode": "5590",
    "localities": ["Leignon"]
  },
  {
    "zipcode": "5590",
    "localities": ["Sovet"]
  },
  {
    "zipcode": "5590",
    "localities": ["Serinchamps"]
  },
  {
    "zipcode": "5590",
    "localities": ["Braibant"]
  },
  {
    "zipcode": "5590",
    "localities": ["CINEY"]
  },
  {
    "zipcode": "5590",
    "localities": ["Haversin"]
  },
  {
    "zipcode": "5590",
    "localities": ["Conneux"]
  },
  {
    "zipcode": "5590",
    "localities": ["Pessoux"]
  },
  {
    "zipcode": "5600",
    "localities": ["PHILIPPEVILLE"]
  },
  {
    "zipcode": "5600",
    "localities": ["Jamagne"]
  },
  {
    "zipcode": "5600",
    "localities": ["Omezée"]
  },
  {
    "zipcode": "5600",
    "localities": ["Franchimont"]
  },
  {
    "zipcode": "5600",
    "localities": ["Vodecée"]
  },
  {
    "zipcode": "5600",
    "localities": ["Roly"]
  },
  {
    "zipcode": "5600",
    "localities": ["Romedenne"]
  },
  {
    "zipcode": "5600",
    "localities": ["Villers-En-Fagne"]
  },
  {
    "zipcode": "5600",
    "localities": ["Fagnolle"]
  },
  {
    "zipcode": "5600",
    "localities": ["Sart-En-Fagne"]
  },
  {
    "zipcode": "5600",
    "localities": ["Sautour"]
  },
  {
    "zipcode": "5600",
    "localities": ["Surice"]
  },
  {
    "zipcode": "5600",
    "localities": ["Merlemont"]
  },
  {
    "zipcode": "5600",
    "localities": ["Neuville"]
  },
  {
    "zipcode": "5600",
    "localities": ["Villers-Le-Gambon"]
  },
  {
    "zipcode": "5600",
    "localities": ["Jamiolle"]
  },
  {
    "zipcode": "5600",
    "localities": ["Samart"]
  },
  {
    "zipcode": "5620",
    "localities": ["Rosée"]
  },
  {
    "zipcode": "5620",
    "localities": ["Morville"]
  },
  {
    "zipcode": "5620",
    "localities": ["Corenne"]
  },
  {
    "zipcode": "5620",
    "localities": ["Saint-Aubin"]
  },
  {
    "zipcode": "5620",
    "localities": ["Flavion"]
  },
  {
    "zipcode": "5620",
    "localities": ["FLORENNES"]
  },
  {
    "zipcode": "5620",
    "localities": ["Hemptinne-Lez-Florennes"]
  },
  {
    "zipcode": "5621",
    "localities": ["Morialmé"]
  },
  {
    "zipcode": "5621",
    "localities": ["Hanzinelle"]
  },
  {
    "zipcode": "5621",
    "localities": ["Thy-Le-Baudouin"]
  },
  {
    "zipcode": "5621",
    "localities": ["Hanzinne"]
  },
  {
    "zipcode": "5630",
    "localities": ["Soumoy"]
  },
  {
    "zipcode": "5630",
    "localities": ["Silenrieux"]
  },
  {
    "zipcode": "5630",
    "localities": ["Senzeilles"]
  },
  {
    "zipcode": "5630",
    "localities": ["Daussois"]
  },
  {
    "zipcode": "5630",
    "localities": ["Villers-Deux-Eglises"]
  },
  {
    "zipcode": "5630",
    "localities": ["CERFONTAINE"]
  },
  {
    "zipcode": "5640",
    "localities": ["Graux"]
  },
  {
    "zipcode": "5640",
    "localities": ["Saint-Gérard"]
  },
  {
    "zipcode": "5640",
    "localities": ["Biesmerée"]
  },
  {
    "zipcode": "5640",
    "localities": ["Biesme"]
  },
  {
    "zipcode": "5640",
    "localities": ["METTET"]
  },
  {
    "zipcode": "5640",
    "localities": ["Oret"]
  },
  {
    "zipcode": "5641",
    "localities": ["Furnaux"]
  },
  {
    "zipcode": "5644",
    "localities": ["Ermeton-Sur-Biert"]
  },
  {
    "zipcode": "5646",
    "localities": ["Stave"]
  },
  {
    "zipcode": "5650",
    "localities": ["WALCOURT"]
  },
  {
    "zipcode": "5650",
    "localities": ["Castillon"]
  },
  {
    "zipcode": "5650",
    "localities": ["Fraire"]
  },
  {
    "zipcode": "5650",
    "localities": ["Vogenée"]
  },
  {
    "zipcode": "5650",
    "localities": ["Chastrès"]
  },
  {
    "zipcode": "5650",
    "localities": ["Yves-Gomezée"]
  },
  {
    "zipcode": "5650",
    "localities": ["Pry"]
  },
  {
    "zipcode": "5650",
    "localities": ["Clermont"]
  },
  {
    "zipcode": "5650",
    "localities": ["Fontenelle"]
  },
  {
    "zipcode": "5651",
    "localities": ["Somzée"]
  },
  {
    "zipcode": "5651",
    "localities": ["Thy-Le-Château"]
  },
  {
    "zipcode": "5651",
    "localities": ["Gourdinne"]
  },
  {
    "zipcode": "5651",
    "localities": ["Tarcienne"]
  },
  {
    "zipcode": "5651",
    "localities": ["Berzée"]
  },
  {
    "zipcode": "5651",
    "localities": ["Rognée"]
  },
  {
    "zipcode": "5651",
    "localities": ["Laneffe"]
  },
  {
    "zipcode": "5660",
    "localities": ["Cul-Des-Sarts"]
  },
  {
    "zipcode": "5660",
    "localities": ["Pesche"]
  },
  {
    "zipcode": "5660",
    "localities": ["Petite-Chapelle"]
  },
  {
    "zipcode": "5660",
    "localities": ["Brûly-De-Pesche"]
  },
  {
    "zipcode": "5660",
    "localities": ["COUVIN"]
  },
  {
    "zipcode": "5660",
    "localities": ["Mariembourg"]
  },
  {
    "zipcode": "5660",
    "localities": ["Presgaux"]
  },
  {
    "zipcode": "5660",
    "localities": ["Aublain"]
  },
  {
    "zipcode": "5660",
    "localities": ["Boussu-En-Fagne"]
  },
  {
    "zipcode": "5660",
    "localities": ["Brûly"]
  },
  {
    "zipcode": "5660",
    "localities": ["Dailly"]
  },
  {
    "zipcode": "5660",
    "localities": ["Pétigny"]
  },
  {
    "zipcode": "5660",
    "localities": ["Frasnes"]
  },
  {
    "zipcode": "5660",
    "localities": ["Gonrieux"]
  },
  {
    "zipcode": "5670",
    "localities": ["Nismes"]
  },
  {
    "zipcode": "5670",
    "localities": ["Le Mesnil"]
  },
  {
    "zipcode": "5670",
    "localities": ["Oignies-En-Thiérache"]
  },
  {
    "zipcode": "5670",
    "localities": ["Olloy-Sur-Viroin"]
  },
  {
    "zipcode": "5670",
    "localities": ["VIROINVAL"]
  },
  {
    "zipcode": "5670",
    "localities": ["Mazée"]
  },
  {
    "zipcode": "5670",
    "localities": ["Dourbes"]
  },
  {
    "zipcode": "5670",
    "localities": ["Treignes"]
  },
  {
    "zipcode": "5670",
    "localities": ["Vierves-Sur-Viroin"]
  },
  {
    "zipcode": "5680",
    "localities": ["Soulme"]
  },
  {
    "zipcode": "5680",
    "localities": ["Vodelée"]
  },
  {
    "zipcode": "5680",
    "localities": ["Vaucelles"]
  },
  {
    "zipcode": "5680",
    "localities": ["Gochenée"]
  },
  {
    "zipcode": "5680",
    "localities": ["Romerée"]
  },
  {
    "zipcode": "5680",
    "localities": ["DOISCHE"]
  },
  {
    "zipcode": "5680",
    "localities": ["Matagne-La-Grande"]
  },
  {
    "zipcode": "5680",
    "localities": ["Matagne-La-Petite"]
  },
  {
    "zipcode": "5680",
    "localities": ["Gimnée"]
  },
  {
    "zipcode": "5680",
    "localities": ["Niverlée"]
  },
  {
    "zipcode": "6000",
    "localities": ["CHARLEROI"]
  },
  {
    "zipcode": "6001",
    "localities": ["Marcinelle"]
  },
  {
    "zipcode": "6010",
    "localities": ["Couillet"]
  },
  {
    "zipcode": "6020",
    "localities": ["Dampremy"]
  },
  {
    "zipcode": "6030",
    "localities": ["Marchienne-Au-Pont"]
  },
  {
    "zipcode": "6030",
    "localities": ["Goutroux"]
  },
  {
    "zipcode": "6031",
    "localities": ["Monceau-Sur-Sambre"]
  },
  {
    "zipcode": "6032",
    "localities": ["Mont-Sur-Marchienne"]
  },
  {
    "zipcode": "6040",
    "localities": ["Jumet"]
  },
  {
    "zipcode": "6041",
    "localities": ["Gosselies"]
  },
  {
    "zipcode": "6042",
    "localities": ["Lodelinsart"]
  },
  {
    "zipcode": "6043",
    "localities": ["Ransart"]
  },
  {
    "zipcode": "6044",
    "localities": ["Roux"]
  },
  {
    "zipcode": "6060",
    "localities": ["Gilly"]
  },
  {
    "zipcode": "6061",
    "localities": ["Montignies-Sur-Sambre"]
  },
  {
    "zipcode": "6075",
    "localities": ["CSM Charleroi X"]
  },
  {
    "zipcode": "6099",
    "localities": ["Charleroi X"]
  },
  {
    "zipcode": "6110",
    "localities": ["MONTIGNY-LE-TILLEUL"]
  },
  {
    "zipcode": "6111",
    "localities": ["Landelies"]
  },
  {
    "zipcode": "6120",
    "localities": ["Nalinnes"]
  },
  {
    "zipcode": "6120",
    "localities": ["Cour-Sur-Heure"]
  },
  {
    "zipcode": "6120",
    "localities": ["HAM-SUR-HEURE"]
  },
  {
    "zipcode": "6120",
    "localities": ["Marbaix"]
  },
  {
    "zipcode": "6120",
    "localities": ["Jamioulx"]
  },
  {
    "zipcode": "6140",
    "localities": ["FONTAINE-L'EVÀQUE"]
  },
  {
    "zipcode": "6141",
    "localities": ["Forchies-La-Marche"]
  },
  {
    "zipcode": "6142",
    "localities": ["Leernes"]
  },
  {
    "zipcode": "6150",
    "localities": ["ANDERLUES"]
  },
  {
    "zipcode": "6180",
    "localities": ["COURCELLES"]
  },
  {
    "zipcode": "6181",
    "localities": ["Gouy-Lez-Piéton"]
  },
  {
    "zipcode": "6182",
    "localities": ["Souvret"]
  },
  {
    "zipcode": "6183",
    "localities": ["Trazegnies"]
  },
  {
    "zipcode": "6200",
    "localities": ["Bouffioulx"]
  },
  {
    "zipcode": "6200",
    "localities": ["CHÂTELET"]
  },
  {
    "zipcode": "6200",
    "localities": ["Châtelineau"]
  },
  {
    "zipcode": "6210",
    "localities": ["Villers-Perwin"]
  },
  {
    "zipcode": "6210",
    "localities": ["Rèves"]
  },
  {
    "zipcode": "6210",
    "localities": ["Frasnes-Lez-Gosselies"]
  },
  {
    "zipcode": "6210",
    "localities": ["LES BONS VILLERS"]
  },
  {
    "zipcode": "6210",
    "localities": ["Wayaux"]
  },
  {
    "zipcode": "6211",
    "localities": ["Mellet"]
  },
  {
    "zipcode": "6220",
    "localities": ["Heppignies"]
  },
  {
    "zipcode": "6220",
    "localities": ["Lambusart"]
  },
  {
    "zipcode": "6220",
    "localities": ["FLEURUS"]
  },
  {
    "zipcode": "6220",
    "localities": ["Wangenies"]
  },
  {
    "zipcode": "6221",
    "localities": ["Saint-Amand"]
  },
  {
    "zipcode": "6222",
    "localities": ["Brye"]
  },
  {
    "zipcode": "6223",
    "localities": ["Wagnelée"]
  },
  {
    "zipcode": "6224",
    "localities": ["Wanfercée-Baulet"]
  },
  {
    "zipcode": "6230",
    "localities": ["Viesville"]
  },
  {
    "zipcode": "6230",
    "localities": ["Obaix"]
  },
  {
    "zipcode": "6230",
    "localities": ["Buzet"]
  },
  {
    "zipcode": "6230",
    "localities": ["Thiméon"]
  },
  {
    "zipcode": "6230",
    "localities": ["PONT-À-CELLES"]
  },
  {
    "zipcode": "6238",
    "localities": ["Luttre"]
  },
  {
    "zipcode": "6238",
    "localities": ["Liberchies"]
  },
  {
    "zipcode": "6240",
    "localities": ["Pironchamps"]
  },
  {
    "zipcode": "6240",
    "localities": ["FARCIENNES"]
  },
  {
    "zipcode": "6250",
    "localities": ["Aiseau"]
  },
  {
    "zipcode": "6250",
    "localities": ["Pont-De-Loup"]
  },
  {
    "zipcode": "6250",
    "localities": ["Presles"]
  },
  {
    "zipcode": "6250",
    "localities": ["AISEAU-PRESLES"]
  },
  {
    "zipcode": "6250",
    "localities": ["Roselies"]
  },
  {
    "zipcode": "6280",
    "localities": ["GERPINNES"]
  },
  {
    "zipcode": "6280",
    "localities": ["Gougnies"]
  },
  {
    "zipcode": "6280",
    "localities": ["Villers-Poterie"]
  },
  {
    "zipcode": "6280",
    "localities": ["Acoz"]
  },
  {
    "zipcode": "6280",
    "localities": ["Joncret"]
  },
  {
    "zipcode": "6280",
    "localities": ["Loverval"]
  },
  {
    "zipcode": "6440",
    "localities": ["Boussu-Lez-Walcourt"]
  },
  {
    "zipcode": "6440",
    "localities": ["FROIDCHAPELLE"]
  },
  {
    "zipcode": "6440",
    "localities": ["Fourbechies"]
  },
  {
    "zipcode": "6440",
    "localities": ["Vergnies"]
  },
  {
    "zipcode": "6441",
    "localities": ["Erpion"]
  },
  {
    "zipcode": "6460",
    "localities": ["Salles"]
  },
  {
    "zipcode": "6460",
    "localities": ["Robechies"]
  },
  {
    "zipcode": "6460",
    "localities": ["Bailièvre"]
  },
  {
    "zipcode": "6460",
    "localities": ["Villers-La-Tour"]
  },
  {
    "zipcode": "6460",
    "localities": ["Saint-Remy"]
  },
  {
    "zipcode": "6460",
    "localities": ["CHIMAY"]
  },
  {
    "zipcode": "6461",
    "localities": ["Virelles"]
  },
  {
    "zipcode": "6462",
    "localities": ["Vaulx-Lez-Chimay"]
  },
  {
    "zipcode": "6463",
    "localities": ["Lompret"]
  },
  {
    "zipcode": "6464",
    "localities": ["Rièzes"]
  },
  {
    "zipcode": "6464",
    "localities": ["Baileux"]
  },
  {
    "zipcode": "6464",
    "localities": ["L'Escaillère"]
  },
  {
    "zipcode": "6464",
    "localities": ["Bourlers"]
  },
  {
    "zipcode": "6464",
    "localities": ["Forges"]
  },
  {
    "zipcode": "6470",
    "localities": ["Sautin"]
  },
  {
    "zipcode": "6470",
    "localities": ["SIVRY-RANCE"]
  },
  {
    "zipcode": "6470",
    "localities": ["Rance"]
  },
  {
    "zipcode": "6470",
    "localities": ["Grandrieu"]
  },
  {
    "zipcode": "6470",
    "localities": ["Montbliart"]
  },
  {
    "zipcode": "6470",
    "localities": ["Sivry"]
  },
  {
    "zipcode": "6500",
    "localities": ["Renlies"]
  },
  {
    "zipcode": "6500",
    "localities": ["Leugnies"]
  },
  {
    "zipcode": "6500",
    "localities": ["Solre-Saint-Géry"]
  },
  {
    "zipcode": "6500",
    "localities": ["Thirimont"]
  },
  {
    "zipcode": "6500",
    "localities": ["Leval-Chaudeville"]
  },
  {
    "zipcode": "6500",
    "localities": ["BEAUMONT"]
  },
  {
    "zipcode": "6500",
    "localities": ["Barbençon"]
  },
  {
    "zipcode": "6511",
    "localities": ["Strée"]
  },
  {
    "zipcode": "6530",
    "localities": ["Leers-Et-Fosteau"]
  },
  {
    "zipcode": "6530",
    "localities": ["THUIN"]
  },
  {
    "zipcode": "6531",
    "localities": ["Biesme-Sous-Thuin"]
  },
  {
    "zipcode": "6532",
    "localities": ["Ragnies"]
  },
  {
    "zipcode": "6533",
    "localities": ["Biercée"]
  },
  {
    "zipcode": "6534",
    "localities": ["Gozée"]
  },
  {
    "zipcode": "6536",
    "localities": ["Thuillies"]
  },
  {
    "zipcode": "6536",
    "localities": ["Donstiennes"]
  },
  {
    "zipcode": "6540",
    "localities": ["Mont-Sainte-Geneviève"]
  },
  {
    "zipcode": "6540",
    "localities": ["LOBBES"]
  },
  {
    "zipcode": "6542",
    "localities": ["Sars-La-Buissière"]
  },
  {
    "zipcode": "6543",
    "localities": ["Bienne-Lez-Happart"]
  },
  {
    "zipcode": "6560",
    "localities": ["Solre-Sur-Sambre"]
  },
  {
    "zipcode": "6560",
    "localities": ["Grand-Reng"]
  },
  {
    "zipcode": "6560",
    "localities": ["Montignies-Saint-Christophe"]
  },
  {
    "zipcode": "6560",
    "localities": ["Bersillies-L'Abbaye"]
  },
  {
    "zipcode": "6560",
    "localities": ["ERQUELINNES"]
  },
  {
    "zipcode": "6560",
    "localities": ["Hantes-Wihéries"]
  },
  {
    "zipcode": "6567",
    "localities": ["MERBES-LE-CHÂTEAU"]
  },
  {
    "zipcode": "6567",
    "localities": ["Fontaine-Valmont"]
  },
  {
    "zipcode": "6567",
    "localities": ["Labuissière"]
  },
  {
    "zipcode": "6567",
    "localities": ["Merbes-Sainte-Marie"]
  },
  {
    "zipcode": "6590",
    "localities": ["MOMIGNIES"]
  },
  {
    "zipcode": "6591",
    "localities": ["Macon"]
  },
  {
    "zipcode": "6592",
    "localities": ["Monceau-Imbrechies"]
  },
  {
    "zipcode": "6593",
    "localities": ["Macquenoise"]
  },
  {
    "zipcode": "6594",
    "localities": ["Beauwelz"]
  },
  {
    "zipcode": "6596",
    "localities": ["Seloignes"]
  },
  {
    "zipcode": "6596",
    "localities": ["Forge-Philippe"]
  },
  {
    "zipcode": "6600",
    "localities": ["BASTOGNE"]
  },
  {
    "zipcode": "6600",
    "localities": ["Wardin"]
  },
  {
    "zipcode": "6600",
    "localities": ["Longvilly"]
  },
  {
    "zipcode": "6600",
    "localities": ["Noville"]
  },
  {
    "zipcode": "6600",
    "localities": ["Villers-La-Bonne-Eau"]
  },
  {
    "zipcode": "6630",
    "localities": ["MARTELANGE"]
  },
  {
    "zipcode": "6637",
    "localities": ["FAUVILLERS"]
  },
  {
    "zipcode": "6637",
    "localities": ["Hollange"]
  },
  {
    "zipcode": "6637",
    "localities": ["Tintange"]
  },
  {
    "zipcode": "6640",
    "localities": ["Hompré"]
  },
  {
    "zipcode": "6640",
    "localities": ["Vaux-Lez-Rosières"]
  },
  {
    "zipcode": "6640",
    "localities": ["Sibret"]
  },
  {
    "zipcode": "6640",
    "localities": ["VAUX-SUR-SÛRE"]
  },
  {
    "zipcode": "6640",
    "localities": ["Nives"]
  },
  {
    "zipcode": "6640",
    "localities": ["Morhet"]
  },
  {
    "zipcode": "6642",
    "localities": ["Juseret"]
  },
  {
    "zipcode": "6660",
    "localities": ["HOUFFALIZE"]
  },
  {
    "zipcode": "6660",
    "localities": ["Nadrin"]
  },
  {
    "zipcode": "6661",
    "localities": ["Mont"]
  },
  {
    "zipcode": "6661",
    "localities": ["Tailles"]
  },
  {
    "zipcode": "6662",
    "localities": ["Tavigny"]
  },
  {
    "zipcode": "6663",
    "localities": ["Mabompré"]
  },
  {
    "zipcode": "6666",
    "localities": ["Wibrin"]
  },
  {
    "zipcode": "6670",
    "localities": ["GOUVY"]
  },
  {
    "zipcode": "6670",
    "localities": ["Limerlé"]
  },
  {
    "zipcode": "6671",
    "localities": ["Bovigny"]
  },
  {
    "zipcode": "6672",
    "localities": ["Beho"]
  },
  {
    "zipcode": "6673",
    "localities": ["Cherain"]
  },
  {
    "zipcode": "6674",
    "localities": ["Montleban"]
  },
  {
    "zipcode": "6680",
    "localities": ["SAINTE-ODE"]
  },
  {
    "zipcode": "6680",
    "localities": ["Amberloup"]
  },
  {
    "zipcode": "6680",
    "localities": ["Tillet"]
  },
  {
    "zipcode": "6681",
    "localities": ["Lavacherie"]
  },
  {
    "zipcode": "6686",
    "localities": ["Flamierge"]
  },
  {
    "zipcode": "6687",
    "localities": ["BERTOGNE"]
  },
  {
    "zipcode": "6688",
    "localities": ["Longchamps"]
  },
  {
    "zipcode": "6690",
    "localities": ["VIELSALM"]
  },
  {
    "zipcode": "6690",
    "localities": ["Bihain"]
  },
  {
    "zipcode": "6692",
    "localities": ["Petit-Thier"]
  },
  {
    "zipcode": "6698",
    "localities": ["Grand-Halleux"]
  },
  {
    "zipcode": "6700",
    "localities": ["Toernich"]
  },
  {
    "zipcode": "6700",
    "localities": ["ARLON"]
  },
  {
    "zipcode": "6700",
    "localities": ["Bonnert"]
  },
  {
    "zipcode": "6700",
    "localities": ["Heinsch"]
  },
  {
    "zipcode": "6704",
    "localities": ["Guirsch"]
  },
  {
    "zipcode": "6706",
    "localities": ["Autelbas"]
  },
  {
    "zipcode": "6717",
    "localities": ["ATTERT"]
  },
  {
    "zipcode": "6717",
    "localities": ["Nobressart"]
  },
  {
    "zipcode": "6717",
    "localities": ["Tontelange"]
  },
  {
    "zipcode": "6717",
    "localities": ["Nothomb"]
  },
  {
    "zipcode": "6717",
    "localities": ["Thiaumont"]
  },
  {
    "zipcode": "6720",
    "localities": ["Hachy"]
  },
  {
    "zipcode": "6720",
    "localities": ["Habay-La-Neuve"]
  },
  {
    "zipcode": "6720",
    "localities": ["HABAY"]
  },
  {
    "zipcode": "6721",
    "localities": ["Anlier"]
  },
  {
    "zipcode": "6723",
    "localities": ["Habay-La-Vieille"]
  },
  {
    "zipcode": "6724",
    "localities": ["Rulles"]
  },
  {
    "zipcode": "6724",
    "localities": ["Houdemont"]
  },
  {
    "zipcode": "6730",
    "localities": ["Saint-Vincent"]
  },
  {
    "zipcode": "6730",
    "localities": ["Bellefontaine"]
  },
  {
    "zipcode": "6730",
    "localities": ["Rossignol"]
  },
  {
    "zipcode": "6730",
    "localities": ["TINTIGNY"]
  },
  {
    "zipcode": "6740",
    "localities": ["Sainte-Marie-Sur-Semois"]
  },
  {
    "zipcode": "6740",
    "localities": ["ETALLE"]
  },
  {
    "zipcode": "6740",
    "localities": ["Villers-Sur-Semois"]
  },
  {
    "zipcode": "6741",
    "localities": ["Vance"]
  },
  {
    "zipcode": "6742",
    "localities": ["Chantemelle"]
  },
  {
    "zipcode": "6743",
    "localities": ["Buzenol"]
  },
  {
    "zipcode": "6747",
    "localities": ["Meix-Le-Tige"]
  },
  {
    "zipcode": "6747",
    "localities": ["SAINT-LÉGER"]
  },
  {
    "zipcode": "6747",
    "localities": ["Châtillon"]
  },
  {
    "zipcode": "6750",
    "localities": ["MUSSON"]
  },
  {
    "zipcode": "6750",
    "localities": ["Mussy-La-Ville"]
  },
  {
    "zipcode": "6750",
    "localities": ["Signeulx"]
  },
  {
    "zipcode": "6760",
    "localities": ["Ethe"]
  },
  {
    "zipcode": "6760",
    "localities": ["Bleid"]
  },
  {
    "zipcode": "6760",
    "localities": ["VIRTON"]
  },
  {
    "zipcode": "6760",
    "localities": ["Ruette"]
  },
  {
    "zipcode": "6761",
    "localities": ["Latour"]
  },
  {
    "zipcode": "6762",
    "localities": ["Saint-Mard"]
  },
  {
    "zipcode": "6767",
    "localities": ["Dampicourt"]
  },
  {
    "zipcode": "6767",
    "localities": ["Harnoncourt"]
  },
  {
    "zipcode": "6767",
    "localities": ["Lamorteau"]
  },
  {
    "zipcode": "6767",
    "localities": ["ROUVROY"]
  },
  {
    "zipcode": "6767",
    "localities": ["Torgny"]
  },
  {
    "zipcode": "6769",
    "localities": ["MEIX-DEVANT-VIRTON"]
  },
  {
    "zipcode": "6769",
    "localities": ["Sommethonne"]
  },
  {
    "zipcode": "6769",
    "localities": ["Villers-La-Loue"]
  },
  {
    "zipcode": "6769",
    "localities": ["Gérouville"]
  },
  {
    "zipcode": "6769",
    "localities": ["Robelmont"]
  },
  {
    "zipcode": "6780",
    "localities": ["Hondelange"]
  },
  {
    "zipcode": "6780",
    "localities": ["MESSANCY"]
  },
  {
    "zipcode": "6780",
    "localities": ["Wolkrange"]
  },
  {
    "zipcode": "6781",
    "localities": ["Sélange"]
  },
  {
    "zipcode": "6782",
    "localities": ["Habergy"]
  },
  {
    "zipcode": "6790",
    "localities": ["AUBANGE"]
  },
  {
    "zipcode": "6791",
    "localities": ["Athus"]
  },
  {
    "zipcode": "6792",
    "localities": ["Halanzy"]
  },
  {
    "zipcode": "6792",
    "localities": ["Rachecourt"]
  },
  {
    "zipcode": "6800",
    "localities": ["Recogne"]
  },
  {
    "zipcode": "6800",
    "localities": ["Freux"]
  },
  {
    "zipcode": "6800",
    "localities": ["Bras"]
  },
  {
    "zipcode": "6800",
    "localities": ["Remagne"]
  },
  {
    "zipcode": "6800",
    "localities": ["Moircy"]
  },
  {
    "zipcode": "6800",
    "localities": ["Saint-Pierre"]
  },
  {
    "zipcode": "6800",
    "localities": ["Sainte-Marie-Chevigny"]
  },
  {
    "zipcode": "6800",
    "localities": ["LIBRAMONT-CHEVIGNY"]
  },
  {
    "zipcode": "6810",
    "localities": ["Jamoigne"]
  },
  {
    "zipcode": "6810",
    "localities": ["CHINY"]
  },
  {
    "zipcode": "6810",
    "localities": ["Izel"]
  },
  {
    "zipcode": "6811",
    "localities": ["Les Bulles"]
  },
  {
    "zipcode": "6812",
    "localities": ["Suxy"]
  },
  {
    "zipcode": "6813",
    "localities": ["Termes"]
  },
  {
    "zipcode": "6820",
    "localities": ["FLORENVILLE"]
  },
  {
    "zipcode": "6820",
    "localities": ["Muno"]
  },
  {
    "zipcode": "6820",
    "localities": ["Sainte-Cécile"]
  },
  {
    "zipcode": "6820",
    "localities": ["Fontenoille"]
  },
  {
    "zipcode": "6821",
    "localities": ["Lacuisine"]
  },
  {
    "zipcode": "6823",
    "localities": ["Villers-Devant-Orval"]
  },
  {
    "zipcode": "6824",
    "localities": ["Chassepierre"]
  },
  {
    "zipcode": "6830",
    "localities": ["Rochehaut"]
  },
  {
    "zipcode": "6830",
    "localities": ["Poupehan"]
  },
  {
    "zipcode": "6830",
    "localities": ["BOUILLON"]
  },
  {
    "zipcode": "6830",
    "localities": ["Les Hayons"]
  },
  {
    "zipcode": "6831",
    "localities": ["Noirfontaine"]
  },
  {
    "zipcode": "6832",
    "localities": ["Sensenruth"]
  },
  {
    "zipcode": "6833",
    "localities": ["Ucimont"]
  },
  {
    "zipcode": "6833",
    "localities": ["Vivy"]
  },
  {
    "zipcode": "6834",
    "localities": ["Bellevaux"]
  },
  {
    "zipcode": "6836",
    "localities": ["Dohan"]
  },
  {
    "zipcode": "6838",
    "localities": ["Corbion"]
  },
  {
    "zipcode": "6840",
    "localities": ["Tournay"]
  },
  {
    "zipcode": "6840",
    "localities": ["Grapfontaine"]
  },
  {
    "zipcode": "6840",
    "localities": ["NEUFCHÂTEAU"]
  },
  {
    "zipcode": "6840",
    "localities": ["Hamipré"]
  },
  {
    "zipcode": "6840",
    "localities": ["Longlier"]
  },
  {
    "zipcode": "6840",
    "localities": ["Grandvoir"]
  },
  {
    "zipcode": "6850",
    "localities": ["Carlsbourg"]
  },
  {
    "zipcode": "6850",
    "localities": ["Offagne"]
  },
  {
    "zipcode": "6850",
    "localities": ["PALISEUL"]
  },
  {
    "zipcode": "6851",
    "localities": ["Nollevaux"]
  },
  {
    "zipcode": "6852",
    "localities": ["Maissin"]
  },
  {
    "zipcode": "6852",
    "localities": ["Opont"]
  },
  {
    "zipcode": "6853",
    "localities": ["Framont"]
  },
  {
    "zipcode": "6856",
    "localities": ["Fays-Les-Veneurs"]
  },
  {
    "zipcode": "6860",
    "localities": ["LÉGLISE"]
  },
  {
    "zipcode": "6860",
    "localities": ["Witry"]
  },
  {
    "zipcode": "6860",
    "localities": ["Mellier"]
  },
  {
    "zipcode": "6860",
    "localities": ["Ebly"]
  },
  {
    "zipcode": "6860",
    "localities": ["Assenois"]
  },
  {
    "zipcode": "6870",
    "localities": ["Hatrival"]
  },
  {
    "zipcode": "6870",
    "localities": ["Awenne"]
  },
  {
    "zipcode": "6870",
    "localities": ["SAINT-HUBERT"]
  },
  {
    "zipcode": "6870",
    "localities": ["Mirwart"]
  },
  {
    "zipcode": "6870",
    "localities": ["Vesqueville"]
  },
  {
    "zipcode": "6870",
    "localities": ["Arville"]
  },
  {
    "zipcode": "6880",
    "localities": ["Auby-Sur-Semois"]
  },
  {
    "zipcode": "6880",
    "localities": ["BERTRIX"]
  },
  {
    "zipcode": "6880",
    "localities": ["Cugnon"]
  },
  {
    "zipcode": "6880",
    "localities": ["Orgeo"]
  },
  {
    "zipcode": "6880",
    "localities": ["Jehonville"]
  },
  {
    "zipcode": "6887",
    "localities": ["Saint-Médard"]
  },
  {
    "zipcode": "6887",
    "localities": ["Straimont"]
  },
  {
    "zipcode": "6887",
    "localities": ["HERBEUMONT"]
  },
  {
    "zipcode": "6890",
    "localities": ["Transinne"]
  },
  {
    "zipcode": "6890",
    "localities": ["Ochamps"]
  },
  {
    "zipcode": "6890",
    "localities": ["Redu"]
  },
  {
    "zipcode": "6890",
    "localities": ["Villance"]
  },
  {
    "zipcode": "6890",
    "localities": ["Smuid"]
  },
  {
    "zipcode": "6890",
    "localities": ["Anloy"]
  },
  {
    "zipcode": "6890",
    "localities": ["LIBIN"]
  },
  {
    "zipcode": "6900",
    "localities": ["Aye"]
  },
  {
    "zipcode": "6900",
    "localities": ["Hargimont"]
  },
  {
    "zipcode": "6900",
    "localities": ["Humain"]
  },
  {
    "zipcode": "6900",
    "localities": ["MARCHE-EN-FAMENNE"]
  },
  {
    "zipcode": "6900",
    "localities": ["On"]
  },
  {
    "zipcode": "6900",
    "localities": ["Waha"]
  },
  {
    "zipcode": "6900",
    "localities": ["Roy"]
  },
  {
    "zipcode": "6920",
    "localities": ["Sohier"]
  },
  {
    "zipcode": "6920",
    "localities": ["WELLIN"]
  },
  {
    "zipcode": "6921",
    "localities": ["Chanly"]
  },
  {
    "zipcode": "6922",
    "localities": ["Halma"]
  },
  {
    "zipcode": "6924",
    "localities": ["Lomprez"]
  },
  {
    "zipcode": "6927",
    "localities": ["Bure"]
  },
  {
    "zipcode": "6927",
    "localities": ["Grupont"]
  },
  {
    "zipcode": "6927",
    "localities": ["Resteigne"]
  },
  {
    "zipcode": "6927",
    "localities": ["TELLIN"]
  },
  {
    "zipcode": "6929",
    "localities": ["Porcheresse"]
  },
  {
    "zipcode": "6929",
    "localities": ["Gembes"]
  },
  {
    "zipcode": "6929",
    "localities": ["DAVERDISSE"]
  },
  {
    "zipcode": "6929",
    "localities": ["Haut-Fays"]
  },
  {
    "zipcode": "6940",
    "localities": ["Grandhan"]
  },
  {
    "zipcode": "6940",
    "localities": ["Wéris"]
  },
  {
    "zipcode": "6940",
    "localities": ["DURBUY"]
  },
  {
    "zipcode": "6940",
    "localities": ["Septon"]
  },
  {
    "zipcode": "6940",
    "localities": ["Barvaux-Sur-Ourthe"]
  },
  {
    "zipcode": "6941",
    "localities": ["Borlon"]
  },
  {
    "zipcode": "6941",
    "localities": ["Villers-Sainte-Gertrude"]
  },
  {
    "zipcode": "6941",
    "localities": ["Bende"]
  },
  {
    "zipcode": "6941",
    "localities": ["Izier"]
  },
  {
    "zipcode": "6941",
    "localities": ["Tohogne"]
  },
  {
    "zipcode": "6941",
    "localities": ["Bomal-Sur-Ourthe"]
  },
  {
    "zipcode": "6941",
    "localities": ["Heyd"]
  },
  {
    "zipcode": "6950",
    "localities": ["Harsin"]
  },
  {
    "zipcode": "6950",
    "localities": ["NASSOGNE"]
  },
  {
    "zipcode": "6951",
    "localities": ["Bande"]
  },
  {
    "zipcode": "6952",
    "localities": ["Grune"]
  },
  {
    "zipcode": "6953",
    "localities": ["Ambly"]
  },
  {
    "zipcode": "6953",
    "localities": ["Forrières"]
  },
  {
    "zipcode": "6953",
    "localities": ["Lesterny"]
  },
  {
    "zipcode": "6953",
    "localities": ["Masbourg"]
  },
  {
    "zipcode": "6960",
    "localities": ["Malempré"]
  },
  {
    "zipcode": "6960",
    "localities": ["Odeigne"]
  },
  {
    "zipcode": "6960",
    "localities": ["Harre"]
  },
  {
    "zipcode": "6960",
    "localities": ["Dochamps"]
  },
  {
    "zipcode": "6960",
    "localities": ["Vaux-Chavanne"]
  },
  {
    "zipcode": "6960",
    "localities": ["MANHAY"]
  },
  {
    "zipcode": "6960",
    "localities": ["Grandménil"]
  },
  {
    "zipcode": "6970",
    "localities": ["TENNEVILLE"]
  },
  {
    "zipcode": "6971",
    "localities": ["Champlon"]
  },
  {
    "zipcode": "6972",
    "localities": ["Erneuville"]
  },
  {
    "zipcode": "6980",
    "localities": ["LA ROCHE-EN-ARDENNE"]
  },
  {
    "zipcode": "6980",
    "localities": ["Beausaint"]
  },
  {
    "zipcode": "6982",
    "localities": ["Samrée"]
  },
  {
    "zipcode": "6983",
    "localities": ["Ortho"]
  },
  {
    "zipcode": "6984",
    "localities": ["Hives"]
  },
  {
    "zipcode": "6986",
    "localities": ["Halleux"]
  },
  {
    "zipcode": "6987",
    "localities": ["Marcourt"]
  },
  {
    "zipcode": "6987",
    "localities": ["RENDEUX"]
  },
  {
    "zipcode": "6987",
    "localities": ["Hodister"]
  },
  {
    "zipcode": "6987",
    "localities": ["Beffe"]
  },
  {
    "zipcode": "6990",
    "localities": ["Hampteau"]
  },
  {
    "zipcode": "6990",
    "localities": ["Marenne"]
  },
  {
    "zipcode": "6990",
    "localities": ["HOTTON"]
  },
  {
    "zipcode": "6990",
    "localities": ["Fronville"]
  },
  {
    "zipcode": "6997",
    "localities": ["Mormont"]
  },
  {
    "zipcode": "6997",
    "localities": ["EREZÉE"]
  },
  {
    "zipcode": "6997",
    "localities": ["Soy"]
  },
  {
    "zipcode": "6997",
    "localities": ["Amonines"]
  },
  {
    "zipcode": "7000",
    "localities": ["MONS"]
  },
  {
    "zipcode": "7010",
    "localities": ["SHAPE"]
  },
  {
    "zipcode": "7011",
    "localities": ["Ghlin"]
  },
  {
    "zipcode": "7012",
    "localities": ["Jemappes"]
  },
  {
    "zipcode": "7012",
    "localities": ["Flénu"]
  },
  {
    "zipcode": "7020",
    "localities": ["Maisières"]
  },
  {
    "zipcode": "7020",
    "localities": ["Nimy"]
  },
  {
    "zipcode": "7021",
    "localities": ["Havré"]
  },
  {
    "zipcode": "7022",
    "localities": ["Harmignies"]
  },
  {
    "zipcode": "7022",
    "localities": ["Hyon"]
  },
  {
    "zipcode": "7022",
    "localities": ["Mesvin"]
  },
  {
    "zipcode": "7022",
    "localities": ["Nouvelles"]
  },
  {
    "zipcode": "7022",
    "localities": ["Harveng"]
  },
  {
    "zipcode": "7024",
    "localities": ["Ciply"]
  },
  {
    "zipcode": "7030",
    "localities": ["Saint-Symphorien"]
  },
  {
    "zipcode": "7031",
    "localities": ["Villers-Saint-Ghislain"]
  },
  {
    "zipcode": "7032",
    "localities": ["Spiennes"]
  },
  {
    "zipcode": "7033",
    "localities": ["Cuesmes"]
  },
  {
    "zipcode": "7034",
    "localities": ["Saint-Denis"]
  },
  {
    "zipcode": "7034",
    "localities": ["Obourg"]
  },
  {
    "zipcode": "7040",
    "localities": ["Quévy-Le-Grand"]
  },
  {
    "zipcode": "7040",
    "localities": ["Aulnois"]
  },
  {
    "zipcode": "7040",
    "localities": ["QUÉVY"]
  },
  {
    "zipcode": "7040",
    "localities": ["Asquillies"]
  },
  {
    "zipcode": "7040",
    "localities": ["Goegnies-Chaussée"]
  },
  {
    "zipcode": "7040",
    "localities": ["Blaregnies"]
  },
  {
    "zipcode": "7040",
    "localities": ["Genly"]
  },
  {
    "zipcode": "7040",
    "localities": ["Bougnies"]
  },
  {
    "zipcode": "7040",
    "localities": ["Quévy-Le-Petit"]
  },
  {
    "zipcode": "7041",
    "localities": ["Givry"]
  },
  {
    "zipcode": "7041",
    "localities": ["Havay"]
  },
  {
    "zipcode": "7050",
    "localities": ["Erbisoeul"]
  },
  {
    "zipcode": "7050",
    "localities": ["Herchies"]
  },
  {
    "zipcode": "7050",
    "localities": ["Masnuy-Saint-Jean"]
  },
  {
    "zipcode": "7050",
    "localities": ["Erbaut"]
  },
  {
    "zipcode": "7050",
    "localities": ["JURBISE"]
  },
  {
    "zipcode": "7050",
    "localities": ["Masnuy-Saint-Pierre"]
  },
  {
    "zipcode": "7060",
    "localities": ["Horrues"]
  },
  {
    "zipcode": "7060",
    "localities": ["SOIGNIES"]
  },
  {
    "zipcode": "7061",
    "localities": ["Thieusies"]
  },
  {
    "zipcode": "7061",
    "localities": ["Casteau"]
  },
  {
    "zipcode": "7062",
    "localities": ["Naast"]
  },
  {
    "zipcode": "7063",
    "localities": ["Chaussée-Notre-Dame-Louvignies"]
  },
  {
    "zipcode": "7063",
    "localities": ["Neufvilles"]
  },
  {
    "zipcode": "7070",
    "localities": ["Gottignies"]
  },
  {
    "zipcode": "7070",
    "localities": ["Mignault"]
  },
  {
    "zipcode": "7070",
    "localities": ["Ville-Sur-Haine"]
  },
  {
    "zipcode": "7070",
    "localities": ["Thieu"]
  },
  {
    "zipcode": "7070",
    "localities": ["LE ROEULX"]
  },
  {
    "zipcode": "7080",
    "localities": ["Eugies"]
  },
  {
    "zipcode": "7080",
    "localities": ["Sars-La-Bruyère"]
  },
  {
    "zipcode": "7080",
    "localities": ["Noirchain"]
  },
  {
    "zipcode": "7080",
    "localities": ["La Bouverie"]
  },
  {
    "zipcode": "7080",
    "localities": ["FRAMERIES"]
  },
  {
    "zipcode": "7090",
    "localities": ["Hennuyères"]
  },
  {
    "zipcode": "7090",
    "localities": ["Petit-Roeulx-Lez-Braine"]
  },
  {
    "zipcode": "7090",
    "localities": ["Steenkerque"]
  },
  {
    "zipcode": "7090",
    "localities": ["Ronquières"]
  },
  {
    "zipcode": "7090",
    "localities": ["Henripont"]
  },
  {
    "zipcode": "7090",
    "localities": ["BRAINE-LE-COMTE"]
  },
  {
    "zipcode": "7100",
    "localities": ["Trivières"]
  },
  {
    "zipcode": "7100",
    "localities": ["LA LOUVIÈRE"]
  },
  {
    "zipcode": "7100",
    "localities": ["Haine-Saint-Pierre"]
  },
  {
    "zipcode": "7100",
    "localities": ["Saint-Vaast"]
  },
  {
    "zipcode": "7100",
    "localities": ["Haine-Saint-Paul"]
  },
  {
    "zipcode": "7110",
    "localities": ["Houdeng-Goegnies"]
  },
  {
    "zipcode": "7110",
    "localities": ["Boussoit"]
  },
  {
    "zipcode": "7110",
    "localities": ["Strépy-Bracquegnies"]
  },
  {
    "zipcode": "7110",
    "localities": ["Houdeng-Aimeries"]
  },
  {
    "zipcode": "7110",
    "localities": ["Maurage"]
  },
  {
    "zipcode": "7120",
    "localities": ["Croix-Lez-Rouveroy"]
  },
  {
    "zipcode": "7120",
    "localities": ["ESTINNES"]
  },
  {
    "zipcode": "7120",
    "localities": ["Fauroeulx"]
  },
  {
    "zipcode": "7120",
    "localities": ["Peissant"]
  },
  {
    "zipcode": "7120",
    "localities": ["Rouveroy"]
  },
  {
    "zipcode": "7120",
    "localities": ["Haulchin"]
  },
  {
    "zipcode": "7120",
    "localities": ["Vellereille-Le-Sec"]
  },
  {
    "zipcode": "7120",
    "localities": ["Estinnes-Au-Val"]
  },
  {
    "zipcode": "7120",
    "localities": ["Estinnes-Au-Mont"]
  },
  {
    "zipcode": "7120",
    "localities": ["Vellereille-Les-Brayeux"]
  },
  {
    "zipcode": "7130",
    "localities": ["BINCHE"]
  },
  {
    "zipcode": "7130",
    "localities": ["Battignies"]
  },
  {
    "zipcode": "7130",
    "localities": ["Bray"]
  },
  {
    "zipcode": "7131",
    "localities": ["Waudrez"]
  },
  {
    "zipcode": "7133",
    "localities": ["vrinnes"]
  },
  {
    "zipcode": "7134",
    "localities": ["ronnes-Lez-Binche"]
  },
  {
    "zipcode": "7134",
    "localities": ["ssaix"]
  },
  {
    "zipcode": "7134",
    "localities": ["val-Trahegnies"]
  },
  {
    "zipcode": "7134",
    "localities": ["inois"]
  },
  {
    "zipcode": "7140",
    "localities": ["rlanwelz-Mariemont"]
  },
  {
    "zipcode": "7140",
    "localities": ["RLANWELZ"]
  },
  {
    "zipcode": "7141",
    "localities": ["rnières"]
  },
  {
    "zipcode": "7141",
    "localities": ["nt-Sainte-Aldegonde"]
  },
  {
    "zipcode": "7160",
    "localities": ["éton"]
  },
  {
    "zipcode": "7160",
    "localities": ["APELLE-LEZ-HERLAIMONT"]
  },
  {
    "zipcode": "7160",
    "localities": ["darville"]
  },
  {
    "zipcode": "7170",
    "localities": ["NAGE"]
  },
  {
    "zipcode": "7170",
    "localities": ["is-D'Haine"]
  },
  {
    "zipcode": "7170",
    "localities": ["yt-Lez-Manage"]
  },
  {
    "zipcode": "7170",
    "localities": ["llecourt"]
  },
  {
    "zipcode": "7170",
    "localities": [" Hestre"]
  },
  {
    "zipcode": "7180",
    "localities": ["NEFFE"]
  },
  {
    "zipcode": "7181",
    "localities": ["tit-Roeulx-Lez-Nivelles"]
  },
  {
    "zipcode": "7181",
    "localities": ["luy"]
  },
  {
    "zipcode": "7181",
    "localities": ["milleureux"]
  },
  {
    "zipcode": "7181",
    "localities": ["quennes"]
  },
  {
    "zipcode": "7190",
    "localities": ["AUSSINNES"]
  },
  {
    "zipcode": "7190",
    "localities": ["rche-Lez-Ecaussinnes"]
  },
  {
    "zipcode": "7190",
    "localities": ["aussinnes-D'Enghien"]
  },
  {
    "zipcode": "7191",
    "localities": ["aussinnes-Lalaing"]
  },
  {
    "zipcode": "7300",
    "localities": ["USSU"]
  },
  {
    "zipcode": "7301",
    "localities": ["rnu"]
  },
  {
    "zipcode": "7320",
    "localities": ["RNISSART"]
  },
  {
    "zipcode": "7321",
    "localities": ["rchies"]
  },
  {
    "zipcode": "7321",
    "localities": ["aton"]
  },
  {
    "zipcode": "7322",
    "localities": ["mmeroeul"]
  },
  {
    "zipcode": "7322",
    "localities": ["lle-Pommeroeul"]
  },
  {
    "zipcode": "7330",
    "localities": ["INT-GHISLAIN"]
  },
  {
    "zipcode": "7331",
    "localities": ["udour"]
  },
  {
    "zipcode": "7332",
    "localities": ["ufmaison"]
  },
  {
    "zipcode": "7332",
    "localities": ["rault"]
  },
  {
    "zipcode": "7333",
    "localities": ["rtre"]
  },
  {
    "zipcode": "7334",
    "localities": ["utrage"]
  },
  {
    "zipcode": "7334",
    "localities": ["llerot"]
  },
  {
    "zipcode": "7340",
    "localities": ["turages"]
  },
  {
    "zipcode": "7340",
    "localities": ["LFONTAINE"]
  },
  {
    "zipcode": "7340",
    "localities": ["smes"]
  },
  {
    "zipcode": "7340",
    "localities": ["rquignies"]
  },
  {
    "zipcode": "7350",
    "localities": ["NSIES"]
  },
  {
    "zipcode": "7350",
    "localities": ["ntroeul-Sur-Haine"]
  },
  {
    "zipcode": "7350",
    "localities": ["ulin"]
  },
  {
    "zipcode": "7350",
    "localities": ["inin"]
  },
  {
    "zipcode": "7370",
    "localities": ["héries"]
  },
  {
    "zipcode": "7370",
    "localities": ["augies"]
  },
  {
    "zipcode": "7370",
    "localities": ["UR"]
  },
  {
    "zipcode": "7370",
    "localities": ["ouges"]
  },
  {
    "zipcode": "7380",
    "localities": ["isieux"]
  },
  {
    "zipcode": "7380",
    "localities": ["IÉVRAIN"]
  },
  {
    "zipcode": "7382",
    "localities": ["dregnies"]
  },
  {
    "zipcode": "7387",
    "localities": ["treppe"]
  },
  {
    "zipcode": "7387",
    "localities": ["ntignies-Sur-Roc"]
  },
  {
    "zipcode": "7387",
    "localities": ["isin"]
  },
  {
    "zipcode": "7387",
    "localities": ["quennes"]
  },
  {
    "zipcode": "7387",
    "localities": ["greau"]
  },
  {
    "zipcode": "7387",
    "localities": ["yt-Le-Franc"]
  },
  {
    "zipcode": "7387",
    "localities": ["his"]
  },
  {
    "zipcode": "7387",
    "localities": ["nezies"]
  },
  {
    "zipcode": "7387",
    "localities": ["NNELLES"]
  },
  {
    "zipcode": "7387",
    "localities": ["gre"]
  },
  {
    "zipcode": "7387",
    "localities": ["rchipont"]
  },
  {
    "zipcode": "7390",
    "localities": ["smuel"]
  },
  {
    "zipcode": "7390",
    "localities": ["AREGNON"]
  },
  {
    "zipcode": "7500",
    "localities": ["e"]
  },
  {
    "zipcode": "7500",
    "localities": ["URNAI"]
  },
  {
    "zipcode": "7500",
    "localities": ["int-Maur"]
  },
  {
    "zipcode": "7501",
    "localities": ["cq"]
  },
  {
    "zipcode": "7502",
    "localities": ["plechin"]
  },
  {
    "zipcode": "7503",
    "localities": ["oyennes"]
  },
  {
    "zipcode": "7504",
    "localities": ["oidmont"]
  },
  {
    "zipcode": "7506",
    "localities": ["llemeau"]
  },
  {
    "zipcode": "7510",
    "localities": ["Suisses"]
  },
  {
    "zipcode": "7511",
    "localities": ["trine Magique"]
  },
  {
    "zipcode": "7512",
    "localities": ["es Rocher"]
  },
  {
    "zipcode": "7513",
    "localities": ["es Rocher"]
  },
  {
    "zipcode": "7520",
    "localities": ["mpleuve"]
  },
  {
    "zipcode": "7520",
    "localities": ["megnies-Chin"]
  },
  {
    "zipcode": "7521",
    "localities": ["ercq"]
  },
  {
    "zipcode": "7522",
    "localities": ["rquain"]
  },
  {
    "zipcode": "7522",
    "localities": ["rtain"]
  },
  {
    "zipcode": "7522",
    "localities": ["main"]
  },
  {
    "zipcode": "7522",
    "localities": ["andain"]
  },
  {
    "zipcode": "7530",
    "localities": ["urain-Ramecroix"]
  },
  {
    "zipcode": "7531",
    "localities": ["vinnes"]
  },
  {
    "zipcode": "7532",
    "localities": ["clers"]
  },
  {
    "zipcode": "7533",
    "localities": ["imougies"]
  },
  {
    "zipcode": "7534",
    "localities": ["rry"]
  },
  {
    "zipcode": "7534",
    "localities": ["ulde"]
  },
  {
    "zipcode": "7536",
    "localities": ["ulx"]
  },
  {
    "zipcode": "7538",
    "localities": ["zon"]
  },
  {
    "zipcode": "7540",
    "localities": ["in"]
  },
  {
    "zipcode": "7540",
    "localities": ["artes"]
  },
  {
    "zipcode": "7540",
    "localities": ["millies"]
  },
  {
    "zipcode": "7540",
    "localities": ["lles"]
  },
  {
    "zipcode": "7542",
    "localities": ["nt-Saint-Aubert"]
  },
  {
    "zipcode": "7543",
    "localities": ["urcourt"]
  },
  {
    "zipcode": "7548",
    "localities": ["rchin"]
  },
  {
    "zipcode": "7600",
    "localities": ["RUWELZ"]
  },
  {
    "zipcode": "7601",
    "localities": ["ucourt"]
  },
  {
    "zipcode": "7602",
    "localities": ["ry"]
  },
  {
    "zipcode": "7603",
    "localities": ["n-Secours"]
  },
  {
    "zipcode": "7604",
    "localities": ["smes-Audemez-Briffoeil"]
  },
  {
    "zipcode": "7604",
    "localities": ["ugnies"]
  },
  {
    "zipcode": "7604",
    "localities": ["affe"]
  },
  {
    "zipcode": "7604",
    "localities": ["asménil"]
  },
  {
    "zipcode": "7604",
    "localities": ["llenelle"]
  },
  {
    "zipcode": "7608",
    "localities": ["ers"]
  },
  {
    "zipcode": "7610",
    "localities": ["MES"]
  },
  {
    "zipcode": "7611",
    "localities": [" Glanerie"]
  },
  {
    "zipcode": "7618",
    "localities": ["intignies"]
  },
  {
    "zipcode": "7620",
    "localities": ["UNEHAUT"]
  },
  {
    "zipcode": "7620",
    "localities": ["ignies"]
  },
  {
    "zipcode": "7620",
    "localities": ["llain-Merlin"]
  },
  {
    "zipcode": "7620",
    "localities": ["éharies"]
  },
  {
    "zipcode": "7620",
    "localities": ["z-Velvain"]
  },
  {
    "zipcode": "7620",
    "localities": ["llain"]
  },
  {
    "zipcode": "7621",
    "localities": ["sdain"]
  },
  {
    "zipcode": "7622",
    "localities": ["plaigne"]
  },
  {
    "zipcode": "7623",
    "localities": ["ngy"]
  },
  {
    "zipcode": "7624",
    "localities": ["wardries"]
  },
  {
    "zipcode": "7640",
    "localities": ["TOING"]
  },
  {
    "zipcode": "7640",
    "localities": ["ubray"]
  },
  {
    "zipcode": "7640",
    "localities": ["ronnes-Lez-Antoing"]
  },
  {
    "zipcode": "7641",
    "localities": ["uyelle"]
  },
  {
    "zipcode": "7642",
    "localities": ["lonne"]
  },
  {
    "zipcode": "7643",
    "localities": ["ntenoy"]
  },
  {
    "zipcode": "7700",
    "localities": ["USCRON"]
  },
  {
    "zipcode": "7700",
    "localities": ["ingne"]
  },
  {
    "zipcode": "7711",
    "localities": ["ttignies"]
  },
  {
    "zipcode": "7712",
    "localities": ["rseaux"]
  },
  {
    "zipcode": "7730",
    "localities": ["int-Léger"]
  },
  {
    "zipcode": "7730",
    "localities": ["taimbourg"]
  },
  {
    "zipcode": "7730",
    "localities": ["ers-Nord"]
  },
  {
    "zipcode": "7730",
    "localities": ["TAIMPUIS"]
  },
  {
    "zipcode": "7730",
    "localities": ["regnies"]
  },
  {
    "zipcode": "7730",
    "localities": ["illeul"]
  },
  {
    "zipcode": "7730",
    "localities": ["chin"]
  },
  {
    "zipcode": "7740",
    "localities": ["rcoing"]
  },
  {
    "zipcode": "7740",
    "localities": ["CQ"]
  },
  {
    "zipcode": "7742",
    "localities": ["rinnes-Lez-Pecq"]
  },
  {
    "zipcode": "7743",
    "localities": ["igies"]
  },
  {
    "zipcode": "7743",
    "localities": ["quelmes"]
  },
  {
    "zipcode": "7750",
    "localities": ["sseignies"]
  },
  {
    "zipcode": "7750",
    "localities": ["roir"]
  },
  {
    "zipcode": "7750",
    "localities": ["seroeul"]
  },
  {
    "zipcode": "7750",
    "localities": ["NT-DE-L'ENCLUS"]
  },
  {
    "zipcode": "7750",
    "localities": ["ougies"]
  },
  {
    "zipcode": "7760",
    "localities": ["ttes"]
  },
  {
    "zipcode": "7760",
    "localities": ["lenbaix"]
  },
  {
    "zipcode": "7760",
    "localities": ["laines"]
  },
  {
    "zipcode": "7760",
    "localities": ["puelles"]
  },
  {
    "zipcode": "7760",
    "localities": ["LLES"]
  },
  {
    "zipcode": "7760",
    "localities": ["canaffles"]
  },
  {
    "zipcode": "7780",
    "localities": ["mines"]
  },
  {
    "zipcode": "7780",
    "localities": ["MINES-WARNETON"]
  },
  {
    "zipcode": "7781",
    "localities": ["uthem"]
  },
  {
    "zipcode": "7782",
    "localities": ["oegsteert"]
  },
  {
    "zipcode": "7783",
    "localities": ["zet"]
  },
  {
    "zipcode": "7784",
    "localities": ["s-Warneton"]
  },
  {
    "zipcode": "7784",
    "localities": ["rneton"]
  },
  {
    "zipcode": "7800",
    "localities": ["nquesaint"]
  },
  {
    "zipcode": "7800",
    "localities": ["H"]
  },
  {
    "zipcode": "7801",
    "localities": ["chonwelz"]
  },
  {
    "zipcode": "7802",
    "localities": ["meignies"]
  },
  {
    "zipcode": "7803",
    "localities": ["uvignies"]
  },
  {
    "zipcode": "7804",
    "localities": ["baix"]
  },
  {
    "zipcode": "7804",
    "localities": ["tiches"]
  },
  {
    "zipcode": "7810",
    "localities": ["ffle"]
  },
  {
    "zipcode": "7811",
    "localities": ["bre"]
  },
  {
    "zipcode": "7812",
    "localities": ["ulbaix"]
  },
  {
    "zipcode": "7812",
    "localities": ["llers-Notre-Dame"]
  },
  {
    "zipcode": "7812",
    "localities": ["gne"]
  },
  {
    "zipcode": "7812",
    "localities": ["utaing"]
  },
  {
    "zipcode": "7812",
    "localities": ["invault"]
  },
  {
    "zipcode": "7812",
    "localities": ["llers-Saint-Amand"]
  },
  {
    "zipcode": "7822",
    "localities": ["slin-L'Evêque"]
  },
  {
    "zipcode": "7822",
    "localities": ["ières"]
  },
  {
    "zipcode": "7822",
    "localities": ["islenghien"]
  },
  {
    "zipcode": "7823",
    "localities": ["becq"]
  },
  {
    "zipcode": "7830",
    "localities": ["ndregnies"]
  },
  {
    "zipcode": "7830",
    "localities": ["aty"]
  },
  {
    "zipcode": "7830",
    "localities": ["llebecq"]
  },
  {
    "zipcode": "7830",
    "localities": ["ves"]
  },
  {
    "zipcode": "7830",
    "localities": ["oricourt"]
  },
  {
    "zipcode": "7830",
    "localities": ["ssilly"]
  },
  {
    "zipcode": "7830",
    "localities": ["uleng"]
  },
  {
    "zipcode": "7830",
    "localities": ["LLY"]
  },
  {
    "zipcode": "7850",
    "localities": ["GHIEN"]
  },
  {
    "zipcode": "7850",
    "localities": ["tit-Enghien"]
  },
  {
    "zipcode": "7850",
    "localities": ["rcq"]
  },
  {
    "zipcode": "7860",
    "localities": ["SSINES"]
  },
  {
    "zipcode": "7861",
    "localities": ["pignies"]
  },
  {
    "zipcode": "7861",
    "localities": ["nnebecq"]
  },
  {
    "zipcode": "7862",
    "localities": ["y"]
  },
  {
    "zipcode": "7863",
    "localities": ["oy"]
  },
  {
    "zipcode": "7864",
    "localities": ["ux-Acren"]
  },
  {
    "zipcode": "7866",
    "localities": ["lignies"]
  },
  {
    "zipcode": "7866",
    "localities": ["is-De-Lessines"]
  },
  {
    "zipcode": "7870",
    "localities": ["NS"]
  },
  {
    "zipcode": "7870",
    "localities": ["mbise"]
  },
  {
    "zipcode": "7870",
    "localities": ["ntignies-Lez-Lens"]
  },
  {
    "zipcode": "7870",
    "localities": ["mbron-Saint-Vincent"]
  },
  {
    "zipcode": "7870",
    "localities": ["uffe"]
  },
  {
    "zipcode": "7880",
    "localities": ["OBECQ"]
  },
  {
    "zipcode": "7890",
    "localities": ["LEZELLES"]
  },
  {
    "zipcode": "7890",
    "localities": ["decq"]
  },
  {
    "zipcode": "7890",
    "localities": ["hamaide"]
  },
  {
    "zipcode": "7900",
    "localities": ["andmetz"]
  },
  {
    "zipcode": "7900",
    "localities": ["UZE-EN-HAINAUT"]
  },
  {
    "zipcode": "7901",
    "localities": ["ieulain"]
  },
  {
    "zipcode": "7903",
    "localities": ["apelle-À-Wattines"]
  },
  {
    "zipcode": "7903",
    "localities": ["icquy"]
  },
  {
    "zipcode": "7903",
    "localities": ["apelle-À-Oie"]
  },
  {
    "zipcode": "7904",
    "localities": ["llaupuis"]
  },
  {
    "zipcode": "7904",
    "localities": ["urpes"]
  },
  {
    "zipcode": "7904",
    "localities": ["paix"]
  },
  {
    "zipcode": "7906",
    "localities": ["llaix"]
  },
  {
    "zipcode": "7910",
    "localities": ["lignies-Lez-Frasnes"]
  },
  {
    "zipcode": "7910",
    "localities": ["rest"]
  },
  {
    "zipcode": "7910",
    "localities": ["c-Wattripont"]
  },
  {
    "zipcode": "7910",
    "localities": ["rdes"]
  },
  {
    "zipcode": "7910",
    "localities": ["vaing"]
  },
  {
    "zipcode": "7910",
    "localities": ["ASNES-LEZ-ANVAING"]
  },
  {
    "zipcode": "7910",
    "localities": ["c-Ainières"]
  },
  {
    "zipcode": "7910",
    "localities": ["ttripont"]
  },
  {
    "zipcode": "7911",
    "localities": ["udeghien"]
  },
  {
    "zipcode": "7911",
    "localities": ["asnes-Lez-Buissenal"]
  },
  {
    "zipcode": "7911",
    "localities": ["cquegnies"]
  },
  {
    "zipcode": "7911",
    "localities": ["rquegies"]
  },
  {
    "zipcode": "7911",
    "localities": ["ntroeul-Au-Bois"]
  },
  {
    "zipcode": "7911",
    "localities": ["ustier"]
  },
  {
    "zipcode": "7911",
    "localities": ["issenal"]
  },
  {
    "zipcode": "7912",
    "localities": ["rgneau"]
  },
  {
    "zipcode": "7912",
    "localities": ["int-Sauveur"]
  },
  {
    "zipcode": "7940",
    "localities": ["mbron-Casteau"]
  },
  {
    "zipcode": "7940",
    "localities": ["UGELETTE"]
  },
  {
    "zipcode": "7941",
    "localities": ["tre"]
  },
  {
    "zipcode": "7942",
    "localities": ["vergnies-Lez-Lens"]
  },
  {
    "zipcode": "7943",
    "localities": ["ges"]
  },
  {
    "zipcode": "7950",
    "localities": ["osage"]
  },
  {
    "zipcode": "7950",
    "localities": ["deuze"]
  },
  {
    "zipcode": "7950",
    "localities": ["IÈVRES"]
  },
  {
    "zipcode": "7950",
    "localities": ["issignies"]
  },
  {
    "zipcode": "7950",
    "localities": ["ngre-Saint-Martin"]
  },
  {
    "zipcode": "7951",
    "localities": ["ngre-Notre-Dame"]
  },
  {
    "zipcode": "7970",
    "localities": ["LOEIL"]
  },
  {
    "zipcode": "7971",
    "localities": ["umaide"]
  },
  {
    "zipcode": "7971",
    "localities": ["delincourt"]
  },
  {
    "zipcode": "7971",
    "localities": ["sècles"]
  },
  {
    "zipcode": "7971",
    "localities": ["megnies"]
  },
  {
    "zipcode": "7972",
    "localities": ["bechies"]
  },
  {
    "zipcode": "7972",
    "localities": ["evaucamps"]
  },
  {
    "zipcode": "7972",
    "localities": ["lignies-Sainte-Anne"]
  },
  {
    "zipcode": "7973",
    "localities": ["andglise"]
  },
  {
    "zipcode": "7973",
    "localities": ["ambruges"]
  },
  {
    "zipcode": "8000",
    "localities": ["UGGE"]
  },
  {
    "zipcode": "8000",
    "localities": ["olkerke"]
  },
  {
    "zipcode": "8020",
    "localities": ["ardamme"]
  },
  {
    "zipcode": "8020",
    "localities": ["ddervoorde"]
  },
  {
    "zipcode": "8020",
    "localities": ["STKAMP"]
  },
  {
    "zipcode": "8020",
    "localities": ["rtsberge"]
  },
  {
    "zipcode": "8200",
    "localities": ["nt-Andries"]
  },
  {
    "zipcode": "8200",
    "localities": ["nt-Michiels"]
  },
  {
    "zipcode": "8210",
    "localities": ["DELGEM"]
  },
  {
    "zipcode": "8210",
    "localities": ["ppem"]
  },
  {
    "zipcode": "8210",
    "localities": ["ldegem"]
  },
  {
    "zipcode": "8211",
    "localities": ["rtrijke"]
  },
  {
    "zipcode": "8300",
    "localities": ["stkapelle"]
  },
  {
    "zipcode": "8300",
    "localities": ["okke"]
  },
  {
    "zipcode": "8300",
    "localities": ["OKKE-HEIST"]
  },
  {
    "zipcode": "8301",
    "localities": ["ist-Aan-Zee"]
  },
  {
    "zipcode": "8301",
    "localities": ["mskapelle"]
  },
  {
    "zipcode": "8310",
    "localities": ["nt-Kruis"]
  },
  {
    "zipcode": "8310",
    "localities": ["sebroek"]
  },
  {
    "zipcode": "8340",
    "localities": ["erkerke"]
  },
  {
    "zipcode": "8340",
    "localities": ["eke"]
  },
  {
    "zipcode": "8340",
    "localities": ["jsele"]
  },
  {
    "zipcode": "8340",
    "localities": ["MME"]
  },
  {
    "zipcode": "8340",
    "localities": ["pscheure"]
  },
  {
    "zipcode": "8340",
    "localities": ["stkerke"]
  },
  {
    "zipcode": "8370",
    "localities": ["ANKENBERGE"]
  },
  {
    "zipcode": "8370",
    "localities": ["tkerke"]
  },
  {
    "zipcode": "8377",
    "localities": ["utave"]
  },
  {
    "zipcode": "8377",
    "localities": ["etkerke"]
  },
  {
    "zipcode": "8377",
    "localities": ["euwmunster"]
  },
  {
    "zipcode": "8377",
    "localities": ["IENKERKE"]
  },
  {
    "zipcode": "8380",
    "localities": ["ebrugge"]
  },
  {
    "zipcode": "8380",
    "localities": ["dzele"]
  },
  {
    "zipcode": "8380",
    "localities": ["ssewege"]
  },
  {
    "zipcode": "8400",
    "localities": ["ndvoorde"]
  },
  {
    "zipcode": "8400",
    "localities": ["ene"]
  },
  {
    "zipcode": "8400",
    "localities": ["STENDE"]
  },
  {
    "zipcode": "8420",
    "localities": [" HAAN"]
  },
  {
    "zipcode": "8420",
    "localities": ["emskerke"]
  },
  {
    "zipcode": "8420",
    "localities": ["nduine"]
  },
  {
    "zipcode": "8421",
    "localities": ["issegem"]
  },
  {
    "zipcode": "8430",
    "localities": ["DDELKERKE"]
  },
  {
    "zipcode": "8431",
    "localities": ["lskerke"]
  },
  {
    "zipcode": "8432",
    "localities": ["ffinge"]
  },
  {
    "zipcode": "8433",
    "localities": ["nnekensvere"]
  },
  {
    "zipcode": "8433",
    "localities": ["ijpe"]
  },
  {
    "zipcode": "8433",
    "localities": ["nt-Pieters-Kapelle"]
  },
  {
    "zipcode": "8433",
    "localities": ["hore"]
  },
  {
    "zipcode": "8434",
    "localities": ["mbardsijde"]
  },
  {
    "zipcode": "8434",
    "localities": ["stende"]
  },
  {
    "zipcode": "8450",
    "localities": ["EDENE"]
  },
  {
    "zipcode": "8460",
    "localities": ["stkerke"]
  },
  {
    "zipcode": "8460",
    "localities": ["ksem"]
  },
  {
    "zipcode": "8460",
    "localities": ["telgem"]
  },
  {
    "zipcode": "8460",
    "localities": ["DENBURG"]
  },
  {
    "zipcode": "8470",
    "localities": ["STEL"]
  },
  {
    "zipcode": "8470",
    "localities": ["aaskerke"]
  },
  {
    "zipcode": "8470",
    "localities": ["vekote"]
  },
  {
    "zipcode": "8470",
    "localities": ["ere"]
  },
  {
    "zipcode": "8480",
    "localities": ["kegem"]
  },
  {
    "zipcode": "8480",
    "localities": ["HTEGEM"]
  },
  {
    "zipcode": "8480",
    "localities": ["rnegem"]
  },
  {
    "zipcode": "8490",
    "localities": ["BBEKE"]
  },
  {
    "zipcode": "8490",
    "localities": ["alhille"]
  },
  {
    "zipcode": "8490",
    "localities": ["rkegem"]
  },
  {
    "zipcode": "8490",
    "localities": ["ellegem"]
  },
  {
    "zipcode": "8490",
    "localities": ["rsenare"]
  },
  {
    "zipcode": "8500",
    "localities": ["RTRIJK"]
  },
  {
    "zipcode": "8501",
    "localities": ["ule"]
  },
  {
    "zipcode": "8501",
    "localities": ["ssegem"]
  },
  {
    "zipcode": "8510",
    "localities": ["oigem"]
  },
  {
    "zipcode": "8510",
    "localities": ["llegem"]
  },
  {
    "zipcode": "8510",
    "localities": ["rke"]
  },
  {
    "zipcode": "8510",
    "localities": ["llegem"]
  },
  {
    "zipcode": "8511",
    "localities": ["lbeke"]
  },
  {
    "zipcode": "8520",
    "localities": ["URNE"]
  },
  {
    "zipcode": "8530",
    "localities": ["RELBEKE"]
  },
  {
    "zipcode": "8531",
    "localities": ["vikhove"]
  },
  {
    "zipcode": "8531",
    "localities": ["lste"]
  },
  {
    "zipcode": "8540",
    "localities": ["ERLIJK"]
  },
  {
    "zipcode": "8550",
    "localities": ["EVEGEM"]
  },
  {
    "zipcode": "8551",
    "localities": ["estert"]
  },
  {
    "zipcode": "8552",
    "localities": ["en"]
  },
  {
    "zipcode": "8553",
    "localities": ["egem"]
  },
  {
    "zipcode": "8554",
    "localities": ["nt-Denijs"]
  },
  {
    "zipcode": "8560",
    "localities": ["orsele"]
  },
  {
    "zipcode": "8560",
    "localities": ["llegem"]
  },
  {
    "zipcode": "8560",
    "localities": ["VELGEM"]
  },
  {
    "zipcode": "8570",
    "localities": ["ZEGEM"]
  },
  {
    "zipcode": "8570",
    "localities": ["chte"]
  },
  {
    "zipcode": "8570",
    "localities": ["jzelbrechtegem"]
  },
  {
    "zipcode": "8570",
    "localities": ["gooigem"]
  },
  {
    "zipcode": "8572",
    "localities": ["ster"]
  },
  {
    "zipcode": "8573",
    "localities": ["egem"]
  },
  {
    "zipcode": "8580",
    "localities": ["ELGEM"]
  },
  {
    "zipcode": "8581",
    "localities": ["rkhove"]
  },
  {
    "zipcode": "8581",
    "localities": ["armaarde"]
  },
  {
    "zipcode": "8582",
    "localities": ["trijve"]
  },
  {
    "zipcode": "8583",
    "localities": ["ssuit"]
  },
  {
    "zipcode": "8587",
    "localities": ["pierres"]
  },
  {
    "zipcode": "8587",
    "localities": ["PIERRES-HELCHIN"]
  },
  {
    "zipcode": "8587",
    "localities": ["lchin"]
  },
  {
    "zipcode": "8600",
    "localities": ["askerke"]
  },
  {
    "zipcode": "8600",
    "localities": ["adslo"]
  },
  {
    "zipcode": "8600",
    "localities": ["en"]
  },
  {
    "zipcode": "8600",
    "localities": ["nt-Jacobs-Kapelle"]
  },
  {
    "zipcode": "8600",
    "localities": ["KSMUIDE"]
  },
  {
    "zipcode": "8600",
    "localities": ["iem"]
  },
  {
    "zipcode": "8600",
    "localities": ["dekapelle"]
  },
  {
    "zipcode": "8600",
    "localities": ["erst"]
  },
  {
    "zipcode": "8600",
    "localities": ["stkerke"]
  },
  {
    "zipcode": "8600",
    "localities": ["umen"]
  },
  {
    "zipcode": "8600",
    "localities": ["iekapellen"]
  },
  {
    "zipcode": "8600",
    "localities": ["rvijze"]
  },
  {
    "zipcode": "8600",
    "localities": ["euwkapelle"]
  },
  {
    "zipcode": "8600",
    "localities": ["uivekenskerke"]
  },
  {
    "zipcode": "8600",
    "localities": ["mpernisse"]
  },
  {
    "zipcode": "8600",
    "localities": ["ke"]
  },
  {
    "zipcode": "8610",
    "localities": ["rren"]
  },
  {
    "zipcode": "8610",
    "localities": ["ndzame"]
  },
  {
    "zipcode": "8610",
    "localities": ["RTEMARK"]
  },
  {
    "zipcode": "8610",
    "localities": ["rken"]
  },
  {
    "zipcode": "8620",
    "localities": ["nt-Joris"]
  },
  {
    "zipcode": "8620",
    "localities": ["EUWPOORT"]
  },
  {
    "zipcode": "8620",
    "localities": ["mskapelle"]
  },
  {
    "zipcode": "8630",
    "localities": ["lveringem"]
  },
  {
    "zipcode": "8630",
    "localities": ["eenkerke"]
  },
  {
    "zipcode": "8630",
    "localities": ["ekapelle"]
  },
  {
    "zipcode": "8630",
    "localities": ["utem"]
  },
  {
    "zipcode": "8630",
    "localities": ["gewaartskapelle"]
  },
  {
    "zipcode": "8630",
    "localities": ["URNE"]
  },
  {
    "zipcode": "8630",
    "localities": ["nkem"]
  },
  {
    "zipcode": "8630",
    "localities": ["oitshoeke"]
  },
  {
    "zipcode": "8630",
    "localities": ["lskamp"]
  },
  {
    "zipcode": "8630",
    "localities": [" Moeren"]
  },
  {
    "zipcode": "8630",
    "localities": ["utenaaie"]
  },
  {
    "zipcode": "8640",
    "localities": ["esten"]
  },
  {
    "zipcode": "8640",
    "localities": ["stvleteren"]
  },
  {
    "zipcode": "8640",
    "localities": ["ETEREN"]
  },
  {
    "zipcode": "8640",
    "localities": ["stvleteren"]
  },
  {
    "zipcode": "8647",
    "localities": ["-RENINGE"]
  },
  {
    "zipcode": "8647",
    "localities": ["ordschote"]
  },
  {
    "zipcode": "8647",
    "localities": ["llinkhove"]
  },
  {
    "zipcode": "8647",
    "localities": ["ninge"]
  },
  {
    "zipcode": "8647",
    "localities": [""]
  },
  {
    "zipcode": "8650",
    "localities": ["erken"]
  },
  {
    "zipcode": "8650",
    "localities": ["UTHULST"]
  },
  {
    "zipcode": "8650",
    "localities": ["rkem"]
  },
  {
    "zipcode": "8660",
    "localities": ["inkerke"]
  },
  {
    "zipcode": "8660",
    "localities": [" PANNE"]
  },
  {
    "zipcode": "8670",
    "localities": ["stduinkerke"]
  },
  {
    "zipcode": "8670",
    "localities": ["lpen"]
  },
  {
    "zipcode": "8670",
    "localities": ["KSIJDE"]
  },
  {
    "zipcode": "8680",
    "localities": ["nde"]
  },
  {
    "zipcode": "8680",
    "localities": ["vekerke"]
  },
  {
    "zipcode": "8680",
    "localities": ["EKELARE"]
  },
  {
    "zipcode": "8690",
    "localities": ["VERINGEM"]
  },
  {
    "zipcode": "8690",
    "localities": ["ren"]
  },
  {
    "zipcode": "8690",
    "localities": ["ogstade"]
  },
  {
    "zipcode": "8690",
    "localities": ["nt-Rijkers"]
  },
  {
    "zipcode": "8691",
    "localities": ["enberge"]
  },
  {
    "zipcode": "8691",
    "localities": ["avele"]
  },
  {
    "zipcode": "8691",
    "localities": ["veren-Aan-De-Ijzer"]
  },
  {
    "zipcode": "8691",
    "localities": ["jverinkhove"]
  },
  {
    "zipcode": "8691",
    "localities": ["isele"]
  },
  {
    "zipcode": "8700",
    "localities": ["ELT"]
  },
  {
    "zipcode": "8700",
    "localities": ["huiferskapelle"]
  },
  {
    "zipcode": "8700",
    "localities": ["negem"]
  },
  {
    "zipcode": "8700",
    "localities": ["rsele"]
  },
  {
    "zipcode": "8710",
    "localities": ["igem"]
  },
  {
    "zipcode": "8710",
    "localities": ["nt-Baafs-Vijve"]
  },
  {
    "zipcode": "8710",
    "localities": ["ELSBEKE"]
  },
  {
    "zipcode": "8720",
    "localities": ["NTERGEM"]
  },
  {
    "zipcode": "8720",
    "localities": ["kken"]
  },
  {
    "zipcode": "8720",
    "localities": ["selgem"]
  },
  {
    "zipcode": "8720",
    "localities": ["rkegem"]
  },
  {
    "zipcode": "8730",
    "localities": ["nt-Joris"]
  },
  {
    "zipcode": "8730",
    "localities": ["delem"]
  },
  {
    "zipcode": "8730",
    "localities": ["ERNEM"]
  },
  {
    "zipcode": "8740",
    "localities": ["TTEM"]
  },
  {
    "zipcode": "8740",
    "localities": ["em"]
  },
  {
    "zipcode": "8750",
    "localities": ["evezele"]
  },
  {
    "zipcode": "8750",
    "localities": ["NGENE"]
  },
  {
    "zipcode": "8755",
    "localities": ["ISELEDE"]
  },
  {
    "zipcode": "8760",
    "localities": ["ULEBEKE"]
  },
  {
    "zipcode": "8770",
    "localities": ["GELMUNSTER"]
  },
  {
    "zipcode": "8780",
    "localities": ["STROZEBEKE"]
  },
  {
    "zipcode": "8790",
    "localities": ["REGEM"]
  },
  {
    "zipcode": "8791",
    "localities": ["veren"]
  },
  {
    "zipcode": "8792",
    "localities": ["sselgem"]
  },
  {
    "zipcode": "8793",
    "localities": ["nt-Eloois-Vijve"]
  },
  {
    "zipcode": "8800",
    "localities": ["mbeke"]
  },
  {
    "zipcode": "8800",
    "localities": ["kene"]
  },
  {
    "zipcode": "8800",
    "localities": ["ESELARE"]
  },
  {
    "zipcode": "8800",
    "localities": ["veren"]
  },
  {
    "zipcode": "8810",
    "localities": ["CHTERVELDE"]
  },
  {
    "zipcode": "8820",
    "localities": ["RHOUT"]
  },
  {
    "zipcode": "8830",
    "localities": ["OGLEDE"]
  },
  {
    "zipcode": "8830",
    "localities": ["ts"]
  },
  {
    "zipcode": "8840",
    "localities": ["ADEN"]
  },
  {
    "zipcode": "8840",
    "localities": ["stnieuwkerke"]
  },
  {
    "zipcode": "8840",
    "localities": ["strozebeke"]
  },
  {
    "zipcode": "8850",
    "localities": ["DOOIE"]
  },
  {
    "zipcode": "8851",
    "localities": ["olskamp"]
  },
  {
    "zipcode": "8860",
    "localities": ["NDELEDE"]
  },
  {
    "zipcode": "8870",
    "localities": ["chtem"]
  },
  {
    "zipcode": "8870",
    "localities": ["elgem"]
  },
  {
    "zipcode": "8870",
    "localities": ["EGEM"]
  },
  {
    "zipcode": "8880",
    "localities": ["llegem-Kapelle"]
  },
  {
    "zipcode": "8880",
    "localities": ["DEGEM"]
  },
  {
    "zipcode": "8880",
    "localities": ["nt-Eloois-Winkel"]
  },
  {
    "zipcode": "8890",
    "localities": ["ORSLEDE"]
  },
  {
    "zipcode": "8890",
    "localities": ["dizele"]
  },
  {
    "zipcode": "8900",
    "localities": ["PER"]
  },
  {
    "zipcode": "8900",
    "localities": ["nt-Jan"]
  },
  {
    "zipcode": "8900",
    "localities": ["kkebus"]
  },
  {
    "zipcode": "8900",
    "localities": ["ielen"]
  },
  {
    "zipcode": "8902",
    "localities": ["llebeke"]
  },
  {
    "zipcode": "8902",
    "localities": ["ormezele"]
  },
  {
    "zipcode": "8902",
    "localities": ["llebeke"]
  },
  {
    "zipcode": "8904",
    "localities": ["ezinge"]
  },
  {
    "zipcode": "8904",
    "localities": ["idschote"]
  },
  {
    "zipcode": "8906",
    "localities": ["verdinge"]
  },
  {
    "zipcode": "8908",
    "localities": ["amertinge"]
  },
  {
    "zipcode": "8920",
    "localities": ["elkapelle"]
  },
  {
    "zipcode": "8920",
    "localities": ["kschote"]
  },
  {
    "zipcode": "8920",
    "localities": ["ngemark"]
  },
  {
    "zipcode": "8920",
    "localities": ["NGEMARK-POELKAPELLE"]
  },
  {
    "zipcode": "8930",
    "localities": ["NEN"]
  },
  {
    "zipcode": "8930",
    "localities": ["uwe"]
  },
  {
    "zipcode": "8930",
    "localities": ["kkem"]
  },
  {
    "zipcode": "8940",
    "localities": ["RVIK"]
  },
  {
    "zipcode": "8940",
    "localities": ["luwe"]
  },
  {
    "zipcode": "8950",
    "localities": ["UVELLAND"]
  },
  {
    "zipcode": "8950",
    "localities": ["euwkerke"]
  },
  {
    "zipcode": "8951",
    "localities": ["anouter"]
  },
  {
    "zipcode": "8952",
    "localities": ["lvergem"]
  },
  {
    "zipcode": "8953",
    "localities": ["jtschate"]
  },
  {
    "zipcode": "8954",
    "localities": ["stouter"]
  },
  {
    "zipcode": "8956",
    "localities": ["mmel"]
  },
  {
    "zipcode": "8957",
    "localities": ["SSINES"]
  },
  {
    "zipcode": "8958",
    "localities": ["ker"]
  },
  {
    "zipcode": "8970",
    "localities": ["PERINGE"]
  },
  {
    "zipcode": "8970",
    "localities": ["ningelst"]
  },
  {
    "zipcode": "8972",
    "localities": ["esbrugge-Haringe"]
  },
  {
    "zipcode": "8972",
    "localities": ["ombeke"]
  },
  {
    "zipcode": "8972",
    "localities": ["oven"]
  },
  {
    "zipcode": "8978",
    "localities": ["tou"]
  },
  {
    "zipcode": "8980",
    "localities": ["ssendale"]
  },
  {
    "zipcode": "8980",
    "localities": ["ndvoorde"]
  },
  {
    "zipcode": "8980",
    "localities": ["selare"]
  },
  {
    "zipcode": "8980",
    "localities": ["luveld"]
  },
  {
    "zipcode": "8980",
    "localities": ["NNEBEKE"]
  },
  {
    "zipcode": "9000",
    "localities": ["NT"]
  },
  {
    "zipcode": "9030",
    "localities": ["riakerke"]
  },
  {
    "zipcode": "9031",
    "localities": ["ongen"]
  },
  {
    "zipcode": "9032",
    "localities": ["ndelgem"]
  },
  {
    "zipcode": "9040",
    "localities": ["nt-Amandsberg"]
  },
  {
    "zipcode": "9041",
    "localities": ["stakker"]
  },
  {
    "zipcode": "9042",
    "localities": ["nt-Kruis-Winkel"]
  },
  {
    "zipcode": "9042",
    "localities": ["steldonk"]
  },
  {
    "zipcode": "9042",
    "localities": ["ndonk"]
  },
  {
    "zipcode": "9050",
    "localities": ["deberg"]
  },
  {
    "zipcode": "9050",
    "localities": ["ntbrugge"]
  },
  {
    "zipcode": "9051",
    "localities": ["nt-Denijs-Westrem"]
  },
  {
    "zipcode": "9051",
    "localities": ["snee"]
  },
  {
    "zipcode": "9052",
    "localities": ["ijnaarde"]
  },
  {
    "zipcode": "9060",
    "localities": ["LZATE"]
  },
  {
    "zipcode": "9070",
    "localities": ["STELBERGEN"]
  },
  {
    "zipcode": "9070",
    "localities": ["usden"]
  },
  {
    "zipcode": "9075",
    "localities": ["M Gent X"]
  },
  {
    "zipcode": "9080",
    "localities": ["veneken"]
  },
  {
    "zipcode": "9080",
    "localities": ["ffelare"]
  },
  {
    "zipcode": "9080",
    "localities": ["ervelde"]
  },
  {
    "zipcode": "9080",
    "localities": ["CHRISTI"]
  },
  {
    "zipcode": "9090",
    "localities": ["LLE"]
  },
  {
    "zipcode": "9090",
    "localities": ["ntrode"]
  },
  {
    "zipcode": "9099",
    "localities": ["nt X"]
  },
  {
    "zipcode": "9100",
    "localities": ["NT-NIKLAAS"]
  },
  {
    "zipcode": "9100",
    "localities": ["euwkerken-Waas"]
  },
  {
    "zipcode": "9111",
    "localities": ["lsele"]
  },
  {
    "zipcode": "9112",
    "localities": ["naai-Waas"]
  },
  {
    "zipcode": "9120",
    "localities": ["asene"]
  },
  {
    "zipcode": "9120",
    "localities": ["llo"]
  },
  {
    "zipcode": "9120",
    "localities": ["VEREN-WAAS"]
  },
  {
    "zipcode": "9120",
    "localities": ["lsele"]
  },
  {
    "zipcode": "9120",
    "localities": ["asdonk"]
  },
  {
    "zipcode": "9130",
    "localities": ["rrebroek"]
  },
  {
    "zipcode": "9130",
    "localities": ["llo"]
  },
  {
    "zipcode": "9130",
    "localities": ["eldrecht"]
  },
  {
    "zipcode": "9130",
    "localities": ["el"]
  },
  {
    "zipcode": "9140",
    "localities": ["eendorp"]
  },
  {
    "zipcode": "9140",
    "localities": ["versele"]
  },
  {
    "zipcode": "9140",
    "localities": ["MSE"]
  },
  {
    "zipcode": "9140",
    "localities": ["elrode"]
  },
  {
    "zipcode": "9150",
    "localities": ["zel"]
  },
  {
    "zipcode": "9150",
    "localities": ["pelmonde"]
  },
  {
    "zipcode": "9150",
    "localities": ["UIBEKE"]
  },
  {
    "zipcode": "9160",
    "localities": ["knam"]
  },
  {
    "zipcode": "9160",
    "localities": ["KEREN"]
  },
  {
    "zipcode": "9160",
    "localities": ["saarde"]
  },
  {
    "zipcode": "9170",
    "localities": [" Klinge"]
  },
  {
    "zipcode": "9170",
    "localities": ["nt-Pauwels"]
  },
  {
    "zipcode": "9170",
    "localities": ["NT-GILLIS-WAAS"]
  },
  {
    "zipcode": "9170",
    "localities": ["erdonk"]
  },
  {
    "zipcode": "9180",
    "localities": ["ERBEKE-WAAS"]
  },
  {
    "zipcode": "9185",
    "localities": ["CHTEBEKE"]
  },
  {
    "zipcode": "9190",
    "localities": ["EKENE"]
  },
  {
    "zipcode": "9190",
    "localities": ["mzeke"]
  },
  {
    "zipcode": "9200",
    "localities": ["pels"]
  },
  {
    "zipcode": "9200",
    "localities": ["embergen"]
  },
  {
    "zipcode": "9200",
    "localities": ["NDERMONDE"]
  },
  {
    "zipcode": "9200",
    "localities": ["degem"]
  },
  {
    "zipcode": "9200",
    "localities": ["hoonaarde"]
  },
  {
    "zipcode": "9200",
    "localities": ["spelare"]
  },
  {
    "zipcode": "9200",
    "localities": ["nt-Gillis-Dendermonde"]
  },
  {
    "zipcode": "9200",
    "localities": ["asrode"]
  },
  {
    "zipcode": "9220",
    "localities": ["MME"]
  },
  {
    "zipcode": "9220",
    "localities": ["erzeke"]
  },
  {
    "zipcode": "9230",
    "localities": ["strem"]
  },
  {
    "zipcode": "9230",
    "localities": ["TTEREN"]
  },
  {
    "zipcode": "9230",
    "localities": ["ssemen"]
  },
  {
    "zipcode": "9240",
    "localities": ["LE"]
  },
  {
    "zipcode": "9250",
    "localities": ["ASMUNSTER"]
  },
  {
    "zipcode": "9255",
    "localities": ["dorp"]
  },
  {
    "zipcode": "9255",
    "localities": ["GGENHOUT"]
  },
  {
    "zipcode": "9260",
    "localities": ["CHELEN"]
  },
  {
    "zipcode": "9260",
    "localities": ["hellebelle"]
  },
  {
    "zipcode": "9260",
    "localities": ["rskamp"]
  },
  {
    "zipcode": "9270",
    "localities": ["lken"]
  },
  {
    "zipcode": "9270",
    "localities": ["ARNE"]
  },
  {
    "zipcode": "9280",
    "localities": ["BBEKE"]
  },
  {
    "zipcode": "9280",
    "localities": ["nderbelle"]
  },
  {
    "zipcode": "9280",
    "localities": ["eze"]
  },
  {
    "zipcode": "9290",
    "localities": ["tbergen"]
  },
  {
    "zipcode": "9290",
    "localities": ["ermere"]
  },
  {
    "zipcode": "9290",
    "localities": ["RLARE"]
  },
  {
    "zipcode": "9300",
    "localities": ["LST"]
  },
  {
    "zipcode": "9308",
    "localities": ["jzegem"]
  },
  {
    "zipcode": "9308",
    "localities": ["fstade"]
  },
  {
    "zipcode": "9310",
    "localities": ["ardegem"]
  },
  {
    "zipcode": "9310",
    "localities": ["ldert"]
  },
  {
    "zipcode": "9310",
    "localities": ["orsel"]
  },
  {
    "zipcode": "9310",
    "localities": ["rdersem"]
  },
  {
    "zipcode": "9320",
    "localities": ["embodegem"]
  },
  {
    "zipcode": "9320",
    "localities": ["euwerkerken"]
  },
  {
    "zipcode": "9340",
    "localities": ["pe"]
  },
  {
    "zipcode": "9340",
    "localities": ["etlede"]
  },
  {
    "zipcode": "9340",
    "localities": ["rdegem"]
  },
  {
    "zipcode": "9340",
    "localities": ["nzele"]
  },
  {
    "zipcode": "9340",
    "localities": ["DE"]
  },
  {
    "zipcode": "9400",
    "localities": ["NOVE"]
  },
  {
    "zipcode": "9400",
    "localities": ["egem"]
  },
  {
    "zipcode": "9400",
    "localities": ["orde"]
  },
  {
    "zipcode": "9400",
    "localities": ["pelterre-Eichem"]
  },
  {
    "zipcode": "9400",
    "localities": ["derhasselt"]
  },
  {
    "zipcode": "9400",
    "localities": ["nderwindeke"]
  },
  {
    "zipcode": "9400",
    "localities": ["eferinge"]
  },
  {
    "zipcode": "9401",
    "localities": ["llare"]
  },
  {
    "zipcode": "9402",
    "localities": ["erbeke"]
  },
  {
    "zipcode": "9403",
    "localities": ["igem"]
  },
  {
    "zipcode": "9404",
    "localities": ["pelare"]
  },
  {
    "zipcode": "9406",
    "localities": ["ter"]
  },
  {
    "zipcode": "9420",
    "localities": ["mbrugge"]
  },
  {
    "zipcode": "9420",
    "localities": ["re"]
  },
  {
    "zipcode": "9420",
    "localities": ["ekkem"]
  },
  {
    "zipcode": "9420",
    "localities": ["ondegem"]
  },
  {
    "zipcode": "9420",
    "localities": ["PE-MERE"]
  },
  {
    "zipcode": "9420",
    "localities": ["tergem"]
  },
  {
    "zipcode": "9420",
    "localities": ["igem"]
  },
  {
    "zipcode": "9420",
    "localities": ["pe"]
  },
  {
    "zipcode": "9420",
    "localities": ["rst"]
  },
  {
    "zipcode": "9450",
    "localities": ["nderhoutem"]
  },
  {
    "zipcode": "9450",
    "localities": ["ALTERT"]
  },
  {
    "zipcode": "9450",
    "localities": ["ldergem"]
  },
  {
    "zipcode": "9451",
    "localities": ["rksken"]
  },
  {
    "zipcode": "9470",
    "localities": ["NDERLEEUW"]
  },
  {
    "zipcode": "9472",
    "localities": ["dergem"]
  },
  {
    "zipcode": "9473",
    "localities": ["lle"]
  },
  {
    "zipcode": "9500",
    "localities": ["erbeke"]
  },
  {
    "zipcode": "9500",
    "localities": ["erboelare"]
  },
  {
    "zipcode": "9500",
    "localities": ["derboelare"]
  },
  {
    "zipcode": "9500",
    "localities": ["hasselt"]
  },
  {
    "zipcode": "9500",
    "localities": ["ane"]
  },
  {
    "zipcode": "9500",
    "localities": ["kerzele"]
  },
  {
    "zipcode": "9500",
    "localities": ["rlardinge"]
  },
  {
    "zipcode": "9500",
    "localities": ["eferdinge"]
  },
  {
    "zipcode": "9500",
    "localities": ["RAARDSBERGEN"]
  },
  {
    "zipcode": "9506",
    "localities": ["arbeke"]
  },
  {
    "zipcode": "9506",
    "localities": ["eerebbe-Vloerzegem"]
  },
  {
    "zipcode": "9506",
    "localities": ["hendelbeke"]
  },
  {
    "zipcode": "9506",
    "localities": ["imminge"]
  },
  {
    "zipcode": "9506",
    "localities": ["ndbergen"]
  },
  {
    "zipcode": "9506",
    "localities": ["euwenhove"]
  },
  {
    "zipcode": "9506",
    "localities": ["egem"]
  },
  {
    "zipcode": "9520",
    "localities": ["nnegem"]
  },
  {
    "zipcode": "9520",
    "localities": ["mbergen"]
  },
  {
    "zipcode": "9520",
    "localities": ["vegem"]
  },
  {
    "zipcode": "9520",
    "localities": ["ierzele"]
  },
  {
    "zipcode": "9520",
    "localities": ["NT-LIEVENS-HOUTEM"]
  },
  {
    "zipcode": "9521",
    "localities": ["tterhoutem"]
  },
  {
    "zipcode": "9550",
    "localities": ["nt-Antelinks"]
  },
  {
    "zipcode": "9550",
    "localities": ["eenhuize-Wijnhuize"]
  },
  {
    "zipcode": "9550",
    "localities": ["llegem"]
  },
  {
    "zipcode": "9550",
    "localities": ["ubrechtegem"]
  },
  {
    "zipcode": "9550",
    "localities": ["RZELE"]
  },
  {
    "zipcode": "9550",
    "localities": ["nt-Lievens-Esse"]
  },
  {
    "zipcode": "9551",
    "localities": ["ssegem"]
  },
  {
    "zipcode": "9552",
    "localities": ["rsbeke"]
  },
  {
    "zipcode": "9570",
    "localities": ["ftinge"]
  },
  {
    "zipcode": "9570",
    "localities": ["ERDE"]
  },
  {
    "zipcode": "9570",
    "localities": ["nt-Maria-Lierde"]
  },
  {
    "zipcode": "9571",
    "localities": ["melveerdegem"]
  },
  {
    "zipcode": "9572",
    "localities": ["nt-Martens-Lierde"]
  },
  {
    "zipcode": "9600",
    "localities": ["NAIX"]
  },
  {
    "zipcode": "9620",
    "localities": ["dveerdegem"]
  },
  {
    "zipcode": "9620",
    "localities": ["nt-Maria-Oudenhove"]
  },
  {
    "zipcode": "9620",
    "localities": ["lzeke-Ruddershove"]
  },
  {
    "zipcode": "9620",
    "localities": ["ene"]
  },
  {
    "zipcode": "9620",
    "localities": ["TTEGEM"]
  },
  {
    "zipcode": "9620",
    "localities": ["mbergen"]
  },
  {
    "zipcode": "9620",
    "localities": ["otenberge"]
  },
  {
    "zipcode": "9620",
    "localities": ["rijpen"]
  },
  {
    "zipcode": "9620",
    "localities": ["nt-Goriks-Oudenhove"]
  },
  {
    "zipcode": "9620",
    "localities": ["euwergem"]
  },
  {
    "zipcode": "9620",
    "localities": ["wetegem"]
  },
  {
    "zipcode": "9630",
    "localities": ["ilegem"]
  },
  {
    "zipcode": "9630",
    "localities": ["ndelgem"]
  },
  {
    "zipcode": "9630",
    "localities": ["borst"]
  },
  {
    "zipcode": "9630",
    "localities": ["ulatem"]
  },
  {
    "zipcode": "9630",
    "localities": ["zebeke"]
  },
  {
    "zipcode": "9630",
    "localities": ["nt-Blasius-Boekel"]
  },
  {
    "zipcode": "9630",
    "localities": ["erlegem"]
  },
  {
    "zipcode": "9630",
    "localities": ["nkzwalm"]
  },
  {
    "zipcode": "9630",
    "localities": ["ALM"]
  },
  {
    "zipcode": "9630",
    "localities": ["kkele"]
  },
  {
    "zipcode": "9630",
    "localities": ["nt-Maria-Latem"]
  },
  {
    "zipcode": "9630",
    "localities": ["nt-Denijs-Boekel"]
  },
  {
    "zipcode": "9636",
    "localities": ["derzwalm-Hermelgem"]
  },
  {
    "zipcode": "9660",
    "localities": ["derbrakel"]
  },
  {
    "zipcode": "9660",
    "localities": ["st"]
  },
  {
    "zipcode": "9660",
    "localities": ["gelsem"]
  },
  {
    "zipcode": "9660",
    "localities": ["erbeek"]
  },
  {
    "zipcode": "9660",
    "localities": ["nt-Maria-Oudenhove"]
  },
  {
    "zipcode": "9660",
    "localities": ["AKEL"]
  },
  {
    "zipcode": "9660",
    "localities": ["chelbeke"]
  },
  {
    "zipcode": "9660",
    "localities": ["brakel"]
  },
  {
    "zipcode": "9661",
    "localities": ["rike"]
  },
  {
    "zipcode": "9667",
    "localities": ["REBEKE"]
  },
  {
    "zipcode": "9667",
    "localities": ["nt-Maria-Horebeke"]
  },
  {
    "zipcode": "9667",
    "localities": ["nt-Kornelis-Horebeke"]
  },
  {
    "zipcode": "9680",
    "localities": ["ARKEDAL"]
  },
  {
    "zipcode": "9680",
    "localities": ["arke-Kerkem"]
  },
  {
    "zipcode": "9680",
    "localities": ["ikhove"]
  },
  {
    "zipcode": "9681",
    "localities": ["kerke"]
  },
  {
    "zipcode": "9688",
    "localities": ["horisse"]
  },
  {
    "zipcode": "9690",
    "localities": ["aremont"]
  },
  {
    "zipcode": "9690",
    "localities": ["lzeke"]
  },
  {
    "zipcode": "9690",
    "localities": ["rchem"]
  },
  {
    "zipcode": "9690",
    "localities": ["ien"]
  },
  {
    "zipcode": "9690",
    "localities": ["UISBERGEN"]
  },
  {
    "zipcode": "9700",
    "localities": ["derename"]
  },
  {
    "zipcode": "9700",
    "localities": ["upegem"]
  },
  {
    "zipcode": "9700",
    "localities": ["ne"]
  },
  {
    "zipcode": "9700",
    "localities": ["vere"]
  },
  {
    "zipcode": "9700",
    "localities": ["llem"]
  },
  {
    "zipcode": "9700",
    "localities": ["DENAARDE"]
  },
  {
    "zipcode": "9700",
    "localities": ["urne"]
  },
  {
    "zipcode": "9700",
    "localities": ["ame"]
  },
  {
    "zipcode": "9700",
    "localities": ["lden"]
  },
  {
    "zipcode": "9700",
    "localities": ["ike"]
  },
  {
    "zipcode": "9700",
    "localities": ["elare"]
  },
  {
    "zipcode": "9700",
    "localities": ["lden"]
  },
  {
    "zipcode": "9700",
    "localities": ["ter"]
  },
  {
    "zipcode": "9700",
    "localities": ["lkegem"]
  },
  {
    "zipcode": "9750",
    "localities": ["ise"]
  },
  {
    "zipcode": "9750",
    "localities": ["ngem"]
  },
  {
    "zipcode": "9750",
    "localities": ["wegem"]
  },
  {
    "zipcode": "9770",
    "localities": ["uishoutem"]
  },
  {
    "zipcode": "9770",
    "localities": ["UISEM"]
  },
  {
    "zipcode": "9771",
    "localities": ["kere"]
  },
  {
    "zipcode": "9772",
    "localities": ["nnegem-Lede"]
  },
  {
    "zipcode": "9790",
    "localities": ["RTEGEM-PETEGEM"]
  },
  {
    "zipcode": "9790",
    "localities": ["ike"]
  },
  {
    "zipcode": "9790",
    "localities": ["segem"]
  },
  {
    "zipcode": "9790",
    "localities": ["tegem-Aan-De-Schelde"]
  },
  {
    "zipcode": "9790",
    "localities": ["regem"]
  },
  {
    "zipcode": "9790",
    "localities": ["rtegem"]
  },
  {
    "zipcode": "9800",
    "localities": ["tegem-Aan-De-Leie"]
  },
  {
    "zipcode": "9800",
    "localities": ["ntergem"]
  },
  {
    "zipcode": "9800",
    "localities": ["ttem"]
  },
  {
    "zipcode": "9800",
    "localities": ["nkt"]
  },
  {
    "zipcode": "9800",
    "localities": ["ammene"]
  },
  {
    "zipcode": "9800",
    "localities": ["igem"]
  },
  {
    "zipcode": "9800",
    "localities": ["INZE"]
  },
  {
    "zipcode": "9800",
    "localities": ["nt-Martens-Leerne"]
  },
  {
    "zipcode": "9800",
    "localities": ["tene"]
  },
  {
    "zipcode": "9800",
    "localities": ["chte-Maria-Leerne"]
  },
  {
    "zipcode": "9800",
    "localities": ["veren"]
  },
  {
    "zipcode": "9810",
    "localities": ["ZARETH"]
  },
  {
    "zipcode": "9810",
    "localities": ["e"]
  },
  {
    "zipcode": "9820",
    "localities": ["nte"]
  },
  {
    "zipcode": "9820",
    "localities": ["helderode"]
  },
  {
    "zipcode": "9820",
    "localities": ["ttelare"]
  },
  {
    "zipcode": "9820",
    "localities": ["lsen"]
  },
  {
    "zipcode": "9820",
    "localities": ["mberge"]
  },
  {
    "zipcode": "9820",
    "localities": ["RELBEKE"]
  },
  {
    "zipcode": "9830",
    "localities": ["NT-MARTENS-LATEM"]
  },
  {
    "zipcode": "9831",
    "localities": ["urle"]
  },
  {
    "zipcode": "9840",
    "localities": [" PINTE"]
  },
  {
    "zipcode": "9840",
    "localities": ["vergem"]
  },
  {
    "zipcode": "9850",
    "localities": ["sselare"]
  },
  {
    "zipcode": "9850",
    "localities": ["rendree"]
  },
  {
    "zipcode": "9850",
    "localities": ["esele"]
  },
  {
    "zipcode": "9850",
    "localities": ["vele"]
  },
  {
    "zipcode": "9850",
    "localities": ["nsbeke"]
  },
  {
    "zipcode": "9850",
    "localities": ["ndegem"]
  },
  {
    "zipcode": "9860",
    "localities": ["ortsele"]
  },
  {
    "zipcode": "9860",
    "localities": ["legem"]
  },
  {
    "zipcode": "9860",
    "localities": ["STERZELE"]
  },
  {
    "zipcode": "9860",
    "localities": ["heldewindeke"]
  },
  {
    "zipcode": "9860",
    "localities": ["jzenzele"]
  },
  {
    "zipcode": "9860",
    "localities": ["ndskouter"]
  },
  {
    "zipcode": "9870",
    "localities": ["sene"]
  },
  {
    "zipcode": "9870",
    "localities": ["LTE"]
  },
  {
    "zipcode": "9870",
    "localities": ["chelen"]
  },
  {
    "zipcode": "9880",
    "localities": ["eke"]
  },
  {
    "zipcode": "9880",
    "localities": ["LTER"]
  },
  {
    "zipcode": "9880",
    "localities": ["tenhulle"]
  },
  {
    "zipcode": "9881",
    "localities": ["llem"]
  },
  {
    "zipcode": "9890",
    "localities": ["per"]
  },
  {
    "zipcode": "9890",
    "localities": ["rste"]
  },
  {
    "zipcode": "9890",
    "localities": ["aigem"]
  },
  {
    "zipcode": "9890",
    "localities": ["VERE"]
  },
  {
    "zipcode": "9890",
    "localities": ["mmerzake"]
  },
  {
    "zipcode": "9890",
    "localities": ["kkelvenne"]
  },
  {
    "zipcode": "9900",
    "localities": ["KLO"]
  },
  {
    "zipcode": "9910",
    "localities": ["esselare"]
  },
  {
    "zipcode": "9910",
    "localities": ["sel"]
  },
  {
    "zipcode": "9920",
    "localities": ["vendegem"]
  },
  {
    "zipcode": "9921",
    "localities": ["nderhoute"]
  },
  {
    "zipcode": "9930",
    "localities": ["mergem"]
  },
  {
    "zipcode": "9930",
    "localities": ["EVEGEM"]
  },
  {
    "zipcode": "9931",
    "localities": ["stwinkel"]
  },
  {
    "zipcode": "9932",
    "localities": ["nsele"]
  },
  {
    "zipcode": "9940",
    "localities": ["tvelde"]
  },
  {
    "zipcode": "9940",
    "localities": ["uizen"]
  },
  {
    "zipcode": "9940",
    "localities": ["ERGEM"]
  },
  {
    "zipcode": "9940",
    "localities": ["eidinge"]
  },
  {
    "zipcode": "9950",
    "localities": ["arschoot"]
  },
  {
    "zipcode": "9960",
    "localities": ["SENEDE"]
  },
  {
    "zipcode": "9961",
    "localities": ["ekhoute"]
  },
  {
    "zipcode": "9968",
    "localities": ["ssevelde"]
  },
  {
    "zipcode": "9968",
    "localities": ["steeklo"]
  },
  {
    "zipcode": "9970",
    "localities": ["PRIJKE"]
  },
  {
    "zipcode": "9971",
    "localities": ["mbeke"]
  },
  {
    "zipcode": "9980",
    "localities": ["NT-LAUREINS"]
  },
  {
    "zipcode": "9981",
    "localities": ["nt-Margriete"]
  },
  {
    "zipcode": "9982",
    "localities": ["nt-Jan-In-Eremo"]
  },
  {
    "zipcode": "9988",
    "localities": ["tervliet"]
  },
  {
    "zipcode": "9988",
    "localities": ["terland-Oudeman"]
  },
  {
    "zipcode": "9990",
    "localities": ["LDEGEM"]
  },
  {
    "zipcode": "9991",
    "localities": ["egem"]
  },
  {
    "zipcode": "9992",
    "localities": ["ddelburg"]
  }
]
